(function() {
  if (typeof window != "object")
    return;
  if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
    "isIntersecting" in window.IntersectionObserverEntry.prototype || Object.defineProperty(
      window.IntersectionObserverEntry.prototype,
      "isIntersecting",
      {
        get: function() {
          return this.intersectionRatio > 0;
        }
      }
    );
    return;
  }
  function t(g) {
    try {
      return g.defaultView && g.defaultView.frameElement || null;
    } catch {
      return null;
    }
  }
  var e = function(g) {
    for (var v = g, $ = t(v); $; )
      v = $.ownerDocument, $ = t(v);
    return v;
  }(window.document), d = [], r = null, o = null;
  function l(g) {
    this.time = g.time, this.target = g.target, this.rootBounds = W(g.rootBounds), this.boundingClientRect = W(g.boundingClientRect), this.intersectionRect = W(g.intersectionRect || z()), this.isIntersecting = !!g.intersectionRect;
    var v = this.boundingClientRect, $ = v.width * v.height, s = this.intersectionRect, u = s.width * s.height;
    $ ? this.intersectionRatio = Number((u / $).toFixed(4)) : this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
  function h(g, v) {
    var $ = v || {};
    if (typeof g != "function")
      throw new Error("callback must be a function");
    if ($.root && $.root.nodeType != 1 && $.root.nodeType != 9)
      throw new Error("root must be a Document or Element");
    this._checkForIntersections = y(
      this._checkForIntersections.bind(this),
      this.THROTTLE_TIMEOUT
    ), this._callback = g, this._observationTargets = [], this._queuedEntries = [], this._rootMarginValues = this._parseRootMargin($.rootMargin), this.thresholds = this._initThresholds($.threshold), this.root = $.root || null, this.rootMargin = this._rootMarginValues.map(function(s) {
      return s.value + s.unit;
    }).join(" "), this._monitoringDocuments = [], this._monitoringUnsubscribes = [];
  }
  h.prototype.THROTTLE_TIMEOUT = 100, h.prototype.POLL_INTERVAL = null, h.prototype.USE_MUTATION_OBSERVER = !0, h._setupCrossOriginUpdater = function() {
    return r || (r = function(g, v) {
      !g || !v ? o = z() : o = Y(g, v), d.forEach(function($) {
        $._checkForIntersections();
      });
    }), r;
  }, h._resetCrossOriginUpdater = function() {
    r = null, o = null;
  }, h.prototype.observe = function(g) {
    var v = this._observationTargets.some(function($) {
      return $.element == g;
    });
    if (!v) {
      if (!(g && g.nodeType == 1))
        throw new Error("target must be an Element");
      this._registerInstance(), this._observationTargets.push({ element: g, entry: null }), this._monitorIntersections(g.ownerDocument), this._checkForIntersections();
    }
  }, h.prototype.unobserve = function(g) {
    this._observationTargets = this._observationTargets.filter(function(v) {
      return v.element != g;
    }), this._unmonitorIntersections(g.ownerDocument), this._observationTargets.length == 0 && this._unregisterInstance();
  }, h.prototype.disconnect = function() {
    this._observationTargets = [], this._unmonitorAllIntersections(), this._unregisterInstance();
  }, h.prototype.takeRecords = function() {
    var g = this._queuedEntries.slice();
    return this._queuedEntries = [], g;
  }, h.prototype._initThresholds = function(g) {
    var v = g || [0];
    return Array.isArray(v) || (v = [v]), v.sort().filter(function($, s, u) {
      if (typeof $ != "number" || isNaN($) || $ < 0 || $ > 1)
        throw new Error("threshold must be a number between 0 and 1 inclusively");
      return $ !== u[s - 1];
    });
  }, h.prototype._parseRootMargin = function(g) {
    var v = g || "0px", $ = v.split(/\s+/).map(function(s) {
      var u = /^(-?\d*\.?\d+)(px|%)$/.exec(s);
      if (!u)
        throw new Error("rootMargin must be specified in pixels or percent");
      return { value: parseFloat(u[1]), unit: u[2] };
    });
    return $[1] = $[1] || $[0], $[2] = $[2] || $[0], $[3] = $[3] || $[1], $;
  }, h.prototype._monitorIntersections = function(g) {
    var v = g.defaultView;
    if (v && this._monitoringDocuments.indexOf(g) == -1) {
      var $ = this._checkForIntersections, s = null, u = null;
      this.POLL_INTERVAL ? s = v.setInterval($, this.POLL_INTERVAL) : (R(v, "resize", $, !0), R(g, "scroll", $, !0), this.USE_MUTATION_OBSERVER && "MutationObserver" in v && (u = new v.MutationObserver($), u.observe(g, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      }))), this._monitoringDocuments.push(g), this._monitoringUnsubscribes.push(function() {
        var w = g.defaultView;
        w && (s && w.clearInterval(s), S(w, "resize", $, !0)), S(g, "scroll", $, !0), u && u.disconnect();
      });
      var m = this.root && (this.root.ownerDocument || this.root) || e;
      if (g != m) {
        var E = t(g);
        E && this._monitorIntersections(E.ownerDocument);
      }
    }
  }, h.prototype._unmonitorIntersections = function(g) {
    var v = this._monitoringDocuments.indexOf(g);
    if (v != -1) {
      var $ = this.root && (this.root.ownerDocument || this.root) || e, s = this._observationTargets.some(function(E) {
        var w = E.element.ownerDocument;
        if (w == g)
          return !0;
        for (; w && w != $; ) {
          var T = t(w);
          if (w = T && T.ownerDocument, w == g)
            return !0;
        }
        return !1;
      });
      if (!s) {
        var u = this._monitoringUnsubscribes[v];
        if (this._monitoringDocuments.splice(v, 1), this._monitoringUnsubscribes.splice(v, 1), u(), g != $) {
          var m = t(g);
          m && this._unmonitorIntersections(m.ownerDocument);
        }
      }
    }
  }, h.prototype._unmonitorAllIntersections = function() {
    var g = this._monitoringUnsubscribes.slice(0);
    this._monitoringDocuments.length = 0, this._monitoringUnsubscribes.length = 0;
    for (var v = 0; v < g.length; v++)
      g[v]();
  }, h.prototype._checkForIntersections = function() {
    if (!(!this.root && r && !o)) {
      var g = this._rootIsInDom(), v = g ? this._getRootRect() : z();
      this._observationTargets.forEach(function($) {
        var s = $.element, u = C(s), m = this._rootContainsTarget(s), E = $.entry, w = g && m && this._computeTargetAndRootIntersection(s, u, v), T = null;
        this._rootContainsTarget(s) ? (!r || this.root) && (T = v) : T = z();
        var H = $.entry = new l({
          time: f(),
          target: s,
          boundingClientRect: u,
          rootBounds: T,
          intersectionRect: w
        });
        E ? g && m ? this._hasCrossedThreshold(E, H) && this._queuedEntries.push(H) : E && E.isIntersecting && this._queuedEntries.push(H) : this._queuedEntries.push(H);
      }, this), this._queuedEntries.length && this._callback(this.takeRecords(), this);
    }
  }, h.prototype._computeTargetAndRootIntersection = function(g, v, $) {
    if (window.getComputedStyle(g).display != "none") {
      for (var s = v, u = F(g), m = !1; !m && u; ) {
        var E = null, w = u.nodeType == 1 ? window.getComputedStyle(u) : {};
        if (w.display == "none")
          return null;
        if (u == this.root || u.nodeType == /* DOCUMENT */
        9)
          if (m = !0, u == this.root || u == e)
            r && !this.root ? !o || o.width == 0 && o.height == 0 ? (u = null, E = null, s = null) : E = o : E = $;
          else {
            var T = F(u), H = T && C(T), V = T && this._computeTargetAndRootIntersection(T, H, $);
            H && V ? (u = T, E = Y(H, V)) : (u = null, s = null);
          }
        else {
          var X = u.ownerDocument;
          u != X.body && u != X.documentElement && w.overflow != "visible" && (E = C(u));
        }
        if (E && (s = N(E, s)), !s)
          break;
        u = u && F(u);
      }
      return s;
    }
  }, h.prototype._getRootRect = function() {
    var g;
    if (this.root && !Z(this.root))
      g = C(this.root);
    else {
      var v = Z(this.root) ? this.root : e, $ = v.documentElement, s = v.body;
      g = {
        top: 0,
        left: 0,
        right: $.clientWidth || s.clientWidth,
        width: $.clientWidth || s.clientWidth,
        bottom: $.clientHeight || s.clientHeight,
        height: $.clientHeight || s.clientHeight
      };
    }
    return this._expandRectByRootMargin(g);
  }, h.prototype._expandRectByRootMargin = function(g) {
    var v = this._rootMarginValues.map(function(s, u) {
      return s.unit == "px" ? s.value : s.value * (u % 2 ? g.width : g.height) / 100;
    }), $ = {
      top: g.top - v[0],
      right: g.right + v[1],
      bottom: g.bottom + v[2],
      left: g.left - v[3]
    };
    return $.width = $.right - $.left, $.height = $.bottom - $.top, $;
  }, h.prototype._hasCrossedThreshold = function(g, v) {
    var $ = g && g.isIntersecting ? g.intersectionRatio || 0 : -1, s = v.isIntersecting ? v.intersectionRatio || 0 : -1;
    if ($ !== s)
      for (var u = 0; u < this.thresholds.length; u++) {
        var m = this.thresholds[u];
        if (m == $ || m == s || m < $ != m < s)
          return !0;
      }
  }, h.prototype._rootIsInDom = function() {
    return !this.root || P(e, this.root);
  }, h.prototype._rootContainsTarget = function(g) {
    var v = this.root && (this.root.ownerDocument || this.root) || e;
    return P(v, g) && (!this.root || v == g.ownerDocument);
  }, h.prototype._registerInstance = function() {
    d.indexOf(this) < 0 && d.push(this);
  }, h.prototype._unregisterInstance = function() {
    var g = d.indexOf(this);
    g != -1 && d.splice(g, 1);
  };
  function f() {
    return window.performance && performance.now && performance.now();
  }
  function y(g, v) {
    var $ = null;
    return function() {
      $ || ($ = setTimeout(function() {
        g(), $ = null;
      }, v));
    };
  }
  function R(g, v, $, s) {
    typeof g.addEventListener == "function" ? g.addEventListener(v, $, s || !1) : typeof g.attachEvent == "function" && g.attachEvent("on" + v, $);
  }
  function S(g, v, $, s) {
    typeof g.removeEventListener == "function" ? g.removeEventListener(v, $, s || !1) : typeof g.detachEvent == "function" && g.detachEvent("on" + v, $);
  }
  function N(g, v) {
    var $ = Math.max(g.top, v.top), s = Math.min(g.bottom, v.bottom), u = Math.max(g.left, v.left), m = Math.min(g.right, v.right), E = m - u, w = s - $;
    return E >= 0 && w >= 0 && {
      top: $,
      bottom: s,
      left: u,
      right: m,
      width: E,
      height: w
    } || null;
  }
  function C(g) {
    var v;
    try {
      v = g.getBoundingClientRect();
    } catch {
    }
    return v ? (v.width && v.height || (v = {
      top: v.top,
      right: v.right,
      bottom: v.bottom,
      left: v.left,
      width: v.right - v.left,
      height: v.bottom - v.top
    }), v) : z();
  }
  function z() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }
  function W(g) {
    return !g || "x" in g ? g : {
      top: g.top,
      y: g.top,
      bottom: g.bottom,
      left: g.left,
      x: g.left,
      right: g.right,
      width: g.width,
      height: g.height
    };
  }
  function Y(g, v) {
    var $ = v.top - g.top, s = v.left - g.left;
    return {
      top: $,
      left: s,
      height: v.height,
      width: v.width,
      bottom: $ + v.height,
      right: s + v.width
    };
  }
  function P(g, v) {
    for (var $ = v; $; ) {
      if ($ == g)
        return !0;
      $ = F($);
    }
    return !1;
  }
  function F(g) {
    var v = g.parentNode;
    return g.nodeType == /* DOCUMENT */
    9 && g != e ? t(g) : (v && v.assignedSlot && (v = v.assignedSlot.parentNode), v && v.nodeType == 11 && v.host ? v.host : v);
  }
  function Z(g) {
    return g && g.nodeType === 9;
  }
  window.IntersectionObserver = h, window.IntersectionObserverEntry = l;
})();
function getDefaultExportFromCjs(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var isEmail$1 = { exports: {} }, assertString = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function d(o) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? d = function(h) {
      return typeof h;
    } : d = function(h) {
      return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
    }, d(o);
  }
  function r(o) {
    var l = typeof o == "string" || o instanceof String;
    if (!l) {
      var h;
      throw o === null ? h = "null" : (h = d(o), h === "object" && o.constructor && o.constructor.hasOwnProperty("name") ? h = o.constructor.name : h = "a ".concat(h)), new TypeError("Expected string but received ".concat(h, "."));
    }
  }
  t.exports = e.default, t.exports.default = e.default;
})(assertString, assertString.exports);
var assertStringExports = assertString.exports, merge = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = d;
  function d() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 ? arguments[1] : void 0;
    for (var l in o)
      typeof r[l] > "u" && (r[l] = o[l]);
    return r;
  }
  t.exports = e.default, t.exports.default = e.default;
})(merge, merge.exports);
var mergeExports = merge.exports, isByteLength = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var d = r(assertStringExports);
  function r(h) {
    return h && h.__esModule ? h : { default: h };
  }
  function o(h) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? o = function(y) {
      return typeof y;
    } : o = function(y) {
      return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
    }, o(h);
  }
  function l(h, f) {
    (0, d.default)(h);
    var y, R;
    o(f) === "object" ? (y = f.min || 0, R = f.max) : (y = arguments[1], R = arguments[2]);
    var S = encodeURI(h).split(/%..|./).length - 1;
    return S >= y && (typeof R > "u" || S <= R);
  }
  t.exports = e.default, t.exports.default = e.default;
})(isByteLength, isByteLength.exports);
var isByteLengthExports = isByteLength.exports, isFQDN = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = h;
  var d = o(assertStringExports), r = o(mergeExports);
  function o(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var l = {
    require_tld: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1
  };
  function h(f, y) {
    (0, d.default)(f), y = (0, r.default)(y, l), y.allow_trailing_dot && f[f.length - 1] === "." && (f = f.substring(0, f.length - 1));
    for (var R = f.split("."), S = 0; S < R.length; S++)
      if (R[S].length > 63)
        return !1;
    if (y.require_tld) {
      var N = R.pop();
      if (!R.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(N) || /[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20\u00A9\uFFFD]/.test(N))
        return !1;
    }
    for (var C, z = 0; z < R.length; z++)
      if (C = R[z], y.allow_underscores && (C = C.replace(/_/g, "")), !/^[a-z\u00a1-\uffff0-9-]+$/i.test(C) || /[\uff01-\uff5e]/.test(C) || C[0] === "-" || C[C.length - 1] === "-")
        return !1;
    return !0;
  }
  t.exports = e.default, t.exports.default = e.default;
})(isFQDN, isFQDN.exports);
var isFQDNExports = isFQDN.exports, isIP = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = h;
  var d = r(assertStringExports);
  function r(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var o = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/, l = /^[0-9A-F]{1,4}$/i;
  function h(f) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if ((0, d.default)(f), y = String(y), y) {
      if (y === "4") {
        if (!o.test(f))
          return !1;
        var R = f.split(".").sort(function(P, F) {
          return P - F;
        });
        return R[3] <= 255;
      } else if (y === "6") {
        var S = [f];
        if (f.includes("%") && (S = f.split("%"), S.length !== 2 || !S[0].includes(":") || S[1] === ""))
          return !1;
        var N = S[0].split(":"), C = !1, z = h(N[N.length - 1], 4), W = z ? 7 : 8;
        if (N.length > W)
          return !1;
        if (f === "::")
          return !0;
        f.substr(0, 2) === "::" ? (N.shift(), N.shift(), C = !0) : f.substr(f.length - 2) === "::" && (N.pop(), N.pop(), C = !0);
        for (var Y = 0; Y < N.length; ++Y)
          if (N[Y] === "" && Y > 0 && Y < N.length - 1) {
            if (C)
              return !1;
            C = !0;
          } else if (!(z && Y === N.length - 1)) {
            if (!l.test(N[Y]))
              return !1;
          }
        return C ? N.length >= 1 : N.length === W;
      }
    } else
      return h(f, 4) || h(f, 6);
    return !1;
  }
  t.exports = e.default, t.exports.default = e.default;
})(isIP, isIP.exports);
var isIPExports = isIP.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = u;
  var d = f(assertStringExports), r = f(mergeExports), o = f(isByteLengthExports), l = f(isFQDNExports), h = f(isIPExports);
  function f(m) {
    return m && m.__esModule ? m : { default: m };
  }
  function y(m, E) {
    return z(m) || C(m, E) || S(m, E) || R();
  }
  function R() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function S(m, E) {
    if (m) {
      if (typeof m == "string")
        return N(m, E);
      var w = Object.prototype.toString.call(m).slice(8, -1);
      if (w === "Object" && m.constructor && (w = m.constructor.name), w === "Map" || w === "Set")
        return Array.from(m);
      if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w))
        return N(m, E);
    }
  }
  function N(m, E) {
    (E == null || E > m.length) && (E = m.length);
    for (var w = 0, T = new Array(E); w < E; w++)
      T[w] = m[w];
    return T;
  }
  function C(m, E) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(m)))) {
      var w = [], T = !0, H = !1, V = void 0;
      try {
        for (var X = m[Symbol.iterator](), G; !(T = (G = X.next()).done) && (w.push(G.value), !(E && w.length === E)); T = !0)
          ;
      } catch (ue) {
        H = !0, V = ue;
      } finally {
        try {
          !T && X.return != null && X.return();
        } finally {
          if (H)
            throw V;
        }
      }
      return w;
    }
  }
  function z(m) {
    if (Array.isArray(m))
      return m;
  }
  var W = {
    allow_display_name: !1,
    require_display_name: !1,
    allow_utf8_local_part: !0,
    require_tld: !0
  }, Y = /^([^\x00-\x1F\x7F-\x9F\cX]+)<(.+)>$/i, P = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, F = /^[a-z\d]+$/, Z = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, g = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, v = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, $ = 254;
  function s(m) {
    var E = m.match(/^"(.+)"$/i), w = E ? E[1] : m;
    if (!w.trim())
      return !1;
    var T = /[\.";<>]/.test(w);
    if (T) {
      if (!E)
        return !1;
      var H = w.split('"').length === w.split('\\"').length;
      if (!H)
        return !1;
    }
    return !0;
  }
  function u(m, E) {
    if ((0, d.default)(m), E = (0, r.default)(E, W), E.require_display_name || E.allow_display_name) {
      var w = m.match(Y);
      if (w) {
        var T, H = y(w, 3);
        if (T = H[1], m = H[2], T.endsWith(" ") && (T = T.substr(0, T.length - 1)), !s(T))
          return !1;
      } else if (E.require_display_name)
        return !1;
    }
    if (!E.ignore_max_length && m.length > $)
      return !1;
    var V = m.split("@"), X = V.pop(), G = V.join("@"), ue = X.toLowerCase();
    if (E.domain_specific_validation && (ue === "gmail.com" || ue === "googlemail.com")) {
      G = G.toLowerCase();
      var b = G.split("+")[0];
      if (!(0, o.default)(b.replace(".", ""), {
        min: 6,
        max: 30
      }))
        return !1;
      for (var U = b.split("."), K = 0; K < U.length; K++)
        if (!F.test(U[K]))
          return !1;
    }
    if (!(0, o.default)(G, {
      max: 64
    }) || !(0, o.default)(X, {
      max: 254
    }))
      return !1;
    if (!(0, l.default)(X, {
      require_tld: E.require_tld
    })) {
      if (!E.allow_ip_domain)
        return !1;
      if (!(0, h.default)(X)) {
        if (!X.startsWith("[") || !X.endsWith("]"))
          return !1;
        var re = X.substr(1, X.length - 2);
        if (re.length === 0 || !(0, h.default)(re))
          return !1;
      }
    }
    if (G[0] === '"')
      return G = G.slice(1, G.length - 1), E.allow_utf8_local_part ? v.test(G) : Z.test(G);
    for (var oe = E.allow_utf8_local_part ? g : P, ie = G.split("."), le = 0; le < ie.length; le++)
      if (!oe.test(ie[le]))
        return !1;
    return !0;
  }
  t.exports = e.default, t.exports.default = e.default;
})(isEmail$1, isEmail$1.exports);
var isEmailExports = isEmail$1.exports;
const isEmail = /* @__PURE__ */ getDefaultExportFromCjs(isEmailExports);
var isNumeric$1 = { exports: {} }, alpha$1 = {};
Object.defineProperty(alpha$1, "__esModule", {
  value: !0
});
alpha$1.commaDecimal = alpha$1.dotDecimal = alpha$1.arabicLocales = alpha$1.englishLocales = alpha$1.decimal = alpha$1.alphanumeric = alpha$1.alpha = void 0;
var alpha = {
  "en-US": /^[A-Z]+$/i,
  "bg-BG": /^[А-Я]+$/i,
  "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[A-ZÆØÅ]+$/i,
  "de-DE": /^[A-ZÄÖÜß]+$/i,
  "el-GR": /^[Α-ώ]+$/i,
  "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "nb-NO": /^[A-ZÆØÅ]+$/i,
  "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[A-ZÆØÅ]+$/i,
  "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[А-ЯЁ]+$/i,
  "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[A-ZÅÄÖ]+$/i,
  "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
  "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[א-ת]+$/,
  "fa-IR": /^['آابپتثجچهخدذرزژسشصضطظعغفقکگلمنوهی']+$/i
};
alpha$1.alpha = alpha;
var alphanumeric = {
  "en-US": /^[0-9A-Z]+$/i,
  "bg-BG": /^[0-9А-Я]+$/i,
  "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[0-9A-ZÆØÅ]+$/i,
  "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
  "el-GR": /^[0-9Α-ω]+$/i,
  "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
  "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
  "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[0-9А-ЯЁ]+$/i,
  "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
  "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
  "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[0-9א-ת]+$/,
  "fa-IR": /^['0-9آابپتثجچهخدذرزژسشصضطظعغفقکگلمنوهی۱۲۳۴۵۶۷۸۹۰']+$/i
};
alpha$1.alphanumeric = alphanumeric;
var decimal = {
  "en-US": ".",
  ar: "٫"
};
alpha$1.decimal = decimal;
var englishLocales = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"];
alpha$1.englishLocales = englishLocales;
for (var locale, i = 0; i < englishLocales.length; i++)
  locale = "en-".concat(englishLocales[i]), alpha[locale] = alpha["en-US"], alphanumeric[locale] = alphanumeric["en-US"], decimal[locale] = decimal["en-US"];
var arabicLocales = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"];
alpha$1.arabicLocales = arabicLocales;
for (var _locale, _i = 0; _i < arabicLocales.length; _i++)
  _locale = "ar-".concat(arabicLocales[_i]), alpha[_locale] = alpha.ar, alphanumeric[_locale] = alphanumeric.ar, decimal[_locale] = decimal.ar;
var dotDecimal = ["ar-EG", "ar-LB", "ar-LY"];
alpha$1.dotDecimal = dotDecimal;
var commaDecimal = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "es-ES", "fr-FR", "it-IT", "ku-IQ", "hu-HU", "nb-NO", "nn-NO", "nl-NL", "pl-PL", "pt-PT", "ru-RU", "sl-SI", "sr-RS@latin", "sr-RS", "sv-SE", "tr-TR", "uk-UA"];
alpha$1.commaDecimal = commaDecimal;
for (var _i2 = 0; _i2 < dotDecimal.length; _i2++)
  decimal[dotDecimal[_i2]] = decimal["en-US"];
for (var _i3 = 0; _i3 < commaDecimal.length; _i3++)
  decimal[commaDecimal[_i3]] = ",";
alpha["pt-BR"] = alpha["pt-PT"];
alphanumeric["pt-BR"] = alphanumeric["pt-PT"];
decimal["pt-BR"] = decimal["pt-PT"];
alpha["pl-Pl"] = alpha["pl-PL"];
alphanumeric["pl-Pl"] = alphanumeric["pl-PL"];
decimal["pl-Pl"] = decimal["pl-PL"];
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = h;
  var d = o(assertStringExports), r = alpha$1;
  function o(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var l = /^[0-9]+$/;
  function h(f, y) {
    return (0, d.default)(f), y && y.no_symbols ? l.test(f) : new RegExp("^[+-]?([0-9]*[".concat((y || {}).locale ? r.decimal[y.locale] : ".", "])?[0-9]+$")).test(f);
  }
  t.exports = e.default, t.exports.default = e.default;
})(isNumeric$1, isNumeric$1.exports);
var isNumericExports = isNumeric$1.exports;
const isNumeric = /* @__PURE__ */ getDefaultExportFromCjs(isNumericExports);
var isURL$1 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = N;
  var d = h(assertStringExports), r = h(isFQDNExports), o = h(isIPExports), l = h(mergeExports);
  function h(C) {
    return C && C.__esModule ? C : { default: C };
  }
  var f = {
    protocols: ["http", "https", "ftp"],
    require_tld: !0,
    require_protocol: !1,
    require_host: !0,
    require_valid_protocol: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1,
    allow_protocol_relative_urls: !1
  }, y = /^\[([^\]]+)\](?::([0-9]+))?$/;
  function R(C) {
    return Object.prototype.toString.call(C) === "[object RegExp]";
  }
  function S(C, z) {
    for (var W = 0; W < z.length; W++) {
      var Y = z[W];
      if (C === Y || R(Y) && Y.test(C))
        return !0;
    }
    return !1;
  }
  function N(C, z) {
    if ((0, d.default)(C), !C || C.length >= 2083 || /[\s<>]/.test(C) || C.indexOf("mailto:") === 0)
      return !1;
    z = (0, l.default)(z, f);
    var W, Y, P, F, Z, g, v, $;
    if (v = C.split("#"), C = v.shift(), v = C.split("?"), C = v.shift(), v = C.split("://"), v.length > 1) {
      if (W = v.shift().toLowerCase(), z.require_valid_protocol && z.protocols.indexOf(W) === -1)
        return !1;
    } else {
      if (z.require_protocol)
        return !1;
      if (C.substr(0, 2) === "//") {
        if (!z.allow_protocol_relative_urls)
          return !1;
        v[0] = C.substr(2);
      }
    }
    if (C = v.join("://"), C === "")
      return !1;
    if (v = C.split("/"), C = v.shift(), C === "" && !z.require_host)
      return !0;
    if (v = C.split("@"), v.length > 1 && (z.disallow_auth || (Y = v.shift(), Y.indexOf(":") >= 0 && Y.split(":").length > 2)))
      return !1;
    F = v.join("@"), g = null, $ = null;
    var s = F.match(y);
    return s ? (P = "", $ = s[1], g = s[2] || null) : (v = F.split(":"), P = v.shift(), v.length && (g = v.join(":"))), !(g !== null && (Z = parseInt(g, 10), !/^[0-9]+$/.test(g) || Z <= 0 || Z > 65535) || !(0, o.default)(P) && !(0, r.default)(P, z) && (!$ || !(0, o.default)($, 6)) || (P = P || $, z.host_whitelist && !S(P, z.host_whitelist)) || z.host_blacklist && S(P, z.host_blacklist));
  }
  t.exports = e.default, t.exports.default = e.default;
})(isURL$1, isURL$1.exports);
var isURLExports = isURL$1.exports;
const isURL = /* @__PURE__ */ getDefaultExportFromCjs(isURLExports);
var isFloat$1 = {};
Object.defineProperty(isFloat$1, "__esModule", {
  value: !0
});
var _default = isFloat$1.default = isFloat;
isFloat$1.locales = void 0;
var _assertString = _interopRequireDefault(assertStringExports), _alpha = alpha$1;
function _interopRequireDefault(t) {
  return t && t.__esModule ? t : { default: t };
}
function isFloat(t, e) {
  (0, _assertString.default)(t), e = e || {};
  var d = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(e.locale ? _alpha.decimal[e.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
  if (t === "" || t === "." || t === "-" || t === "+")
    return !1;
  var r = parseFloat(t.replace(",", "."));
  return d.test(t) && (!e.hasOwnProperty("min") || r >= e.min) && (!e.hasOwnProperty("max") || r <= e.max) && (!e.hasOwnProperty("lt") || r < e.lt) && (!e.hasOwnProperty("gt") || r > e.gt);
}
var locales = Object.keys(_alpha.decimal);
isFloat$1.locales = locales;
var intlTelInput$3 = { exports: {} };
(function(t) {
  (function(e) {
    t.exports ? t.exports = e() : window.intlTelInput = e();
  })(function(e) {
    return function() {
      for (var d = [["Afghanistan (‫افغانستان‬‎)", "af", "93"], ["Albania (Shqipëri)", "al", "355"], ["Algeria (‫الجزائر‬‎)", "dz", "213"], ["American Samoa", "as", "1", 5, ["684"]], ["Andorra", "ad", "376"], ["Angola", "ao", "244"], ["Anguilla", "ai", "1", 6, ["264"]], ["Antigua and Barbuda", "ag", "1", 7, ["268"]], ["Argentina", "ar", "54"], ["Armenia (Հայաստան)", "am", "374"], ["Aruba", "aw", "297"], ["Ascension Island", "ac", "247"], ["Australia", "au", "61", 0], ["Austria (Österreich)", "at", "43"], ["Azerbaijan (Azərbaycan)", "az", "994"], ["Bahamas", "bs", "1", 8, ["242"]], ["Bahrain (‫البحرين‬‎)", "bh", "973"], ["Bangladesh (বাংলাদেশ)", "bd", "880"], ["Barbados", "bb", "1", 9, ["246"]], ["Belarus (Беларусь)", "by", "375"], ["Belgium (België)", "be", "32"], ["Belize", "bz", "501"], ["Benin (Bénin)", "bj", "229"], ["Bermuda", "bm", "1", 10, ["441"]], ["Bhutan (འབྲུག)", "bt", "975"], ["Bolivia", "bo", "591"], ["Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387"], ["Botswana", "bw", "267"], ["Brazil (Brasil)", "br", "55"], ["British Indian Ocean Territory", "io", "246"], ["British Virgin Islands", "vg", "1", 11, ["284"]], ["Brunei", "bn", "673"], ["Bulgaria (България)", "bg", "359"], ["Burkina Faso", "bf", "226"], ["Burundi (Uburundi)", "bi", "257"], ["Cambodia (កម្ពុជា)", "kh", "855"], ["Cameroon (Cameroun)", "cm", "237"], ["Canada", "ca", "1", 1, ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde (Kabu Verdi)", "cv", "238"], ["Caribbean Netherlands", "bq", "599", 1, ["3", "4", "7"]], ["Cayman Islands", "ky", "1", 12, ["345"]], ["Central African Republic (République centrafricaine)", "cf", "236"], ["Chad (Tchad)", "td", "235"], ["Chile", "cl", "56"], ["China (中国)", "cn", "86"], ["Christmas Island", "cx", "61", 2, ["89164"]], ["Cocos (Keeling) Islands", "cc", "61", 1, ["89162"]], ["Colombia", "co", "57"], ["Comoros (‫جزر القمر‬‎)", "km", "269"], ["Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243"], ["Congo (Republic) (Congo-Brazzaville)", "cg", "242"], ["Cook Islands", "ck", "682"], ["Costa Rica", "cr", "506"], ["Côte d’Ivoire", "ci", "225"], ["Croatia (Hrvatska)", "hr", "385"], ["Cuba", "cu", "53"], ["Curaçao", "cw", "599", 0], ["Cyprus (Κύπρος)", "cy", "357"], ["Czech Republic (Česká republika)", "cz", "420"], ["Denmark (Danmark)", "dk", "45"], ["Djibouti", "dj", "253"], ["Dominica", "dm", "1", 13, ["767"]], ["Dominican Republic (República Dominicana)", "do", "1", 2, ["809", "829", "849"]], ["Ecuador", "ec", "593"], ["Egypt (‫مصر‬‎)", "eg", "20"], ["El Salvador", "sv", "503"], ["Equatorial Guinea (Guinea Ecuatorial)", "gq", "240"], ["Eritrea", "er", "291"], ["Estonia (Eesti)", "ee", "372"], ["Eswatini", "sz", "268"], ["Ethiopia", "et", "251"], ["Falkland Islands (Islas Malvinas)", "fk", "500"], ["Faroe Islands (Føroyar)", "fo", "298"], ["Fiji", "fj", "679"], ["Finland (Suomi)", "fi", "358", 0], ["France", "fr", "33"], ["French Guiana (Guyane française)", "gf", "594"], ["French Polynesia (Polynésie française)", "pf", "689"], ["Gabon", "ga", "241"], ["Gambia", "gm", "220"], ["Georgia (საქართველო)", "ge", "995"], ["Germany (Deutschland)", "de", "49"], ["Ghana (Gaana)", "gh", "233"], ["Gibraltar", "gi", "350"], ["Greece (Ελλάδα)", "gr", "30"], ["Greenland (Kalaallit Nunaat)", "gl", "299"], ["Grenada", "gd", "1", 14, ["473"]], ["Guadeloupe", "gp", "590", 0], ["Guam", "gu", "1", 15, ["671"]], ["Guatemala", "gt", "502"], ["Guernsey", "gg", "44", 1, ["1481", "7781", "7839", "7911"]], ["Guinea (Guinée)", "gn", "224"], ["Guinea-Bissau (Guiné Bissau)", "gw", "245"], ["Guyana", "gy", "592"], ["Haiti", "ht", "509"], ["Honduras", "hn", "504"], ["Hong Kong (香港)", "hk", "852"], ["Hungary (Magyarország)", "hu", "36"], ["Iceland (Ísland)", "is", "354"], ["India (भारत)", "in", "91"], ["Indonesia", "id", "62"], ["Iran (‫ایران‬‎)", "ir", "98"], ["Iraq (‫العراق‬‎)", "iq", "964"], ["Ireland", "ie", "353"], ["Isle of Man", "im", "44", 2, ["1624", "74576", "7524", "7924", "7624"]], ["Israel (‫ישראל‬‎)", "il", "972"], ["Italy (Italia)", "it", "39", 0], ["Jamaica", "jm", "1", 4, ["876", "658"]], ["Japan (日本)", "jp", "81"], ["Jersey", "je", "44", 3, ["1534", "7509", "7700", "7797", "7829", "7937"]], ["Jordan (‫الأردن‬‎)", "jo", "962"], ["Kazakhstan (Казахстан)", "kz", "7", 1, ["33", "7"]], ["Kenya", "ke", "254"], ["Kiribati", "ki", "686"], ["Kosovo", "xk", "383"], ["Kuwait (‫الكويت‬‎)", "kw", "965"], ["Kyrgyzstan (Кыргызстан)", "kg", "996"], ["Laos (ລາວ)", "la", "856"], ["Latvia (Latvija)", "lv", "371"], ["Lebanon (‫لبنان‬‎)", "lb", "961"], ["Lesotho", "ls", "266"], ["Liberia", "lr", "231"], ["Libya (‫ليبيا‬‎)", "ly", "218"], ["Liechtenstein", "li", "423"], ["Lithuania (Lietuva)", "lt", "370"], ["Luxembourg", "lu", "352"], ["Macau (澳門)", "mo", "853"], ["Madagascar (Madagasikara)", "mg", "261"], ["Malawi", "mw", "265"], ["Malaysia", "my", "60"], ["Maldives", "mv", "960"], ["Mali", "ml", "223"], ["Malta", "mt", "356"], ["Marshall Islands", "mh", "692"], ["Martinique", "mq", "596"], ["Mauritania (‫موريتانيا‬‎)", "mr", "222"], ["Mauritius (Moris)", "mu", "230"], ["Mayotte", "yt", "262", 1, ["269", "639"]], ["Mexico (México)", "mx", "52"], ["Micronesia", "fm", "691"], ["Moldova (Republica Moldova)", "md", "373"], ["Monaco", "mc", "377"], ["Mongolia (Монгол)", "mn", "976"], ["Montenegro (Crna Gora)", "me", "382"], ["Montserrat", "ms", "1", 16, ["664"]], ["Morocco (‫المغرب‬‎)", "ma", "212", 0], ["Mozambique (Moçambique)", "mz", "258"], ["Myanmar (Burma) (မြန်မာ)", "mm", "95"], ["Namibia (Namibië)", "na", "264"], ["Nauru", "nr", "674"], ["Nepal (नेपाल)", "np", "977"], ["Netherlands (Nederland)", "nl", "31"], ["New Caledonia (Nouvelle-Calédonie)", "nc", "687"], ["New Zealand", "nz", "64"], ["Nicaragua", "ni", "505"], ["Niger (Nijar)", "ne", "227"], ["Nigeria", "ng", "234"], ["Niue", "nu", "683"], ["Norfolk Island", "nf", "672"], ["North Korea (조선 민주주의 인민 공화국)", "kp", "850"], ["North Macedonia (Северна Македонија)", "mk", "389"], ["Northern Mariana Islands", "mp", "1", 17, ["670"]], ["Norway (Norge)", "no", "47", 0], ["Oman (‫عُمان‬‎)", "om", "968"], ["Pakistan (‫پاکستان‬‎)", "pk", "92"], ["Palau", "pw", "680"], ["Palestine (‫فلسطين‬‎)", "ps", "970"], ["Panama (Panamá)", "pa", "507"], ["Papua New Guinea", "pg", "675"], ["Paraguay", "py", "595"], ["Peru (Perú)", "pe", "51"], ["Philippines", "ph", "63"], ["Poland (Polska)", "pl", "48"], ["Portugal", "pt", "351"], ["Puerto Rico", "pr", "1", 3, ["787", "939"]], ["Qatar (‫قطر‬‎)", "qa", "974"], ["Réunion (La Réunion)", "re", "262", 0], ["Romania (România)", "ro", "40"], ["Russia (Россия)", "ru", "7", 0], ["Rwanda", "rw", "250"], ["Saint Barthélemy", "bl", "590", 1], ["Saint Helena", "sh", "290"], ["Saint Kitts and Nevis", "kn", "1", 18, ["869"]], ["Saint Lucia", "lc", "1", 19, ["758"]], ["Saint Martin (Saint-Martin (partie française))", "mf", "590", 2], ["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508"], ["Saint Vincent and the Grenadines", "vc", "1", 20, ["784"]], ["Samoa", "ws", "685"], ["San Marino", "sm", "378"], ["São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239"], ["Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966"], ["Senegal (Sénégal)", "sn", "221"], ["Serbia (Србија)", "rs", "381"], ["Seychelles", "sc", "248"], ["Sierra Leone", "sl", "232"], ["Singapore", "sg", "65"], ["Sint Maarten", "sx", "1", 21, ["721"]], ["Slovakia (Slovensko)", "sk", "421"], ["Slovenia (Slovenija)", "si", "386"], ["Solomon Islands", "sb", "677"], ["Somalia (Soomaaliya)", "so", "252"], ["South Africa", "za", "27"], ["South Korea (대한민국)", "kr", "82"], ["South Sudan (‫جنوب السودان‬‎)", "ss", "211"], ["Spain (España)", "es", "34"], ["Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94"], ["Sudan (‫السودان‬‎)", "sd", "249"], ["Suriname", "sr", "597"], ["Svalbard and Jan Mayen", "sj", "47", 1, ["79"]], ["Sweden (Sverige)", "se", "46"], ["Switzerland (Schweiz)", "ch", "41"], ["Syria (‫سوريا‬‎)", "sy", "963"], ["Taiwan (台灣)", "tw", "886"], ["Tajikistan", "tj", "992"], ["Tanzania", "tz", "255"], ["Thailand (ไทย)", "th", "66"], ["Timor-Leste", "tl", "670"], ["Togo", "tg", "228"], ["Tokelau", "tk", "690"], ["Tonga", "to", "676"], ["Trinidad and Tobago", "tt", "1", 22, ["868"]], ["Tunisia (‫تونس‬‎)", "tn", "216"], ["Turkey (Türkiye)", "tr", "90"], ["Turkmenistan", "tm", "993"], ["Turks and Caicos Islands", "tc", "1", 23, ["649"]], ["Tuvalu", "tv", "688"], ["U.S. Virgin Islands", "vi", "1", 24, ["340"]], ["Uganda", "ug", "256"], ["Ukraine (Україна)", "ua", "380"], ["United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971"], ["United Kingdom", "gb", "44", 0], ["United States", "us", "1", 0], ["Uruguay", "uy", "598"], ["Uzbekistan (Oʻzbekiston)", "uz", "998"], ["Vanuatu", "vu", "678"], ["Vatican City (Città del Vaticano)", "va", "39", 1, ["06698"]], ["Venezuela", "ve", "58"], ["Vietnam (Việt Nam)", "vn", "84"], ["Wallis and Futuna (Wallis-et-Futuna)", "wf", "681"], ["Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1, ["5288", "5289"]], ["Yemen (‫اليمن‬‎)", "ye", "967"], ["Zambia", "zm", "260"], ["Zimbabwe", "zw", "263"], ["Åland Islands", "ax", "358", 1, ["18"]]], r = 0; r < d.length; r++) {
        var o = d[r];
        d[r] = {
          name: o[0],
          iso2: o[1],
          dialCode: o[2],
          priority: o[3] || 0,
          areaCodes: o[4] || null
        };
      }
      function l(v) {
        for (var $ = 1; $ < arguments.length; $++) {
          var s = arguments[$] != null ? Object(arguments[$]) : {}, u = Object.keys(s);
          typeof Object.getOwnPropertySymbols == "function" && u.push.apply(u, Object.getOwnPropertySymbols(s).filter(function(m) {
            return Object.getOwnPropertyDescriptor(s, m).enumerable;
          })), u.forEach(function(m) {
            h(v, m, s[m]);
          });
        }
        return v;
      }
      function h(v, $, s) {
        return $ = S($), $ in v ? Object.defineProperty(v, $, {
          value: s,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : v[$] = s, v;
      }
      function f(v, $) {
        if (!(v instanceof $))
          throw new TypeError("Cannot call a class as a function");
      }
      function y(v, $) {
        for (var s = 0; s < $.length; s++) {
          var u = $[s];
          u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(v, S(u.key), u);
        }
      }
      function R(v, $, s) {
        return $ && y(v.prototype, $), s && y(v, s), Object.defineProperty(v, "prototype", {
          writable: !1
        }), v;
      }
      function S(v) {
        var $ = N(v, "string");
        return typeof $ == "symbol" ? $ : String($);
      }
      function N(v, $) {
        if (typeof v != "object" || v === null)
          return v;
        var s = v[Symbol.toPrimitive];
        if (s !== e) {
          var u = s.call(v, $ || "default");
          if (typeof u != "object")
            return u;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ($ === "string" ? String : Number)(v);
      }
      var C = {
        getInstance: function($) {
          var s = $.getAttribute("data-intl-tel-input-id");
          return window.intlTelInputGlobals.instances[s];
        },
        instances: {},
        // using a global like this allows us to mock it in the tests
        documentReady: function() {
          return document.readyState === "complete";
        }
      };
      typeof window == "object" && (window.intlTelInputGlobals = C);
      var z = 0, W = {
        // whether or not to allow the dropdown
        allowDropdown: !0,
        // auto insert dial code (A) on init, (B) on user selecting a country, (C) on calling setCountry
        // also listen for blur/submit and auto remove dial code if that's all there is
        autoInsertDialCode: !1,
        // add a placeholder in the input with an example number for the selected country
        autoPlaceholder: "polite",
        // modify the parentClass
        customContainer: "",
        // modify the auto placeholder
        customPlaceholder: null,
        // append menu to specified element
        dropdownContainer: null,
        // don't display these countries
        excludeCountries: [],
        // format the input value during initialisation and on setNumber
        formatOnDisplay: !0,
        // geoIp lookup function
        geoIpLookup: null,
        // inject a hidden input with this name, and on submit, populate it with the result of getNumber
        hiddenInput: "",
        // initial country
        initialCountry: "",
        // localized country names e.g. { 'de': 'Deutschland' }
        localizedCountries: null,
        // national vs international formatting for numbers e.g. placeholders and displaying existing numbers
        nationalMode: !0,
        // display only these countries
        onlyCountries: [],
        // number type to use for placeholders
        placeholderNumberType: "MOBILE",
        // the countries at the top of the list. defaults to united states and united kingdom
        preferredCountries: ["us", "gb"],
        // display the country dial code next to the selected flag
        separateDialCode: !1,
        // option to hide the flags - must be used with separateDialCode, or allowDropdown=false
        showFlags: !0,
        // specify the path to the libphonenumber script to enable validation/formatting
        utilsScript: ""
      }, Y = ["800", "822", "833", "844", "855", "866", "877", "880", "881", "882", "883", "884", "885", "886", "887", "888", "889"], P = function($, s) {
        for (var u = Object.keys($), m = 0; m < u.length; m++)
          s(u[m], $[u[m]]);
      }, F = function($) {
        P(window.intlTelInputGlobals.instances, function(s) {
          window.intlTelInputGlobals.instances[s][$]();
        });
      }, Z = /* @__PURE__ */ function() {
        function v($, s) {
          var u = this;
          f(this, v), this.id = z++, this.telInput = $, this.activeItem = null, this.highlightedItem = null;
          var m = s || {};
          this.options = {}, P(W, function(E, w) {
            u.options[E] = m.hasOwnProperty(E) ? m[E] : w;
          }), this.hadInitialPlaceholder = !!$.getAttribute("placeholder");
        }
        return R(v, [{
          key: "_init",
          value: function() {
            var s = this;
            this.options.nationalMode && (this.options.autoInsertDialCode = !1), this.options.separateDialCode && (this.options.autoInsertDialCode = !1);
            var u = this.options.allowDropdown && !this.options.separateDialCode;
            if (!this.options.showFlags && u && (this.options.showFlags = !0), this.isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), this.isMobile && (document.body.classList.add("iti-mobile"), this.options.dropdownContainer || (this.options.dropdownContainer = document.body)), this.isRTL = !!this.telInput.closest("[dir=rtl]"), typeof Promise < "u") {
              var m = new Promise(function(w, T) {
                s.resolveAutoCountryPromise = w, s.rejectAutoCountryPromise = T;
              }), E = new Promise(function(w, T) {
                s.resolveUtilsScriptPromise = w, s.rejectUtilsScriptPromise = T;
              });
              this.promise = Promise.all([m, E]);
            } else
              this.resolveAutoCountryPromise = this.rejectAutoCountryPromise = function() {
              }, this.resolveUtilsScriptPromise = this.rejectUtilsScriptPromise = function() {
              };
            this.selectedCountryData = {}, this._processCountryData(), this._generateMarkup(), this._setInitialState(), this._initListeners(), this._initRequests();
          }
        }, {
          key: "_processCountryData",
          value: function() {
            this._processAllCountries(), this._processCountryCodes(), this._processPreferredCountries(), this.options.localizedCountries && this._translateCountriesByLocale(), (this.options.onlyCountries.length || this.options.localizedCountries) && this.countries.sort(this._countryNameSort);
          }
        }, {
          key: "_addCountryCode",
          value: function(s, u, m) {
            u.length > this.countryCodeMaxLen && (this.countryCodeMaxLen = u.length), this.countryCodes.hasOwnProperty(u) || (this.countryCodes[u] = []);
            for (var E = 0; E < this.countryCodes[u].length; E++)
              if (this.countryCodes[u][E] === s)
                return;
            var w = m !== e ? m : this.countryCodes[u].length;
            this.countryCodes[u][w] = s;
          }
        }, {
          key: "_processAllCountries",
          value: function() {
            if (this.options.onlyCountries.length) {
              var s = this.options.onlyCountries.map(function(m) {
                return m.toLowerCase();
              });
              this.countries = d.filter(function(m) {
                return s.indexOf(m.iso2) > -1;
              });
            } else if (this.options.excludeCountries.length) {
              var u = this.options.excludeCountries.map(function(m) {
                return m.toLowerCase();
              });
              this.countries = d.filter(function(m) {
                return u.indexOf(m.iso2) === -1;
              });
            } else
              this.countries = d;
          }
        }, {
          key: "_translateCountriesByLocale",
          value: function() {
            for (var s = 0; s < this.countries.length; s++) {
              var u = this.countries[s].iso2.toLowerCase();
              this.options.localizedCountries.hasOwnProperty(u) && (this.countries[s].name = this.options.localizedCountries[u]);
            }
          }
        }, {
          key: "_countryNameSort",
          value: function(s, u) {
            return s.name < u.name ? -1 : s.name > u.name ? 1 : 0;
          }
        }, {
          key: "_processCountryCodes",
          value: function() {
            this.countryCodeMaxLen = 0, this.dialCodes = {}, this.countryCodes = {};
            for (var s = 0; s < this.countries.length; s++) {
              var u = this.countries[s];
              this.dialCodes[u.dialCode] || (this.dialCodes[u.dialCode] = !0), this._addCountryCode(u.iso2, u.dialCode, u.priority);
            }
            for (var m = 0; m < this.countries.length; m++) {
              var E = this.countries[m];
              if (E.areaCodes)
                for (var w = this.countryCodes[E.dialCode][0], T = 0; T < E.areaCodes.length; T++) {
                  for (var H = E.areaCodes[T], V = 1; V < H.length; V++) {
                    var X = E.dialCode + H.substr(0, V);
                    this._addCountryCode(w, X), this._addCountryCode(E.iso2, X);
                  }
                  this._addCountryCode(E.iso2, E.dialCode + H);
                }
            }
          }
        }, {
          key: "_processPreferredCountries",
          value: function() {
            this.preferredCountries = [];
            for (var s = 0; s < this.options.preferredCountries.length; s++) {
              var u = this.options.preferredCountries[s].toLowerCase(), m = this._getCountryData(u, !1, !0);
              m && this.preferredCountries.push(m);
            }
          }
        }, {
          key: "_createEl",
          value: function(s, u, m) {
            var E = document.createElement(s);
            return u && P(u, function(w, T) {
              return E.setAttribute(w, T);
            }), m && m.appendChild(E), E;
          }
        }, {
          key: "_generateMarkup",
          value: function() {
            !this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete")) && this.telInput.setAttribute("autocomplete", "off");
            var s = this.options, u = s.allowDropdown, m = s.separateDialCode, E = s.showFlags, w = s.customContainer, T = s.hiddenInput, H = s.dropdownContainer, V = "iti";
            u && (V += " iti--allow-dropdown"), m && (V += " iti--separate-dial-code"), E && (V += " iti--show-flags"), w && (V += " ".concat(w));
            var X = this._createEl("div", {
              class: V
            });
            this.telInput.parentNode.insertBefore(X, this.telInput);
            var G = u || E || m;
            if (G && (this.flagsContainer = this._createEl("div", {
              class: "iti__flag-container"
            }, X)), X.appendChild(this.telInput), G && (this.selectedFlag = this._createEl("div", l({
              class: "iti__selected-flag"
            }, u && {
              role: "combobox",
              "aria-haspopup": "listbox",
              "aria-controls": "iti-".concat(this.id, "__country-listbox"),
              "aria-expanded": "false",
              "aria-label": "Telephone country code"
            }), this.flagsContainer)), E && (this.selectedFlagInner = this._createEl("div", {
              class: "iti__flag"
            }, this.selectedFlag)), this.selectedFlag && this.telInput.disabled && this.selectedFlag.setAttribute("aria-disabled", "true"), m && (this.selectedDialCode = this._createEl("div", {
              class: "iti__selected-dial-code"
            }, this.selectedFlag)), u && (this.telInput.disabled || this.selectedFlag.setAttribute("tabindex", "0"), this.dropdownArrow = this._createEl("div", {
              class: "iti__arrow"
            }, this.selectedFlag), this.countryList = this._createEl("ul", {
              class: "iti__country-list iti__hide",
              id: "iti-".concat(this.id, "__country-listbox"),
              role: "listbox",
              "aria-label": "List of countries"
            }), this.preferredCountries.length && (this._appendListItems(this.preferredCountries, "iti__preferred", !0), this._createEl("li", {
              class: "iti__divider",
              role: "separator",
              "aria-disabled": "true"
            }, this.countryList)), this._appendListItems(this.countries, "iti__standard"), H ? (this.dropdown = this._createEl("div", {
              class: "iti iti--container"
            }), this.dropdown.appendChild(this.countryList)) : this.flagsContainer.appendChild(this.countryList)), T) {
              var ue = T, b = this.telInput.getAttribute("name");
              if (b) {
                var U = b.lastIndexOf("[");
                U !== -1 && (ue = "".concat(b.substr(0, U), "[").concat(ue, "]"));
              }
              this.hiddenInput = this._createEl("input", {
                type: "hidden",
                name: ue
              }), X.appendChild(this.hiddenInput);
            }
          }
        }, {
          key: "_appendListItems",
          value: function(s, u, m) {
            for (var E = "", w = 0; w < s.length; w++) {
              var T = s[w], H = m ? "-preferred" : "";
              E += "<li class='iti__country ".concat(u, "' tabIndex='-1' id='iti-").concat(this.id, "__item-").concat(T.iso2).concat(H, "' role='option' data-dial-code='").concat(T.dialCode, "' data-country-code='").concat(T.iso2, "' aria-selected='false'>"), this.options.showFlags && (E += "<div class='iti__flag-box'><div class='iti__flag iti__".concat(T.iso2, "'></div></div>")), E += "<span class='iti__country-name'>".concat(T.name, "</span>"), E += "<span class='iti__dial-code'>+".concat(T.dialCode, "</span>"), E += "</li>";
            }
            this.countryList.insertAdjacentHTML("beforeend", E);
          }
        }, {
          key: "_setInitialState",
          value: function() {
            var s = this.telInput.getAttribute("value"), u = this.telInput.value, m = s && s.charAt(0) === "+" && (!u || u.charAt(0) !== "+"), E = m ? s : u, w = this._getDialCode(E), T = this._isRegionlessNanp(E), H = this.options, V = H.initialCountry, X = H.autoInsertDialCode;
            w && !T ? this._updateFlagFromNumber(E) : V !== "auto" && (V ? this._setFlag(V.toLowerCase()) : w && T ? this._setFlag("us") : (this.defaultCountry = this.preferredCountries.length ? this.preferredCountries[0].iso2 : this.countries[0].iso2, E || this._setFlag(this.defaultCountry)), !E && X && (this.telInput.value = "+".concat(this.selectedCountryData.dialCode))), E && this._updateValFromNumber(E);
          }
        }, {
          key: "_initListeners",
          value: function() {
            this._initKeyListeners(), this.options.autoInsertDialCode && this._initBlurListeners(), this.options.allowDropdown && this._initDropdownListeners(), this.hiddenInput && this._initHiddenInputListener();
          }
        }, {
          key: "_initHiddenInputListener",
          value: function() {
            var s = this;
            this._handleHiddenInputSubmit = function() {
              s.hiddenInput.value = s.getNumber();
            }, this.telInput.form && this.telInput.form.addEventListener("submit", this._handleHiddenInputSubmit);
          }
        }, {
          key: "_getClosestLabel",
          value: function() {
            for (var s = this.telInput; s && s.tagName !== "LABEL"; )
              s = s.parentNode;
            return s;
          }
        }, {
          key: "_initDropdownListeners",
          value: function() {
            var s = this;
            this._handleLabelClick = function(m) {
              s.countryList.classList.contains("iti__hide") ? s.telInput.focus() : m.preventDefault();
            };
            var u = this._getClosestLabel();
            u && u.addEventListener("click", this._handleLabelClick), this._handleClickSelectedFlag = function() {
              s.countryList.classList.contains("iti__hide") && !s.telInput.disabled && !s.telInput.readOnly && s._showDropdown();
            }, this.selectedFlag.addEventListener("click", this._handleClickSelectedFlag), this._handleFlagsContainerKeydown = function(m) {
              var E = s.countryList.classList.contains("iti__hide");
              E && ["ArrowUp", "Up", "ArrowDown", "Down", " ", "Enter"].indexOf(m.key) !== -1 && (m.preventDefault(), m.stopPropagation(), s._showDropdown()), m.key === "Tab" && s._closeDropdown();
            }, this.flagsContainer.addEventListener("keydown", this._handleFlagsContainerKeydown);
          }
        }, {
          key: "_initRequests",
          value: function() {
            var s = this;
            this.options.utilsScript && !window.intlTelInputUtils ? window.intlTelInputGlobals.documentReady() ? window.intlTelInputGlobals.loadUtils(this.options.utilsScript) : window.addEventListener("load", function() {
              window.intlTelInputGlobals.loadUtils(s.options.utilsScript);
            }) : this.resolveUtilsScriptPromise(), this.options.initialCountry === "auto" ? this._loadAutoCountry() : this.resolveAutoCountryPromise();
          }
        }, {
          key: "_loadAutoCountry",
          value: function() {
            window.intlTelInputGlobals.autoCountry ? this.handleAutoCountry() : window.intlTelInputGlobals.startedLoadingAutoCountry || (window.intlTelInputGlobals.startedLoadingAutoCountry = !0, typeof this.options.geoIpLookup == "function" && this.options.geoIpLookup(function(s) {
              window.intlTelInputGlobals.autoCountry = s.toLowerCase(), setTimeout(function() {
                return F("handleAutoCountry");
              });
            }, function() {
              return F("rejectAutoCountryPromise");
            }));
          }
        }, {
          key: "_initKeyListeners",
          value: function() {
            var s = this;
            this._handleKeyupEvent = function() {
              s._updateFlagFromNumber(s.telInput.value) && s._triggerCountryChange();
            }, this.telInput.addEventListener("keyup", this._handleKeyupEvent), this._handleClipboardEvent = function() {
              setTimeout(s._handleKeyupEvent);
            }, this.telInput.addEventListener("cut", this._handleClipboardEvent), this.telInput.addEventListener("paste", this._handleClipboardEvent);
          }
        }, {
          key: "_cap",
          value: function(s) {
            var u = this.telInput.getAttribute("maxlength");
            return u && s.length > u ? s.substr(0, u) : s;
          }
        }, {
          key: "_initBlurListeners",
          value: function() {
            var s = this;
            this._handleSubmitOrBlurEvent = function() {
              s._removeEmptyDialCode();
            }, this.telInput.form && this.telInput.form.addEventListener("submit", this._handleSubmitOrBlurEvent), this.telInput.addEventListener("blur", this._handleSubmitOrBlurEvent);
          }
        }, {
          key: "_removeEmptyDialCode",
          value: function() {
            if (this.telInput.value.charAt(0) === "+") {
              var s = this._getNumeric(this.telInput.value);
              (!s || this.selectedCountryData.dialCode === s) && (this.telInput.value = "");
            }
          }
        }, {
          key: "_getNumeric",
          value: function(s) {
            return s.replace(/\D/g, "");
          }
        }, {
          key: "_trigger",
          value: function(s) {
            var u = document.createEvent("Event");
            u.initEvent(s, !0, !0), this.telInput.dispatchEvent(u);
          }
        }, {
          key: "_showDropdown",
          value: function() {
            this.countryList.classList.remove("iti__hide"), this.selectedFlag.setAttribute("aria-expanded", "true"), this._setDropdownPosition(), this.activeItem && (this._highlightListItem(this.activeItem, !1), this._scrollTo(this.activeItem, !0)), this._bindDropdownListeners(), this.dropdownArrow.classList.add("iti__arrow--up"), this._trigger("open:countrydropdown");
          }
        }, {
          key: "_toggleClass",
          value: function(s, u, m) {
            m && !s.classList.contains(u) ? s.classList.add(u) : !m && s.classList.contains(u) && s.classList.remove(u);
          }
        }, {
          key: "_setDropdownPosition",
          value: function() {
            var s = this;
            if (this.options.dropdownContainer && this.options.dropdownContainer.appendChild(this.dropdown), !this.isMobile) {
              var u = this.telInput.getBoundingClientRect(), m = window.pageYOffset || document.documentElement.scrollTop, E = u.top + m, w = this.countryList.offsetHeight, T = E + this.telInput.offsetHeight + w < m + window.innerHeight, H = E - w > m;
              if (this._toggleClass(this.countryList, "iti__country-list--dropup", !T && H), this.options.dropdownContainer) {
                var V = !T && H ? 0 : this.telInput.offsetHeight;
                this.dropdown.style.top = "".concat(E + V, "px"), this.dropdown.style.left = "".concat(u.left + document.body.scrollLeft, "px"), this._handleWindowScroll = function() {
                  return s._closeDropdown();
                }, window.addEventListener("scroll", this._handleWindowScroll);
              }
            }
          }
        }, {
          key: "_getClosestListItem",
          value: function(s) {
            for (var u = s; u && u !== this.countryList && !u.classList.contains("iti__country"); )
              u = u.parentNode;
            return u === this.countryList ? null : u;
          }
        }, {
          key: "_bindDropdownListeners",
          value: function() {
            var s = this;
            this._handleMouseoverCountryList = function(w) {
              var T = s._getClosestListItem(w.target);
              T && s._highlightListItem(T, !1);
            }, this.countryList.addEventListener("mouseover", this._handleMouseoverCountryList), this._handleClickCountryList = function(w) {
              var T = s._getClosestListItem(w.target);
              T && s._selectListItem(T);
            }, this.countryList.addEventListener("click", this._handleClickCountryList);
            var u = !0;
            this._handleClickOffToClose = function() {
              u || s._closeDropdown(), u = !1;
            }, document.documentElement.addEventListener("click", this._handleClickOffToClose);
            var m = "", E = null;
            this._handleKeydownOnDropdown = function(w) {
              w.preventDefault(), w.key === "ArrowUp" || w.key === "Up" || w.key === "ArrowDown" || w.key === "Down" ? s._handleUpDownKey(w.key) : w.key === "Enter" ? s._handleEnterKey() : w.key === "Escape" ? s._closeDropdown() : /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(w.key) && (E && clearTimeout(E), m += w.key.toLowerCase(), s._searchForCountry(m), E = setTimeout(function() {
                m = "";
              }, 1e3));
            }, document.addEventListener("keydown", this._handleKeydownOnDropdown);
          }
        }, {
          key: "_handleUpDownKey",
          value: function(s) {
            var u = s === "ArrowUp" || s === "Up" ? this.highlightedItem.previousElementSibling : this.highlightedItem.nextElementSibling;
            u && (u.classList.contains("iti__divider") && (u = s === "ArrowUp" || s === "Up" ? u.previousElementSibling : u.nextElementSibling), this._highlightListItem(u, !0));
          }
        }, {
          key: "_handleEnterKey",
          value: function() {
            this.highlightedItem && this._selectListItem(this.highlightedItem);
          }
        }, {
          key: "_searchForCountry",
          value: function(s) {
            for (var u = 0; u < this.countries.length; u++)
              if (this._startsWith(this.countries[u].name, s)) {
                var m = this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(this.countries[u].iso2));
                this._highlightListItem(m, !1), this._scrollTo(m, !0);
                break;
              }
          }
        }, {
          key: "_startsWith",
          value: function(s, u) {
            return s.substr(0, u.length).toLowerCase() === u;
          }
        }, {
          key: "_updateValFromNumber",
          value: function(s) {
            var u = s;
            if (this.options.formatOnDisplay && window.intlTelInputUtils && this.selectedCountryData) {
              var m = this.options.nationalMode || u.charAt(0) !== "+" && !this.options.separateDialCode, E = intlTelInputUtils.numberFormat, w = E.NATIONAL, T = E.INTERNATIONAL, H = m ? w : T;
              u = intlTelInputUtils.formatNumber(u, this.selectedCountryData.iso2, H);
            }
            u = this._beforeSetNumber(u), this.telInput.value = u;
          }
        }, {
          key: "_updateFlagFromNumber",
          value: function(s) {
            var u = s, m = this.selectedCountryData.dialCode, E = m === "1";
            u && E && u.charAt(0) !== "+" && (u.charAt(0) !== "1" && (u = "1".concat(u)), u = "+".concat(u)), this.options.separateDialCode && m && u.charAt(0) !== "+" && (u = "+".concat(m).concat(u));
            var w = this._getDialCode(u, !0), T = this._getNumeric(u), H = null;
            if (w) {
              var V = this.countryCodes[this._getNumeric(w)], X = V.indexOf(this.selectedCountryData.iso2) !== -1 && T.length <= w.length - 1, G = m === "1" && this._isRegionlessNanp(T);
              if (!G && !X) {
                for (var ue = 0; ue < V.length; ue++)
                  if (V[ue]) {
                    H = V[ue];
                    break;
                  }
              }
            } else
              u.charAt(0) === "+" && T.length ? H = "" : (!u || u === "+") && (H = this.defaultCountry);
            return H !== null ? this._setFlag(H) : !1;
          }
        }, {
          key: "_isRegionlessNanp",
          value: function(s) {
            var u = this._getNumeric(s);
            if (u.charAt(0) === "1") {
              var m = u.substr(1, 3);
              return Y.indexOf(m) !== -1;
            }
            return !1;
          }
        }, {
          key: "_highlightListItem",
          value: function(s, u) {
            var m = this.highlightedItem;
            m && m.classList.remove("iti__highlight"), this.highlightedItem = s, this.highlightedItem.classList.add("iti__highlight"), this.selectedFlag.setAttribute("aria-activedescendant", s.getAttribute("id")), u && this.highlightedItem.focus();
          }
        }, {
          key: "_getCountryData",
          value: function(s, u, m) {
            for (var E = u ? d : this.countries, w = 0; w < E.length; w++)
              if (E[w].iso2 === s)
                return E[w];
            if (m)
              return null;
            throw new Error("No country data for '".concat(s, "'"));
          }
        }, {
          key: "_setFlag",
          value: function(s) {
            var u = this.options, m = u.allowDropdown, E = u.separateDialCode, w = u.showFlags, T = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
            if (this.selectedCountryData = s ? this._getCountryData(s, !1, !1) : {}, this.selectedCountryData.iso2 && (this.defaultCountry = this.selectedCountryData.iso2), w && this.selectedFlagInner.setAttribute("class", "iti__flag iti__".concat(s)), this._setSelectedCountryFlagTitleAttribute(s, E), E) {
              var H = this.selectedCountryData.dialCode ? "+".concat(this.selectedCountryData.dialCode) : "";
              this.selectedDialCode.innerHTML = H;
              var V = this.selectedFlag.offsetWidth || this._getHiddenSelectedFlagWidth();
              this.isRTL ? this.telInput.style.paddingRight = "".concat(V + 6, "px") : this.telInput.style.paddingLeft = "".concat(V + 6, "px");
            }
            if (this._updatePlaceholder(), m) {
              var X = this.activeItem;
              if (X && (X.classList.remove("iti__active"), X.setAttribute("aria-selected", "false")), s) {
                var G = this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(s, "-preferred")) || this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(s));
                G.setAttribute("aria-selected", "true"), G.classList.add("iti__active"), this.activeItem = G;
              }
            }
            return T.iso2 !== s;
          }
        }, {
          key: "_setSelectedCountryFlagTitleAttribute",
          value: function(s, u) {
            if (this.selectedFlag) {
              var m;
              s && !u ? m = "".concat(this.selectedCountryData.name, ": +").concat(this.selectedCountryData.dialCode) : s ? m = this.selectedCountryData.name : m = "Unknown", this.selectedFlag.setAttribute("title", m);
            }
          }
        }, {
          key: "_getHiddenSelectedFlagWidth",
          value: function() {
            var s = this.telInput.parentNode.cloneNode();
            s.style.visibility = "hidden", document.body.appendChild(s);
            var u = this.flagsContainer.cloneNode();
            s.appendChild(u);
            var m = this.selectedFlag.cloneNode(!0);
            u.appendChild(m);
            var E = m.offsetWidth;
            return s.parentNode.removeChild(s), E;
          }
        }, {
          key: "_updatePlaceholder",
          value: function() {
            var s = this.options.autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && this.options.autoPlaceholder === "polite";
            if (window.intlTelInputUtils && s) {
              var u = intlTelInputUtils.numberType[this.options.placeholderNumberType], m = this.selectedCountryData.iso2 ? intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, this.options.nationalMode, u) : "";
              m = this._beforeSetNumber(m), typeof this.options.customPlaceholder == "function" && (m = this.options.customPlaceholder(m, this.selectedCountryData)), this.telInput.setAttribute("placeholder", m);
            }
          }
        }, {
          key: "_selectListItem",
          value: function(s) {
            var u = this._setFlag(s.getAttribute("data-country-code"));
            this._closeDropdown(), this._updateDialCode(s.getAttribute("data-dial-code")), this.telInput.focus();
            var m = this.telInput.value.length;
            this.telInput.setSelectionRange(m, m), u && this._triggerCountryChange();
          }
        }, {
          key: "_closeDropdown",
          value: function() {
            this.countryList.classList.add("iti__hide"), this.selectedFlag.setAttribute("aria-expanded", "false"), this.selectedFlag.removeAttribute("aria-activedescendant"), this.dropdownArrow.classList.remove("iti__arrow--up"), document.removeEventListener("keydown", this._handleKeydownOnDropdown), document.documentElement.removeEventListener("click", this._handleClickOffToClose), this.countryList.removeEventListener("mouseover", this._handleMouseoverCountryList), this.countryList.removeEventListener("click", this._handleClickCountryList), this.options.dropdownContainer && (this.isMobile || window.removeEventListener("scroll", this._handleWindowScroll), this.dropdown.parentNode && this.dropdown.parentNode.removeChild(this.dropdown)), this._trigger("close:countrydropdown");
          }
        }, {
          key: "_scrollTo",
          value: function(s, u) {
            var m = this.countryList, E = window.pageYOffset || document.documentElement.scrollTop, w = m.offsetHeight, T = m.getBoundingClientRect().top + E, H = T + w, V = s.offsetHeight, X = s.getBoundingClientRect().top + E, G = X + V, ue = X - T + m.scrollTop, b = w / 2 - V / 2;
            if (X < T)
              u && (ue -= b), m.scrollTop = ue;
            else if (G > H) {
              u && (ue += b);
              var U = w - V;
              m.scrollTop = ue - U;
            }
          }
        }, {
          key: "_updateDialCode",
          value: function(s) {
            var u = this.telInput.value, m = "+".concat(s), E;
            if (u.charAt(0) === "+") {
              var w = this._getDialCode(u);
              w ? E = u.replace(w, m) : E = m, this.telInput.value = E;
            } else
              this.options.autoInsertDialCode && (u ? E = m + u : E = m, this.telInput.value = E);
          }
        }, {
          key: "_getDialCode",
          value: function(s, u) {
            var m = "";
            if (s.charAt(0) === "+")
              for (var E = "", w = 0; w < s.length; w++) {
                var T = s.charAt(w);
                if (!isNaN(parseInt(T, 10))) {
                  if (E += T, u)
                    this.countryCodes[E] && (m = s.substr(0, w + 1));
                  else if (this.dialCodes[E]) {
                    m = s.substr(0, w + 1);
                    break;
                  }
                  if (E.length === this.countryCodeMaxLen)
                    break;
                }
              }
            return m;
          }
        }, {
          key: "_getFullNumber",
          value: function() {
            var s = this.telInput.value.trim(), u = this.selectedCountryData.dialCode, m, E = this._getNumeric(s);
            return this.options.separateDialCode && s.charAt(0) !== "+" && u && E ? m = "+".concat(u) : m = "", m + s;
          }
        }, {
          key: "_beforeSetNumber",
          value: function(s) {
            var u = s;
            if (this.options.separateDialCode) {
              var m = this._getDialCode(u);
              if (m) {
                m = "+".concat(this.selectedCountryData.dialCode);
                var E = u[m.length] === " " || u[m.length] === "-" ? m.length + 1 : m.length;
                u = u.substr(E);
              }
            }
            return this._cap(u);
          }
        }, {
          key: "_triggerCountryChange",
          value: function() {
            this._trigger("countrychange");
          }
        }, {
          key: "handleAutoCountry",
          value: function() {
            this.options.initialCountry === "auto" && (this.defaultCountry = window.intlTelInputGlobals.autoCountry, this.telInput.value || this.setCountry(this.defaultCountry), this.resolveAutoCountryPromise());
          }
        }, {
          key: "handleUtils",
          value: function() {
            window.intlTelInputUtils && (this.telInput.value && this._updateValFromNumber(this.telInput.value), this._updatePlaceholder()), this.resolveUtilsScriptPromise();
          }
        }, {
          key: "destroy",
          value: function() {
            var s = this.telInput.form;
            if (this.options.allowDropdown) {
              this._closeDropdown(), this.selectedFlag.removeEventListener("click", this._handleClickSelectedFlag), this.flagsContainer.removeEventListener("keydown", this._handleFlagsContainerKeydown);
              var u = this._getClosestLabel();
              u && u.removeEventListener("click", this._handleLabelClick);
            }
            this.hiddenInput && s && s.removeEventListener("submit", this._handleHiddenInputSubmit), this.options.autoInsertDialCode && (s && s.removeEventListener("submit", this._handleSubmitOrBlurEvent), this.telInput.removeEventListener("blur", this._handleSubmitOrBlurEvent)), this.telInput.removeEventListener("keyup", this._handleKeyupEvent), this.telInput.removeEventListener("cut", this._handleClipboardEvent), this.telInput.removeEventListener("paste", this._handleClipboardEvent), this.telInput.removeAttribute("data-intl-tel-input-id");
            var m = this.telInput.parentNode;
            m.parentNode.insertBefore(this.telInput, m), m.parentNode.removeChild(m), delete window.intlTelInputGlobals.instances[this.id];
          }
        }, {
          key: "getExtension",
          value: function() {
            return window.intlTelInputUtils ? intlTelInputUtils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2) : "";
          }
        }, {
          key: "getNumber",
          value: function(s) {
            if (window.intlTelInputUtils) {
              var u = this.selectedCountryData.iso2;
              return intlTelInputUtils.formatNumber(this._getFullNumber(), u, s);
            }
            return "";
          }
        }, {
          key: "getNumberType",
          value: function() {
            return window.intlTelInputUtils ? intlTelInputUtils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2) : -99;
          }
        }, {
          key: "getSelectedCountryData",
          value: function() {
            return this.selectedCountryData;
          }
        }, {
          key: "getValidationError",
          value: function() {
            if (window.intlTelInputUtils) {
              var s = this.selectedCountryData.iso2;
              return intlTelInputUtils.getValidationError(this._getFullNumber(), s);
            }
            return -99;
          }
        }, {
          key: "isValidNumber",
          value: function() {
            var s = this._getFullNumber().trim();
            return window.intlTelInputUtils ? intlTelInputUtils.isValidNumber(s, this.selectedCountryData.iso2) : null;
          }
        }, {
          key: "isPossibleNumber",
          value: function() {
            var s = this._getFullNumber().trim();
            return window.intlTelInputUtils ? intlTelInputUtils.isPossibleNumber(s, this.selectedCountryData.iso2) : null;
          }
        }, {
          key: "setCountry",
          value: function(s) {
            var u = s.toLowerCase();
            this.selectedCountryData.iso2 !== u && (this._setFlag(u), this._updateDialCode(this.selectedCountryData.dialCode), this._triggerCountryChange());
          }
        }, {
          key: "setNumber",
          value: function(s) {
            var u = this._updateFlagFromNumber(s);
            this._updateValFromNumber(s), u && this._triggerCountryChange();
          }
        }, {
          key: "setPlaceholderNumberType",
          value: function(s) {
            this.options.placeholderNumberType = s, this._updatePlaceholder();
          }
        }]), v;
      }();
      C.getCountryData = function() {
        return d;
      };
      var g = function($, s, u) {
        var m = document.createElement("script");
        m.onload = function() {
          F("handleUtils"), s && s();
        }, m.onerror = function() {
          F("rejectUtilsScriptPromise"), u && u();
        }, m.className = "iti-load-utils", m.async = !0, m.src = $, document.body.appendChild(m);
      };
      return C.loadUtils = function(v) {
        if (!window.intlTelInputUtils && !window.intlTelInputGlobals.startedLoadingUtilsScript) {
          if (window.intlTelInputGlobals.startedLoadingUtilsScript = !0, typeof Promise < "u")
            return new Promise(function($, s) {
              return g(v, $, s);
            });
          g(v);
        }
        return null;
      }, C.defaults = W, C.version = "18.2.1", function(v, $) {
        var s = new Z(v, $);
        return s._init(), v.setAttribute("data-intl-tel-input-id", s.id), window.intlTelInputGlobals.instances[s.id] = s, s;
      };
    }();
  });
})(intlTelInput$3);
var intlTelInputExports = intlTelInput$3.exports, intlTelInput$1 = intlTelInputExports;
const intlTelInput$2 = /* @__PURE__ */ getDefaultExportFromCjs(intlTelInput$1);
(function() {
  var t = this || self;
  function e(a, c) {
    a = a.split(".");
    var I = t;
    a[0] in I || typeof I.execScript > "u" || I.execScript("var " + a[0]);
    for (var x; a.length && (x = a.shift()); )
      a.length || c === void 0 ? I[x] && I[x] !== Object.prototype[x] ? I = I[x] : I = I[x] = {} : I[x] = c;
  }
  function d(a, c) {
    function I() {
    }
    I.prototype = c.prototype, a.$ = c.prototype, a.prototype = new I(), a.prototype.constructor = a, a.fa = function(x, D, O) {
      for (var k = Array(arguments.length - 2), B = 2; B < arguments.length; B++)
        k[B - 2] = arguments[B];
      return c.prototype[D].apply(x, k);
    };
  }
  function r(a) {
    const c = [];
    let I = 0;
    for (const x in a)
      c[I++] = a[x];
    return c;
  }
  function o(a, c) {
    switch (this.g = a, this.m = !!c.o, this.i = c.h, this.v = c.type, this.u = !1, this.i) {
      case f:
      case y:
      case R:
      case S:
      case N:
      case h:
      case l:
        this.u = !0;
    }
    this.l = c.defaultValue;
  }
  var l = 1, h = 2, f = 3, y = 4, R = 6, S = 16, N = 18;
  function C(a, c) {
    for (this.i = a, this.g = {}, a = 0; a < c.length; a++) {
      var I = c[a];
      this.g[I.g] = I;
    }
  }
  function z(a) {
    return a = r(a.g), a.sort(function(c, I) {
      return c.g - I.g;
    }), a;
  }
  function W() {
    this.g = {}, this.l = this.j().g, this.i = this.m = null;
  }
  W.prototype.has = function(a) {
    return this.g[a.g] != null;
  }, W.prototype.get = function(a, c) {
    return F(this, a.g, c);
  }, W.prototype.set = function(a, c) {
    $(this, a.g, c);
  }, W.prototype.add = function(a, c) {
    s(this, a.g, c);
  };
  function Y(a, c) {
    for (var I = z(a.j()), x = 0; x < I.length; x++) {
      var D = I[x], O = D.g;
      if (c.g[O] != null) {
        a.i && delete a.i[D.g];
        var k = D.i == 11 || D.i == 10;
        if (D.m) {
          D = g(c, O);
          for (var B = 0; B < D.length; B++)
            s(a, O, k ? D[B].clone() : D[B]);
        } else
          D = P(c, O), k ? (k = P(a, O)) ? Y(k, D) : $(a, O, D.clone()) : $(a, O, D);
      }
    }
  }
  W.prototype.clone = function() {
    var a = new this.constructor();
    return a != this && (a.g = {}, a.i && (a.i = {}), Y(a, this)), a;
  };
  function P(a, c) {
    var I = a.g[c];
    if (I == null)
      return null;
    if (a.m) {
      if (!(c in a.i)) {
        var x = a.m, D = a.l[c];
        if (I != null)
          if (D.m) {
            for (var O = [], k = 0; k < I.length; k++)
              O[k] = x.i(D, I[k]);
            I = O;
          } else
            I = x.i(D, I);
        return a.i[c] = I;
      }
      return a.i[c];
    }
    return I;
  }
  function F(a, c, I) {
    var x = P(a, c);
    return a.l[c].m ? x[I || 0] : x;
  }
  function Z(a, c) {
    if (a.g[c] != null)
      a = F(a, c);
    else
      e: {
        if (a = a.l[c], a.l === void 0)
          if (c = a.v, c === Boolean)
            a.l = !1;
          else if (c === Number)
            a.l = 0;
          else if (c === String)
            a.l = a.u ? "0" : "";
          else {
            a = new c();
            break e;
          }
        a = a.l;
      }
    return a;
  }
  function g(a, c) {
    return P(a, c) || [];
  }
  function v(a, c) {
    return a.l[c].m ? a.g[c] != null ? a.g[c].length : 0 : a.g[c] != null ? 1 : 0;
  }
  function $(a, c, I) {
    a.g[c] = I, a.i && (a.i[c] = I);
  }
  function s(a, c, I) {
    a.g[c] || (a.g[c] = []), a.g[c].push(I), a.i && delete a.i[c];
  }
  function u(a, c) {
    var I = [], x;
    for (x in c)
      x != 0 && I.push(new o(x, c[x]));
    return new C(a, I);
  }
  function m() {
  }
  m.prototype.g = function(a) {
    throw new a.i(), Error("Unimplemented");
  }, m.prototype.i = function(a, c) {
    if (a.i == 11 || a.i == 10)
      return c instanceof W ? c : this.g(a.v.prototype.j(), c);
    if (a.i == 14)
      return typeof c == "string" && E.test(c) && (a = Number(c), 0 < a) ? a : c;
    if (!a.u)
      return c;
    if (a = a.v, a === String) {
      if (typeof c == "number")
        return String(c);
    } else if (a === Number && typeof c == "string" && (c === "Infinity" || c === "-Infinity" || c === "NaN" || E.test(c)))
      return Number(c);
    return c;
  };
  var E = /^-?[0-9]+$/;
  function w() {
  }
  d(w, m), w.prototype.g = function(a, c) {
    return a = new a.i(), a.m = this, a.g = c, a.i = {}, a;
  };
  function T() {
  }
  d(T, w), T.prototype.i = function(a, c) {
    return a.i == 8 ? !!c : m.prototype.i.apply(this, arguments);
  }, T.prototype.g = function(a, c) {
    return T.$.g.call(this, a, c);
  };
  function H(a, c) {
    a != null && this.g.apply(this, arguments);
  }
  H.prototype.i = "", H.prototype.set = function(a) {
    this.i = "" + a;
  }, H.prototype.g = function(a, c, I) {
    if (this.i += String(a), c != null)
      for (let x = 1; x < arguments.length; x++)
        this.i += arguments[x];
    return this;
  }, H.prototype.toString = function() {
    return this.i;
  };
  function V() {
    W.call(this);
  }
  d(V, W);
  var X = null;
  function G() {
    W.call(this);
  }
  d(G, W);
  var ue = null;
  function b() {
    W.call(this);
  }
  d(b, W);
  var U = null;
  V.prototype.j = function() {
    var a = X;
    return a || (X = a = u(V, { 0: { name: "NumberFormat", s: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: !0, h: 9, type: String }, 2: { name: "format", required: !0, h: 9, type: String }, 3: { name: "leading_digits_pattern", o: !0, h: 9, type: String }, 4: { name: "national_prefix_formatting_rule", h: 9, type: String }, 6: { name: "national_prefix_optional_when_formatting", h: 8, defaultValue: !1, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", h: 9, type: String } })), a;
  }, V.j = V.prototype.j, G.prototype.j = function() {
    var a = ue;
    return a || (ue = a = u(G, { 0: { name: "PhoneNumberDesc", s: "i18n.phonenumbers.PhoneNumberDesc" }, 2: { name: "national_number_pattern", h: 9, type: String }, 9: { name: "possible_length", o: !0, h: 5, type: Number }, 10: { name: "possible_length_local_only", o: !0, h: 5, type: Number }, 6: { name: "example_number", h: 9, type: String } })), a;
  }, G.j = G.prototype.j, b.prototype.j = function() {
    var a = U;
    return a || (U = a = u(b, {
      0: { name: "PhoneMetadata", s: "i18n.phonenumbers.PhoneMetadata" },
      1: { name: "general_desc", h: 11, type: G },
      2: { name: "fixed_line", h: 11, type: G },
      3: { name: "mobile", h: 11, type: G },
      4: { name: "toll_free", h: 11, type: G },
      5: { name: "premium_rate", h: 11, type: G },
      6: { name: "shared_cost", h: 11, type: G },
      7: { name: "personal_number", h: 11, type: G },
      8: { name: "voip", h: 11, type: G },
      21: { name: "pager", h: 11, type: G },
      25: { name: "uan", h: 11, type: G },
      27: { name: "emergency", h: 11, type: G },
      28: { name: "voicemail", h: 11, type: G },
      29: { name: "short_code", h: 11, type: G },
      30: { name: "standard_rate", h: 11, type: G },
      31: { name: "carrier_specific", h: 11, type: G },
      33: { name: "sms_services", h: 11, type: G },
      24: { name: "no_international_dialling", h: 11, type: G },
      9: { name: "id", required: !0, h: 9, type: String },
      10: { name: "country_code", h: 5, type: Number },
      11: { name: "international_prefix", h: 9, type: String },
      17: { name: "preferred_international_prefix", h: 9, type: String },
      12: { name: "national_prefix", h: 9, type: String },
      13: { name: "preferred_extn_prefix", h: 9, type: String },
      15: {
        name: "national_prefix_for_parsing",
        h: 9,
        type: String
      },
      16: { name: "national_prefix_transform_rule", h: 9, type: String },
      18: { name: "same_mobile_and_fixed_line_pattern", h: 8, defaultValue: !1, type: Boolean },
      19: { name: "number_format", o: !0, h: 11, type: V },
      20: { name: "intl_number_format", o: !0, h: 11, type: V },
      22: { name: "main_country_for_code", h: 8, defaultValue: !1, type: Boolean },
      23: { name: "leading_digits", h: 9, type: String }
    })), a;
  }, b.j = b.prototype.j;
  function K() {
    W.call(this);
  }
  d(K, W);
  var re = null, oe = { ea: 0, da: 1, ca: 5, ba: 10, aa: 20 };
  K.prototype.j = function() {
    var a = re;
    return a || (re = a = u(K, { 0: { name: "PhoneNumber", s: "i18n.phonenumbers.PhoneNumber" }, 1: { name: "country_code", required: !0, h: 5, type: Number }, 2: { name: "national_number", required: !0, h: 4, type: Number }, 3: { name: "extension", h: 9, type: String }, 4: { name: "italian_leading_zero", h: 8, type: Boolean }, 8: { name: "number_of_leading_zeros", h: 5, defaultValue: 1, type: Number }, 5: { name: "raw_input", h: 9, type: String }, 6: { name: "country_code_source", h: 14, defaultValue: 0, type: oe }, 7: {
      name: "preferred_domestic_carrier_code",
      h: 9,
      type: String
    } })), a;
  }, K.ctor = K, K.ctor.j = K.prototype.j;
  var ie = {
    1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
    7: ["RU", "KZ"],
    20: ["EG"],
    27: ["ZA"],
    30: ["GR"],
    31: ["NL"],
    32: ["BE"],
    33: ["FR"],
    34: ["ES"],
    36: ["HU"],
    39: ["IT", "VA"],
    40: ["RO"],
    41: ["CH"],
    43: ["AT"],
    44: ["GB", "GG", "IM", "JE"],
    45: ["DK"],
    46: ["SE"],
    47: ["NO", "SJ"],
    48: ["PL"],
    49: ["DE"],
    51: ["PE"],
    52: ["MX"],
    53: ["CU"],
    54: ["AR"],
    55: ["BR"],
    56: ["CL"],
    57: ["CO"],
    58: ["VE"],
    60: ["MY"],
    61: ["AU", "CC", "CX"],
    62: ["ID"],
    63: ["PH"],
    64: ["NZ"],
    65: ["SG"],
    66: ["TH"],
    81: ["JP"],
    82: ["KR"],
    84: ["VN"],
    86: ["CN"],
    90: ["TR"],
    91: ["IN"],
    92: ["PK"],
    93: ["AF"],
    94: ["LK"],
    95: ["MM"],
    98: ["IR"],
    211: ["SS"],
    212: ["MA", "EH"],
    213: ["DZ"],
    216: ["TN"],
    218: ["LY"],
    220: ["GM"],
    221: ["SN"],
    222: ["MR"],
    223: ["ML"],
    224: ["GN"],
    225: ["CI"],
    226: ["BF"],
    227: ["NE"],
    228: ["TG"],
    229: ["BJ"],
    230: ["MU"],
    231: ["LR"],
    232: ["SL"],
    233: ["GH"],
    234: ["NG"],
    235: ["TD"],
    236: ["CF"],
    237: ["CM"],
    238: ["CV"],
    239: ["ST"],
    240: ["GQ"],
    241: ["GA"],
    242: ["CG"],
    243: ["CD"],
    244: ["AO"],
    245: ["GW"],
    246: ["IO"],
    247: ["AC"],
    248: ["SC"],
    249: ["SD"],
    250: ["RW"],
    251: ["ET"],
    252: ["SO"],
    253: ["DJ"],
    254: ["KE"],
    255: ["TZ"],
    256: ["UG"],
    257: ["BI"],
    258: ["MZ"],
    260: ["ZM"],
    261: ["MG"],
    262: ["RE", "YT"],
    263: ["ZW"],
    264: ["NA"],
    265: ["MW"],
    266: ["LS"],
    267: ["BW"],
    268: ["SZ"],
    269: ["KM"],
    290: ["SH", "TA"],
    291: ["ER"],
    297: ["AW"],
    298: ["FO"],
    299: ["GL"],
    350: ["GI"],
    351: ["PT"],
    352: ["LU"],
    353: ["IE"],
    354: ["IS"],
    355: ["AL"],
    356: ["MT"],
    357: ["CY"],
    358: ["FI", "AX"],
    359: ["BG"],
    370: ["LT"],
    371: ["LV"],
    372: ["EE"],
    373: ["MD"],
    374: ["AM"],
    375: ["BY"],
    376: ["AD"],
    377: ["MC"],
    378: ["SM"],
    380: ["UA"],
    381: ["RS"],
    382: ["ME"],
    383: ["XK"],
    385: ["HR"],
    386: ["SI"],
    387: ["BA"],
    389: ["MK"],
    420: ["CZ"],
    421: ["SK"],
    423: ["LI"],
    500: ["FK"],
    501: ["BZ"],
    502: ["GT"],
    503: ["SV"],
    504: ["HN"],
    505: ["NI"],
    506: ["CR"],
    507: ["PA"],
    508: ["PM"],
    509: ["HT"],
    590: ["GP", "BL", "MF"],
    591: ["BO"],
    592: ["GY"],
    593: ["EC"],
    594: ["GF"],
    595: ["PY"],
    596: ["MQ"],
    597: ["SR"],
    598: ["UY"],
    599: ["CW", "BQ"],
    670: ["TL"],
    672: ["NF"],
    673: ["BN"],
    674: ["NR"],
    675: ["PG"],
    676: ["TO"],
    677: ["SB"],
    678: ["VU"],
    679: ["FJ"],
    680: ["PW"],
    681: ["WF"],
    682: ["CK"],
    683: ["NU"],
    685: ["WS"],
    686: ["KI"],
    687: ["NC"],
    688: ["TV"],
    689: ["PF"],
    690: ["TK"],
    691: ["FM"],
    692: ["MH"],
    800: ["001"],
    808: ["001"],
    850: ["KP"],
    852: ["HK"],
    853: ["MO"],
    855: ["KH"],
    856: ["LA"],
    870: ["001"],
    878: ["001"],
    880: ["BD"],
    881: ["001"],
    882: ["001"],
    883: ["001"],
    886: ["TW"],
    888: ["001"],
    960: ["MV"],
    961: ["LB"],
    962: ["JO"],
    963: ["SY"],
    964: ["IQ"],
    965: ["KW"],
    966: ["SA"],
    967: ["YE"],
    968: ["OM"],
    970: ["PS"],
    971: ["AE"],
    972: ["IL"],
    973: ["BH"],
    974: ["QA"],
    975: ["BT"],
    976: ["MN"],
    977: ["NP"],
    979: ["001"],
    992: ["TJ"],
    993: ["TM"],
    994: ["AZ"],
    995: ["GE"],
    996: ["KG"],
    998: ["UZ"]
  }, le = {
    AC: [, [
      ,
      ,
      "(?:[01589]\\d|[46])\\d{4}",
      ,
      ,
      ,
      ,
      ,
      ,
      [5, 6]
    ], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:0[1-9]|[1589]\\d)\\d{4}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]],
    AD: [
      ,
      [, , "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", , , , , , , [6, 8, 9]],
      [, , "[78]\\d{5}", , , , "712345", , , [6]],
      [, , "690\\d{6}|[356]\\d{5}", , , , "312345", , , [6, 9]],
      [, , "180[02]\\d{4}", , , , "18001234", , , [8]],
      [, , "[19]\\d{5}", , , , "912345", , , [6]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "AD",
      376,
      "00",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , "1800\\d{4}", , , , , , , [8]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    AE: [
      ,
      [, , "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
      [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]],
      [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]],
      [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"],
      [, , "900[02]\\d{5}", , , , "900234567", , , [9]],
      [, , "700[05]\\d{5}", , , , "700012345", , , [9]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "AE",
      971,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , "600[25]\\d{5}", , , , "600212345", , , [9]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    AF: [, [, , "[2-7]\\d{8}", , , , , , , [9], [7]], [
      ,
      ,
      "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
      ,
      ,
      ,
      "234567890",
      ,
      ,
      ,
      [7]
    ], [, , "7\\d{8}", , , , "701234567", , , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    AG: [
      ,
      [, , "(?:268|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
      [
        ,
        ,
        "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
        ,
        ,
        ,
        "2684601234",
        ,
        ,
        ,
        [7]
      ],
      [, , "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}", , , , "2684641234", , , , [7]],
      [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
      [, , "900[2-9]\\d{6}", , , , "9002123456"],
      [, , , , , , , , , [-1]],
      [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
      [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]],
      "AG",
      1,
      "011",
      "1",
      ,
      ,
      "([457]\\d{6})$|1",
      "268$1",
      ,
      ,
      ,
      ,
      [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]],
      ,
      "268",
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    AI: [, [, , "(?:264|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "264(?:292|4(?:6[12]|9[78]))\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
      ,
      ,
      "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
      ,
      ,
      ,
      "5002345678"
    ], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "([2457]\\d{6})$|1", "264$1", , , , , [, , "264724\\d{4}", , , , "2647241234", , , , [7]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    AL: [, [, , "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", , , , , , , [6, 7, 8, 9], [5]], [, , "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", , , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[78][2-9]|9\\d)\\d{6}", , , , "672123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [
      ,
      ,
      "900[1-9]\\d\\d",
      ,
      ,
      ,
      "900123",
      ,
      ,
      [6]
    ], [, , "808[1-9]\\d\\d", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    AM: [, [
      ,
      ,
      "(?:[1-489]\\d|55|60|77)\\d{6}",
      ,
      ,
      ,
      ,
      ,
      ,
      [8],
      [5, 6]
    ], [, , "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}", , , , "10123456", , , , [5, 6]], [, , "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}", , , , "77123456"], [, , "800\\d{5}", , , , "80012345"], [, , "90[016]\\d{5}", , , , "90012345"], [, , "80[1-4]\\d{5}", , , , "80112345"], [, , , , , , , , , [-1]], [, , "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[01])\\d{4}", , , , "60271234"], "AM", 374, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], [
      ,
      "(\\d{3})(\\d{5})",
      "$1 $2",
      ["2|3[12]"],
      "(0$1)"
    ], [, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    AO: [
      ,
      [, , "[29]\\d{8}", , , , , , , [9]],
      [, , "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}", , , , "222123456"],
      [, , "9[1-59]\\d{7}", , , , "923123456"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "AO",
      244,
      "00",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    AR: [
      ,
      [, , "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", , , , , , , [10, 11], [6, 7, 8]],
      [
        ,
        ,
        "3888[013-9]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
        ,
        ,
        ,
        "1123456789",
        ,
        ,
        [10],
        [6, 7, 8]
      ],
      [
        ,
        ,
        "93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
        ,
        ,
        ,
        "91123456789",
        ,
        ,
        ,
        [6, 7, 8]
      ],
      [, , "800\\d{7,8}", , , , "8001234567"],
      [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "AR",
      54,
      "00",
      "0",
      ,
      ,
      "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
      "9$1",
      ,
      ,
      [[, "(\\d{3})", "$1", ["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]], [, "(\\d{2})(\\d{4})", "$1-$2", ["[1-9]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[1-8]"]], [
        ,
        "(\\d{4})(\\d{2})(\\d{4})",
        "$1 $2-$3",
        [
          "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
          "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
          "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
          "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
        ],
        "0$1",
        ,
        1
      ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [
        ,
        "(\\d)(\\d{4})(\\d{2})(\\d{4})",
        "$2 15-$3-$4",
        [
          "9(?:2[2-469]|3[3-578])",
          "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
          "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
          "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
          "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
        ],
        "0$1"
      ], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1"]],
      [
        [
          ,
          "(\\d{4})(\\d{2})(\\d{4})",
          "$1 $2-$3",
          [
            "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
            "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ],
          "0$1",
          ,
          1
        ],
        [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1],
        [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", [
          "9(?:2[2-469]|3[3-578])",
          "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
          "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
          "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
          "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
        ]],
        [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["91"]],
        [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"],
        [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9"]]
      ],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , "810\\d{7}", , , , , , , [10]],
      [, , "810\\d{7}", , , , "8101234567", , , [10]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    AS: [, [, , "(?:[58]\\d\\d|684|900)\\d{7}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}", , , , "6847331234", , , , [7]], [
      ,
      ,
      "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
      ,
      ,
      ,
      "8002123456"
    ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "([267]\\d{6})$|1", "684$1", , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    AT: [, [
      ,
      ,
      "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
      ,
      ,
      ,
      ,
      ,
      ,
      [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      [3]
    ], [, , "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}", , , , "1234567890", , , , [3]], [, , "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", , , , "664123456", , , [7, 8, 9, 10, 11, 12, 13]], [
      ,
      ,
      "800\\d{6,10}",
      ,
      ,
      ,
      "800123456",
      ,
      ,
      [9, 10, 11, 12, 13]
    ], [, , "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10|2[018])\\d{6,10}|828\\d{5}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", , , , "780123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , [
      [, "(\\d{4})", "$1", ["14"]],
      [, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"],
      [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"],
      [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
      [, "(\\d{6})", "$1", ["[18]"]],
      [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"],
      [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"],
      [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"],
      [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]
    ], [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [
      ,
      "(\\d{3})(\\d{3,10})",
      "$1 $2",
      ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
      "0$1"
    ], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    AU: [
      ,
      [, , "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", , , , , , , [5, 6, 7, 8, 9, 10, 12]],
      [
        ,
        ,
        "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
        ,
        ,
        ,
        "212345678",
        ,
        ,
        [9],
        [8]
      ],
      [, , "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]],
      [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
      [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
      [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
      [, , , , , , , , , [-1]],
      [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
      "AU",
      61,
      "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
      "0",
      ,
      ,
      "(183[12])|0",
      ,
      "0011",
      ,
      [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["19"]], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]], [
        ,
        "(\\d{4})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["130"]
      ]],
      [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]],
      [, , "163\\d{2,6}", , , , "1631234", , , [5, 6, 7, 8, 9]],
      1,
      ,
      [, , "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}", , , , , , , [6, 7, 8, 10, 12]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    AW: [, [
      ,
      ,
      "(?:[25-79]\\d\\d|800)\\d{4}",
      ,
      ,
      ,
      ,
      ,
      ,
      [7]
    ], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:28\\d|501)\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    AX: [, [
      ,
      ,
      "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
      ,
      ,
      ,
      ,
      ,
      ,
      [5, 6, 7, 8, 9, 10, 11, 12]
    ], [, , "18[1-8]\\d{3,6}", , , , "181234567", , , [6, 7, 8, 9]], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , "18", [, , , , , , , , , [-1]], [
      ,
      ,
      "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
      ,
      ,
      ,
      "10112345"
    ], , , [, , , , , , , , , [-1]]],
    AZ: [, [, , "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", , , , , , , [9], [7]], [, , "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}", , , , "123123456", , , , [7]], [, , "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[1-9]"]], [
      ,
      "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["90"],
      "0$1"
    ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [
      ,
      "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[13-9]"],
      "0$1"
    ]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    BA: [
      ,
      [, , "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", , , , , , , [8, 9], [6]],
      [, , "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", , , , "30212345", , , [8], [6]],
      [, , "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}", , , , "61123456"],
      [, , "8[08]\\d{6}", , , , "80123456", , , [8]],
      [, , "9[0246]\\d{6}", , , , "90123456", , , [8]],
      [, , "8[12]\\d{6}", , , , "82123456", , , [8]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "BA",
      387,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
      [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", , , , "70341234", , , [8]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    BB: [, [, , "(?:246|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}", , , , "2462501234", , , , [7]], [
      ,
      ,
      "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
      ,
      ,
      ,
      "8002123456"
    ], [, , "(?:246976|900[2-9]\\d\\d)\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "([2-9]\\d{6})$|1", "246$1", , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [
      ,
      ,
      "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
      ,
      ,
      ,
      "2464301234",
      ,
      ,
      ,
      [7]
    ], , , [, , , , , , , , , [-1]]],
    BD: [, [, , "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [
      ,
      ,
      "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:222|[45]\\d)\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
      ,
      ,
      ,
      "27111234"
    ], [, , "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], [
      ,
      "(\\d{3})(\\d{3,7})",
      "$1-$2",
      ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
      "0$1"
    ], [, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], [, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    BE: [, [, , "4\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9]], [, , "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", , , , "12345678", , , [8]], [, , "4[5-9]\\d{7}", , , , "470123456", , , [9]], [, , "800[1-9]\\d{4}", , , , "80012345", , , [8]], [, , "(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}", , , , "90012345", , , [8]], [
      ,
      ,
      "7879\\d{4}",
      ,
      ,
      ,
      "78791234",
      ,
      ,
      [8]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", , , , "78102345", , , [8]], , , [, , , , , , , , , [-1]]],
    BF: [, [
      ,
      ,
      "[025-7]\\d{7}",
      ,
      ,
      ,
      ,
      ,
      ,
      [8]
    ], [, , "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}", , , , "70123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    BG: [
      ,
      [, , "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", , , , , , , [6, 7, 8, 9, 12], [4, 5]],
      [, , "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", , , , "2123456", , , [6, 7, 8], [4, 5]],
      [, , "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", , , , "43012345", , , [8, 9]],
      [, , "(?:00800\\d\\d|800)\\d{5}", , , , "80012345", , , [8, 12]],
      [, , "90\\d{6}", , , , "90123456", , , [8]],
      [, , "700\\d{5}", , , , "70012345", , , [8]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "BG",
      359,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d{6})", "$1", ["1"]], [, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
        ,
        "(\\d{3})(\\d{4})",
        "$1 $2",
        ["43[1-6]|70[1-9]"],
        "0$1"
      ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
      [[, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
        ,
        "(\\d{3})(\\d{4})",
        "$1 $2",
        ["43[1-6]|70[1-9]"],
        "0$1"
      ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    BH: [, [, , "[136-9]\\d{7}", , , , , , , [8]], [
      ,
      ,
      "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}",
      ,
      ,
      ,
      "17001234"
    ], [, , "(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}", , , , "36001234"], [, , "80\\d{6}", , , , "80123456"], [, , "(?:87|9[014578])\\d{6}", , , , "90123456"], [, , "84\\d{6}", , , , "84123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BH", 973, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    BI: [, [, , "(?:[267]\\d|31)\\d{6}", , , , , , , [8]], [, , "(?:22|31)\\d{6}", , , , "22201234"], [
      ,
      ,
      "(?:29|[67][125-9])\\d{6}",
      ,
      ,
      ,
      "79561234"
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    BJ: [
      ,
      [, , "[24-689]\\d{7}", , , , , , , [8]],
      [, , "2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}", , , , "20211234"],
      [, , "(?:4[0-356]|[56]\\d|9[013-9])\\d{6}", , , , "90011234"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , "857[58]\\d{4}", , , , "85751234"],
      "BJ",
      229,
      "00",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , "81\\d{6}", , , , "81123456"],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    BL: [, [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [, , "590(?:2[7-9]|5[12]|87)\\d{4}", , , , "590271234"], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:395|76[018])\\d|475[0-2])\\d{4}", , , , "976012345"], "BL", 590, "00", "0", , , "0", , , , , , [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    BM: [, [, , "(?:441|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}", , , , "4414123456", , , , [7]], [, , "441(?:[2378]\\d|5[0-39]|92)\\d{5}", , , , "4413701234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
      ,
      ,
      "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
      ,
      ,
      ,
      "5002345678"
    ], [, , , , , , , , , [-1]], "BM", 1, "011", "1", , , "([2-9]\\d{6})$|1", "441$1", , , , , [, , , , , , , , , [-1]], , "441", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    BN: [
      ,
      [, , "[2-578]\\d{6}", , , , , , , [7]],
      [, , "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}", , , , "2345678"],
      [, , "(?:22[89]|[78]\\d\\d)\\d{4}", , , , "7123456"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , "5[34]\\d{5}", , , , "5345678"],
      "BN",
      673,
      "00",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    BO: [
      ,
      [, , "(?:[2-467]\\d\\d|8001)\\d{5}", , , , , , , [8, 9], [7]],
      [, , "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", , , , "22123456", , , [8], [7]],
      [, , "[67]\\d{7}", , , , "71234567", , , [8]],
      [, , "8001[07]\\d{4}", , , , "800171234", , , [9]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "BO",
      591,
      "00(?:1\\d)?",
      "0",
      ,
      ,
      "0(1\\d)?",
      ,
      ,
      ,
      [[, "(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"], , "0$CC $1"], [, "(\\d{8})", "$1", ["[67]"], , "0$CC $1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"], , "0$CC $1"]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , "8001[07]\\d{4}", , , , , , , [9]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    BQ: [, [, , "(?:[34]1|7\\d)\\d{5}", , , , , , , [7]], [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}", , , , "7151234"], [, , "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BQ", 599, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "[347]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    BR: [, [, , "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", , , , "11961234567", , , [10, 11], [8, 9]], [
      ,
      ,
      "800\\d{6,7}",
      ,
      ,
      ,
      "800123456",
      ,
      ,
      [9, 10]
    ], [, , "300\\d{6}|[59]00\\d{6,7}", , , , "300123456", , , [9, 10]], [, , "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", , , , "40041234", , , [8, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [[, "(\\d{3,6})", "$1", ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
      ,
      "(\\d{4})(\\d{4})",
      "$1-$2",
      ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]
    ], [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], [, "(\\d{5})(\\d{4})", "$1-$2", ["9"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
      ,
      "(\\d{3})(\\d{2,3})(\\d{4})",
      "$1 $2 $3",
      ["(?:[358]|90)0"],
      "0$1"
    ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}", , , , , , , [8, 9, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    BS: [, [, , "(?:242|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
      ,
      ,
      "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
      ,
      ,
      ,
      "2423456789",
      ,
      ,
      ,
      [7]
    ], [, , "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}", , , , "2423591234", , , , [7]], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
      ,
      ,
      "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
      ,
      ,
      ,
      "5002345678"
    ], [, , , , , , , , , [-1]], "BS", 1, "011", "1", , , "([3-8]\\d{6})$|1", "242$1", , , , , [, , , , , , , , , [-1]], , "242", [, , , , , , , , , [-1]], [, , "242225\\d{4}", , , , "2422250123"], , , [, , , , , , , , , [-1]]],
    BT: [, [, , "[17]\\d{7}|[2-8]\\d{6}", , , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|77)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[2-7]"]], [
      ,
      "(\\d)(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["[2-68]|7[246]"]
    ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    BW: [, [, , "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [
      ,
      ,
      "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",
      ,
      ,
      ,
      "2401234",
      ,
      ,
      [7]
    ], [, , "(?:321|7(?:[1-7]\\d|8[0-4]))\\d{5}", , , , "71123456", , , [8]], [, , "(?:0800|800\\d)\\d{6}", , , , "0800012345", , , [10]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "79(?:1(?:[01]\\d|2[0-7])|2[0-7]\\d)\\d{3}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], [
      ,
      "(\\d{3})(\\d{4})(\\d{3})",
      "$1 $2 $3",
      ["8"]
    ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    BY: [, [, , "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", , , , "152450911", , , [9], [5, 6, 7]], [
      ,
      ,
      "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
      ,
      ,
      ,
      "294911911",
      ,
      ,
      [9]
    ], [, , "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}", , , , "8011234567"], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "0|80?", , "8~10", , [[, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [
      ,
      "(\\d{4})(\\d{2})(\\d{3})",
      "$1 $2-$3",
      ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
      "8 0$1"
    ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    BZ: [, [, , "(?:0800\\d|[2-8])\\d{6}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", , , , "2221234", , , [7]], [
      ,
      ,
      "6[0-35-7]\\d{5}",
      ,
      ,
      ,
      "6221234",
      ,
      ,
      [7]
    ], [, , "0800\\d{7}", , , , "08001234123", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CA: [, [, , "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", , , , , , , [7, 10]], [
      ,
      ,
      "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
      ,
      ,
      ,
      "5062345678",
      ,
      ,
      [10],
      [7]
    ], [, , "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", , , , "5062345678", , , [10], [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , [10]], [, , "900[2-9]\\d{6}", , , , "9002123456", , , [10]], [, , , , , , , , , [-1]], [
      ,
      ,
      "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
      ,
      ,
      ,
      "5002345678",
      ,
      ,
      [10]
    ], [, , "600[2-9]\\d{6}", , , , "6002012345", , , [10]], "CA", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "310\\d{4}", , , , "3101234", , , [7]], , , [, , , , , , , , , [-1]]],
    CC: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", , , , "891621234", , , [9], [8]], [
      ,
      ,
      "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
      ,
      ,
      ,
      "412345678",
      ,
      ,
      [9]
    ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CD: [, [
      ,
      ,
      "[189]\\d{8}|[1-68]\\d{6}",
      ,
      ,
      ,
      ,
      ,
      ,
      [7, 9]
    ], [, , "12\\d{7}|[1-6]\\d{6}", , , , "1234567"], [, , "88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}", , , , "991234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CF: [, [
      ,
      ,
      "(?:[27]\\d{3}|8776)\\d{4}",
      ,
      ,
      ,
      ,
      ,
      ,
      [8]
    ], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[024-7]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CG: [, [, , "222\\d{6}|(?:0\\d|80)\\d{7}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [
      ,
      ,
      "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
      ,
      ,
      ,
      "061234567"
    ], [, , , , , , , , , [-1]], [, , "80[0-2]\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CH: [
      ,
      [, , "8\\d{11}|[2-9]\\d{8}", , , , , , , [9, 12]],
      [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]],
      [, , "7[35-9]\\d{7}", , , , "781234567", , , [9]],
      [, , "800\\d{6}", , , , "800123456", , , [9]],
      [, , "90[016]\\d{6}", , , , "900123456", , , [9]],
      [, , "84[0248]\\d{6}", , , , "840123456", , , [9]],
      [, , "878\\d{6}", , , , "878123456", , , [9]],
      [, , , , , , , , , [-1]],
      "CH",
      41,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]],
      ,
      [, , "74[0248]\\d{6}", , , , "740123456", , , [9]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , "5[18]\\d{7}", , , , "581234567", , , [9]],
      ,
      ,
      [
        ,
        ,
        "860\\d{9}",
        ,
        ,
        ,
        "860123456789",
        ,
        ,
        [12]
      ]
    ],
    CI: [, [, , "[02]\\d{9}", , , , , , , [10]], [, , "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}", , , , "2123456789"], [, , "0[157]\\d{8}", , , , "0123456789"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CK: [, [
      ,
      ,
      "[2-578]\\d{4}",
      ,
      ,
      ,
      ,
      ,
      ,
      [5]
    ], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[578]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CL: [, [, , "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", , , , , , , [9, 10, 11]], [
      ,
      ,
      "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
      ,
      ,
      ,
      "221234567",
      ,
      ,
      [9]
    ], [, , "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", , , , "221234567", , , [9]], [, , "(?:123|8)00\\d{6}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [
      ,
      ,
      "600\\d{7,8}",
      ,
      ,
      ,
      "6001234567",
      ,
      ,
      [10, 11]
    ], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", , , , , , , 1, [[, "(\\d{4})", "$1", ["1(?:[03-589]|21)|[29]0|78"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [
      ,
      "(\\d{2})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],
      "($1)"
    ], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [[, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [
      ,
      "(\\d{3})(\\d{3})(\\d{3,4})",
      "$1 $2 $3",
      ["60|8"]
    ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , , , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CM: [, [, , "[26]\\d{8}|88\\d{6,7}", , , , , , , [8, 9]], [, , "2(?:22|33)\\d{6}", , , , "222123456", , , [9]], [, , "(?:24[23]|6[25-9]\\d)\\d{6}", , , , "671234567", , , [9]], [, , "88\\d{6,7}", , , , "88012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CM", 237, "00", , , , , , , , [[
      ,
      "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["88"]
    ], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CN: [, [, , "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [
      ,
      ,
      "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
      ,
      ,
      ,
      "1012345678",
      ,
      ,
      [7, 8, 9, 10, 11],
      [5, 6]
    ], [, , "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", , , , "13123456789", , , [11]], [, , "(?:(?:10|21)8|8)00\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [
      ,
      ,
      "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
      ,
      ,
      ,
      "4001234567",
      ,
      ,
      [7, 8, 9, 10, 11],
      [5, 6]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "00|1(?:[12]\\d|79)\\d\\d00", "0", , , "(1(?:[12]\\d|79)\\d\\d)|0", , "00", , [
      [, "(\\d{5,6})", "$1", ["10|96"]],
      [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1", "$CC $1"],
      [, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]", "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])", "1(?:0(?:[0-8]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])|6)|[3-9]"]],
      [, "(\\d{4})(\\d{4})", "$1 $2", ["16[08]"]],
      [
        ,
        "(\\d{3})(\\d{5,6})",
        "$1 $2",
        [
          "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
          "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
          "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
          "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
        ],
        "0$1",
        "$CC $1"
      ],
      [, "(\\d{4})(\\d{4})", "$1 $2", [
        "[1-9]",
        "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
        "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
        "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
      ]],
      [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
      [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1],
      [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
      [
        ,
        "(\\d{3})(\\d{7,8})",
        "$1 $2",
        ["9"]
      ],
      [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
      [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
      [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
      [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
    ], [
      [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1", "$CC $1"],
      [, "(\\d{3})(\\d{5,6})", "$1 $2", [
        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
      ], "0$1", "$CC $1"],
      [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
      [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],
        "0$1",
        "$CC $1",
        1
      ],
      [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
      [, "(\\d{3})(\\d{7,8})", "$1 $2", ["9"]],
      [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
      [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
      [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
      [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
    ], [, , , , , , , , , [-1]], , , [, , "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}", , , , , , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CO: [, [, , "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", , , , , , , [10, 11], [7]], [, , "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60[124-8][2-9]\\d{6}", , , , "6012345678", , , [10], [7]], [
      ,
      ,
      "3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
      ,
      ,
      ,
      "3211234567",
      ,
      ,
      [10]
    ], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "19(?:0[01]|4[78])\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0(4(?:[14]4|56)|[579])?", , , , [[, "(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1"]], [
      [, "(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)", "0$CC $1"],
      [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"], , "0$CC $1"],
      [, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1"]]
    ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CR: [, [, , "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", , , , , , , [8, 10]], [, , "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", , , , "22123456", , , [8]], [, , "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", , , , "83123456", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      "(?:210[0-6]|4\\d{3}|5100)\\d{4}",
      ,
      ,
      ,
      "40001234",
      ,
      ,
      [8]
    ], "CR", 506, "00", , , , "(19(?:0[0-2468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CU: [, [, , "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", , , , , , , [6, 7, 8, 10], [4, 5]], [, , "(?:3[23]|48)\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}", , , , "71234567", , , , [4, 5]], [, , "5\\d{7}", , , , "51234567", , , [8]], [
      ,
      ,
      "800\\d{7}",
      ,
      ,
      ,
      "8001234567",
      ,
      ,
      [10]
    ], [, , , , , , , , , [-1]], [, , "807\\d{7}", , , , "8071234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], [, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CV: [, [, , "(?:[2-59]\\d\\d|800)\\d{4}", , , , , , , [7]], [
      ,
      ,
      "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
      ,
      ,
      ,
      "2211234"
    ], [, , "(?:36|5[1-389]|9\\d)\\d{5}", , , , "9911234"], [, , "800\\d{4}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[3-5]|4[356])\\d{5}", , , , "3401234"], "CV", 238, "0", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CW: [, [, , "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", , , , , , , [7, 8]], [
      ,
      ,
      "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
      ,
      ,
      ,
      "94351234"
    ], [, , "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}", , , , "95181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], , [, , "955\\d{5}", , , , "95581234", , , [8]], 1, "[69]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    CX: [
      ,
      [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]],
      [
        ,
        ,
        "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
        ,
        ,
        ,
        "891641234",
        ,
        ,
        [9],
        [8]
      ],
      [, , "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]],
      [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
      [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
      [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
      [, , , , , , , , , [-1]],
      [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
      "CX",
      61,
      "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
      "0",
      ,
      ,
      "([59]\\d{7})$|0",
      "8$1",
      "0011",
      ,
      ,
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    CY: [, [, , "(?:[279]\\d|[58]0)\\d{6}", , , , , , , [8]], [, , "2[2-6]\\d{6}", , , , "22345678"], [, , "9(?:10|[4-79]\\d)\\d{5}", , , , "96123456"], [, , "800\\d{5}", , , , "80001234"], [, , "90[09]\\d{5}", , , , "90012345"], [, , "80[1-9]\\d{5}", , , , "80112345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "CY", 357, "00", , , , , , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:50|77)\\d{6}", , , , "77123456"], , , [, , , , , , , , , [-1]]],
    CZ: [, [, , "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]], [, , "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", , , , "212345678", , , [9]], [, , "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", , , , "601123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]], [, , "8[134]\\d{7}", , , , "811234567", , , [9]], [, , "70[01]\\d{6}", , , , "700123456", , , [9]], [, , "9[17]0\\d{6}", , , , "910123456", , , [9]], "CZ", 420, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [
      ,
      "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
      "$1 $2 $3 $4",
      ["96"]
    ], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "9(?:5\\d|7[2-4])\\d{6}", , , , "972123456", , , [9]], , , [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]],
    DE: [, [, , "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", , , , , , , [
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15
    ], [2, 3]], [
      ,
      ,
      "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
      ,
      ,
      ,
      "30123456",
      ,
      ,
      [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      [2, 3, 4]
    ], [, , "15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", , , , "9001234567", , , [10, 11]], [, , "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], "DE", 49, "00", "0", , , "0", , , , [
      [, "(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"],
      [
        ,
        "(\\d{3})(\\d{3,12})",
        "$1 $2",
        ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],
        "0$1"
      ],
      [
        ,
        "(\\d{4})(\\d{2,11})",
        "$1 $2",
        ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
        "0$1"
      ],
      [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
      [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
      [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
      [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
      [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
      [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
      [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
      [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
      [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
      [, "(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"],
      [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
      [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
      [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
      [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
      [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
    ], , [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [
      ,
      ,
      "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
      ,
      ,
      ,
      "177991234567",
      ,
      ,
      [12, 13]
    ]],
    DJ: [, [, , "(?:2\\d|77)\\d{6}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    DK: [, [, , "[2-9]\\d{7}", , , , , , , [8]], [, , "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}", , , , "32123456"], [
      ,
      ,
      "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",
      ,
      ,
      ,
      "32123456"
    ], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , 1, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    DM: [
      ,
      [, , "(?:[58]\\d\\d|767|900)\\d{7}", , , , , , , [10], [7]],
      [, , "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}", , , , "7674201234", , , , [7]],
      [, , "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}", , , , "7672251234", , , , [7]],
      [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
      [, , "900[2-9]\\d{6}", , , , "9002123456"],
      [, , , , , , , , , [-1]],
      [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
      [, , , , , , , , , [-1]],
      "DM",
      1,
      "011",
      "1",
      ,
      ,
      "([2-7]\\d{6})$|1",
      "767$1",
      ,
      ,
      ,
      ,
      [, , , , , , , , , [-1]],
      ,
      "767",
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    DO: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}", , , , "8092345678", , , , [7]], [, , "8[024]9[2-9]\\d{6}", , , , "8092345678", , , , [7]], [
      ,
      ,
      "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",
      ,
      ,
      ,
      "8002123456"
    ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DO", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "8001|8[024]9", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    DZ: [
      ,
      [, , "(?:[1-4]|[5-79]\\d|80)\\d{7}", , , , , , , [8, 9]],
      [, , "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}", , , , "12345678"],
      [, , "(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", , , , "551234567", , , [9]],
      [, , "800\\d{6}", , , , "800123456", , , [9]],
      [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]],
      [, , "80[12]1\\d{5}", , , , "801123456", , , [9]],
      [, , , , , , , , , [-1]],
      [, , "98[23]\\d{6}", , , , "983123456", , , [9]],
      "DZ",
      213,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [
        [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"],
        [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"],
        [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]
      ],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    EC: [
      ,
      [, , "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", , , , , , , [8, 9, 10, 11], [7]],
      [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]],
      [, , "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", , , , "991234567", , , [9]],
      [, , "1800\\d{7}|1[78]00\\d{6}", , , , "18001234567", , , [10, 11]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]],
      "EC",
      593,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]],
      [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    EE: [
      ,
      [, , "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", , , , , , , [7, 8, 10]],
      [
        ,
        ,
        "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
        ,
        ,
        ,
        "3212345",
        ,
        ,
        [7]
      ],
      [, , "(?:5\\d{5}|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-3679]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", , , , "51234567", , , [7, 8]],
      [, , "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}", , , , "80012345"],
      [, , "(?:40\\d\\d|900)\\d{4}", , , , "9001234", , , [7, 8]],
      [, , , , , , , , , [-1]],
      [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]],
      [, , , , , , , , , [-1]],
      "EE",
      372,
      "00",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , "800[2-9]\\d{3}", , , , , , , [7]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    EG: [, [
      ,
      ,
      "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
      ,
      ,
      ,
      ,
      ,
      ,
      [8, 9, 10],
      [6, 7]
    ], [, , "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", , , , "234567890", , , [8, 9], [6, 7]], [, , "1[0-25]\\d{8}", , , , "1001234567", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "EG", 20, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], [
      ,
      "(\\d{3})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["[189]"],
      "0$1"
    ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    EH: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "528[89]\\d{5}", , , , "528812345"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "592(?:4[0-2]|93)\\d{4}", , , , "592401234"], "EH", 212, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , "528[89]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    ER: [, [
      ,
      ,
      "[178]\\d{6}",
      ,
      ,
      ,
      ,
      ,
      ,
      [7],
      [6]
    ], [, , "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}", , , , "8370362", , , , [6]], [, , "(?:17[1-3]|7\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    ES: [, [, , "[5-9]\\d{8}", , , , , , , [9]], [
      ,
      ,
      "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
      ,
      ,
      ,
      "810123456"
    ], [, , "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}", , , , "612345678"], [, , "[89]00\\d{6}", , , , "800123456"], [, , "80[367]\\d{6}", , , , "803123456"], [, , "90[12]\\d{6}", , , , "901123456"], [, , "70\\d{7}", , , , "701234567"], [, , , , , , , , , [-1]], "ES", 34, "00", , , , , , , , [[, "(\\d{4})", "$1", ["905"]], [, "(\\d{6})", "$1", ["[79]9"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], [
      [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]],
      [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]
    ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "51\\d{7}", , , , "511234567"], , , [, , , , , , , , , [-1]]],
    ET: [, [, , "(?:11|[2-579]\\d)\\d{7}", , , , , , , [9], [7]], [
      ,
      ,
      "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
      ,
      ,
      ,
      "111112345",
      ,
      ,
      ,
      [7]
    ], [, , "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    FI: [
      ,
      [, , "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
      [
        ,
        ,
        "(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}",
        ,
        ,
        ,
        "131234567",
        ,
        ,
        [5, 6, 7, 8, 9]
      ],
      [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]],
      [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]],
      [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "FI",
      358,
      "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
      "0",
      ,
      ,
      "0",
      ,
      "00",
      ,
      [[, "(\\d{5})", "$1", ["75[12]"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{6})", "$1", ["11"]], [
        ,
        "(\\d{3})(\\d{3,7})",
        "$1 $2",
        ["[12]00|[368]|70[07-9]"],
        "0$1"
      ], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]],
      [[, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]],
      [, , , , , , , , , [-1]],
      1,
      "1[03-79]|[2-9]",
      [, , "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"],
      [, , "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}", , , , "10112345"],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    FJ: [
      ,
      [, , "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", , , , , , , [7, 11]],
      [, , "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]],
      [, , "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", , , , "7012345", , , [7]],
      [, , "0800\\d{7}", , , , "08001234567", , , [11]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "FJ",
      679,
      "0(?:0|52)",
      ,
      ,
      ,
      ,
      ,
      "00",
      ,
      [[, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    FK: [, [, , "[2-7]\\d{4}", , , , , , , [5]], [, , "[2-47]\\d{4}", , , , "31234"], [, , "[56]\\d{4}", , , , "51234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FK", 500, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    FM: [, [, , "(?:[39]\\d\\d|820)\\d{4}", , , , , , , [7]], [
      ,
      ,
      "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
      ,
      ,
      ,
      "3201234"
    ], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    FO: [, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[34]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d|9[16])\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [
      ,
      ,
      "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
      ,
      ,
      ,
      "901123"
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", , , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", ["[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    FR: [, [, , "[1-9]\\d{8}", , , , , , , [9]], [, , "(?:[1-35]\\d|4[1-9])\\d{7}", , , , "123456789"], [, , "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [
      ,
      ,
      "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
      ,
      ,
      ,
      "891123456"
    ], [, , "8(?:1[01]|2[0156]|4[02]|84)\\d{6}", , , , "884012345"], [, , , , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["10"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], , , [, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]],
    GA: [, [, , "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", , , , , , , [7, 8]], [, , "[01]1\\d{6}", , , , "01441234", , , [8]], [, , "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}", , , , "06031234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [
      ,
      "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["0"]
    ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    GB: [, [, , "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", , , , , , , [7, 9, 10], [4, 5, 6, 8]], [
      ,
      ,
      "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
      ,
      ,
      ,
      "1212345678",
      ,
      ,
      [9, 10],
      [4, 5, 6, 7, 8]
    ], [, , "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", , , , "7400123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [
      ,
      ,
      "56\\d{8}",
      ,
      ,
      ,
      "5612345678",
      ,
      ,
      [10]
    ], "GB", 44, "00", "0", " x", , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", [
      "[25]|7(?:0|6[02-9])",
      "[25]|7(?:0|6(?:[03-9]|2[356]))"
    ], "0$1"], [, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
    GD: [
      ,
      [, , "(?:473|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
      [
        ,
        ,
        "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
        ,
        ,
        ,
        "4732691234",
        ,
        ,
        ,
        [7]
      ],
      [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]],
      [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
      [, , "900[2-9]\\d{6}", , , , "9002123456"],
      [, , , , , , , , , [-1]],
      [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
      [, , , , , , , , , [-1]],
      "GD",
      1,
      "011",
      "1",
      ,
      ,
      "([2-9]\\d{6})$|1",
      "473$1",
      ,
      ,
      ,
      ,
      [, , , , , , , , , [-1]],
      ,
      "473",
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    GE: [, [, , "(?:[3-57]\\d\\d|800)\\d{6}", , , , , , , [9], [6, 7]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", , , , [6, 7]], [
      ,
      ,
      "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:00(?:0\\d|44|5[05]|77|88|99)|1(?:1(?:00|[124]\\d|3[01])|4\\d\\d)|(?:44|68)\\d\\d|5(?:[0157-9]\\d\\d|200)|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:070|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}",
      ,
      ,
      ,
      "555123456"
    ], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70[67]\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "70[67]\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    GF: [, [
      ,
      ,
      "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
      ,
      ,
      ,
      ,
      ,
      ,
      [9]
    ], [, , "594(?:[0239]\\d|[16][0-3]|4[03-9]|5[6-9]|80)\\d{4}", , , , "594101234"], [, , "694(?:[0-249]\\d|3[0-8])\\d{4}", , , , "694201234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:396|76\\d)\\d|476[0-2])\\d{4}", , , , "976012345"], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ]],
    GG: [, [, , "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", , , , , , , [7, 9, 10], [6]], [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]], [, , "7(?:(?:781|839)\\d|911[17])\\d{5}", , , , "7781123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GG", 44, "00", "0", , , "([25-9]\\d{5})$|0", "1481$1", , , , , [
      ,
      ,
      "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
      ,
      ,
      ,
      "7640123456",
      ,
      ,
      [10]
    ], , , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
    GH: [, [, , "(?:[235]\\d{3}|800)\\d{5}", , , , , , , [8, 9], [7]], [, , "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", , , , "302345678", , , [9], [7]], [, , "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", , , , "231234567", , , [9]], [
      ,
      ,
      "800\\d{5}",
      ,
      ,
      ,
      "80012345",
      ,
      ,
      [8]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|8[0-2]"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    GI: [, [, , "(?:[25]\\d|60)\\d{6}", , , , , , , [8]], [
      ,
      ,
      "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
      ,
      ,
      ,
      "20012345"
    ], [, , "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    GL: [, [, , "(?:19|[2-689]\\d|70)\\d{4}", , , , , , , [6]], [, , "(?:19|3[1-7]|6[14689]|70|8[14-79]|9\\d)\\d{4}", , , , "321000"], [, , "[245]\\d{5}", , , , "221234"], [, , "80\\d{4}", , , , "801234"], [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , , , , , , , , [-1]], [, , "3[89]\\d{4}", , , , "381234"], "GL", 299, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    GM: [
      ,
      [, , "[2-9]\\d{6}", , , , , , , [7]],
      [, , "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}", , , , "5661234"],
      [, , "(?:[23679]\\d|5[0-489])\\d{5}", , , , "3012345"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "GM",
      220,
      "00",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    GN: [, [, , "722\\d{6}|(?:3|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", , , , "30241234", , , [8]], [, , "6[0-356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "722\\d{6}", , , , "722123456", , , [9]], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [
      ,
      "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[67]"]
    ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    GP: [, [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [, , "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}", , , , "590201234"], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:395|76[018])\\d|475[0-2])\\d{4}", , , , "976012345"], "GP", 590, "00", "0", , , "0", , , , [[
      ,
      "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[569]"],
      "0$1"
    ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    GQ: [, [, , "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", , , , , , , [9]], [, , "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}", , , , "333091234"], [, , "(?:222|55\\d)\\d{6}", , , , "222123456"], [, , "80\\d[1-9]\\d{5}", , , , "800123456"], [, , "90\\d[1-9]\\d{5}", , , , "900123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GQ", 240, "00", , , , , , , , [[
      ,
      "(\\d{3})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["[235]"]
    ], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    GR: [, [, , "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", , , , , , , [10, 11, 12]], [
      ,
      ,
      "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
      ,
      ,
      ,
      "2123456789",
      ,
      ,
      [10]
    ], [, , "68[57-9]\\d{7}|(?:69|94)\\d{8}", , , , "6912345678", , , [10]], [, , "800\\d{7,9}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567", , , [10]], [, , "8(?:0[16]|12|[27]5|50)\\d{7}", , , , "8011234567", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], [
      ,
      "(\\d{3})(\\d{3,4})(\\d{5})",
      "$1 $2 $3",
      ["8"]
    ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5005000\\d{3}", , , , "5005000123", , , [10]], , , [, , , , , , , , , [-1]]],
    GT: [
      ,
      [, , "(?:1\\d{3}|[2-7])\\d{7}", , , , , , , [8, 11]],
      [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]],
      [, , "[3-5]\\d{7}", , , , "51234567", , , [8]],
      [, , "18[01]\\d{8}", , , , "18001112222", , , [11]],
      [, , "19\\d{9}", , , , "19001112222", , , [11]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "GT",
      502,
      "00",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    GU: [, [, , "(?:[58]\\d\\d|671|900)\\d{7}", , , , , , , [10], [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [
      ,
      ,
      "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
      ,
      ,
      ,
      "6713001234",
      ,
      ,
      ,
      [7]
    ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "([3-9]\\d{6})$|1", "671$1", , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], , , [, , , , , , , , , [-1]]],
    GW: [, [, , "[49]\\d{8}|4\\d{6}", , , , , , , [7, 9]], [, , "443\\d{6}", , , , "443201234", , , [9]], [, , "9(?:5\\d|6[569]|77)\\d{6}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    GY: [, [, , "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}", , , , , , , [7]], [
      ,
      ,
      "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}",
      ,
      ,
      ,
      "2201234"
    ], [, , "(?:6\\d\\d|70[0-35-7])\\d{4}", , , , "6091234"], [, , "(?:289|862)\\d{4}", , , , "2891234"], [, , "9008\\d{3}", , , , "9008123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GY", 592, "001", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    HK: [
      ,
      [, , "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", , , , , , , [
        5,
        6,
        7,
        8,
        9,
        11
      ]],
      [, , "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:[45][0-8]|6[01]|9\\d))|58(?:0[1-8]|1[2-9]))\\d{4}", , , , "21234567", , , [8]],
      [
        ,
        ,
        "(?:4(?:44[5-9]|6(?:0[0-7]|1[0-6]|4[0-57-9]|6[0-4]|7[0-8]))|573[0-6]|6(?:26[013-8]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|9(?:29[013-9]|59[0-4]))\\d{4}|(?:4(?:4[01]|6[2358])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
        ,
        ,
        ,
        "51234567",
        ,
        ,
        [8]
      ],
      [, , "800\\d{6}", , , , "800123456", , , [9]],
      [, , "900(?:[0-24-9]\\d{7}|3\\d{1,4})", , , , "90012345678", , , [5, 6, 7, 8, 11]],
      [, , , , , , , , , [-1]],
      [, , "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", , , , "81123456", , , [8]],
      [, , , , , , , , , [-1]],
      "HK",
      852,
      "00(?:30|5[09]|[126-9]?)",
      ,
      ,
      ,
      ,
      ,
      "00",
      ,
      [[, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]],
      ,
      [, , "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", , , , "71123456", , , [8]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    HN: [, [, , "8\\d{10}|[237-9]\\d{7}", , , , , , , [8, 11]], [
      ,
      ,
      "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
      ,
      ,
      ,
      "22123456",
      ,
      ,
      [8]
    ], [, , "[37-9]\\d{7}", , , , "91234567", , , [8]], [, , "8002\\d{7}", , , , "80021234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], [, , , , , , , , , [-1]], , , [, , "8002\\d{7}", , , , , , , [11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    HR: [, [, , "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", , , , , , , [6, 7, 8, 9]], [
      ,
      ,
      "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
      ,
      ,
      ,
      "12345678",
      ,
      ,
      [8, 9],
      [6, 7]
    ], [, , "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|77|9[67])))\\d{4}|98\\d{6}", , , , "921234567", , , [8, 9]], [, , "80[01]\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "6[01459]\\d{6}|6[01]\\d{4,5}", , , , "611234", , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [
      ,
      "(\\d)(\\d{4})(\\d{3})",
      "$1 $2 $3",
      ["1"],
      "0$1"
    ], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "62\\d{6,7}|72\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]],
    HT: [
      ,
      [, , "(?:[2-489]\\d|55)\\d{6}", , , , , , , [8]],
      [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"],
      [, , "(?:[34]\\d|55)\\d{6}", , , , "34101234"],
      [, , "8\\d{7}", , , , "80012345"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}", , , , "98901234"],
      "HT",
      509,
      "00",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    HU: [
      ,
      [, , "[235-7]\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9], [6, 7]],
      [, , "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6, 7]],
      [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]],
      [, , "(?:[48]0\\d|680[29])\\d{5}", , , , "80123456"],
      [, , "9[01]\\d{6}", , , , "90123456", , , [8]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , "21\\d{7}", , , , "211234567", , , [9]],
      "HU",
      36,
      "00",
      "06",
      ,
      ,
      "06",
      ,
      ,
      ,
      [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , "(?:[48]0\\d|680[29])\\d{5}"],
      [, , "38\\d{7}", , , , "381234567", , , [9]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    ID: [, [
      ,
      ,
      "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
      ,
      ,
      ,
      ,
      ,
      ,
      [7, 8, 9, 10, 11, 12, 13],
      [5, 6]
    ], [
      ,
      ,
      "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
      ,
      ,
      ,
      "218350123",
      ,
      ,
      [7, 8, 9, 10, 11],
      [5, 6]
    ], [, , "8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}", , , , "8001234567", , , [8, 9, 10, 11, 12, 13]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "00[89]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [
      ,
      "(\\d{3})(\\d{5,8})",
      "$1 $2",
      ["[2-79]"],
      "(0$1)"
    ], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["001"]], [, "(\\d{2})(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [
      ,
      "(\\d{2})(\\d{5,9})",
      "$1 $2",
      ["2[124]|[36]1"],
      "(0$1)"
    ], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "001803\\d{6,7}|(?:007803\\d|8071)\\d{6}", , , , , , , [10, 12, 13]], [
      ,
      ,
      "(?:1500|8071\\d{3})\\d{3}",
      ,
      ,
      ,
      "8071123456",
      ,
      ,
      [7, 10]
    ], , , [, , , , , , , , , [-1]]],
    IE: [, [, , "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", , , , , , , [7, 8, 9, 10], [5, 6]], [, , "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}", , , , "2212345", , , , [5, 6]], [, , "8(?:22|[35-9]\\d)\\d{6}", , , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "15(?:1[2-8]|[2-8]0|9[089])\\d{6}", , , , "1520123456", , , [10]], [
      ,
      ,
      "18[59]0\\d{6}",
      ,
      ,
      ,
      "1850123456",
      ,
      ,
      [10]
    ], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], [
      ,
      "(\\d{2})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["[78]"],
      "0$1"
    ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], [, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", , , , , , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", , , , "8551234567", , , [10]]],
    IL: [, [, , "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", , , , , , , [7, 8, 9, 10, 11, 12]], [
      ,
      ,
      "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
      ,
      ,
      ,
      "21234567",
      ,
      ,
      [8, 11, 12],
      [7]
    ], [, , "55410\\d{4}|5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-9]|3[0-3]|4[34]|5[015689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", , , , "502345678", , , [9]], [, , "1(?:255|80[019]\\d{3})\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", , , , "1919123456", , , [8, 10]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [
      ,
      ,
      "7(?:38(?:0\\d|5[09]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
      ,
      ,
      ,
      "771234567",
      ,
      ,
      [9]
    ], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "(\\d{4})(\\d{3})", "$1-$2", ["125"]], [, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], [, "(\\d{4})(\\d{6})", "$1-$2", ["159"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], [, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], , [, , , , , , , , , [-1]], , , [, , "1700\\d{6}", , , , , , , [10]], [
      ,
      ,
      "1599\\d{6}",
      ,
      ,
      ,
      "1599123456",
      ,
      ,
      [10]
    ], , , [, , "151\\d{8,9}", , , , "15112340000", , , [11, 12]]],
    IM: [
      ,
      [, , "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]],
      [, , "1624(?:230|[5-8]\\d\\d)\\d{3}", , , , "1624756789", , , , [6]],
      [, , "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"],
      [, , "808162\\d{4}", , , , "8081624567"],
      [, , "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}", , , , "9016247890"],
      [, , , , , , , , , [-1]],
      [, , "70\\d{8}", , , , "7012345678"],
      [, , "56\\d{8}", , , , "5612345678"],
      "IM",
      44,
      "00",
      "0",
      ,
      ,
      "([25-8]\\d{5})$|0",
      "1624$1",
      ,
      ,
      ,
      ,
      [, , , , , , , , , [-1]],
      ,
      "74576|(?:16|7[56])24",
      [, , , , , , , , , [-1]],
      [, , "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}", , , , "5512345678"],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    IN: [, [, , "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [
      ,
      ,
      "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
      ,
      ,
      ,
      "7410410123",
      ,
      ,
      [10],
      [6, 7, 8]
    ], [
      ,
      ,
      "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
      ,
      ,
      ,
      "8123456789",
      ,
      ,
      [10]
    ], [, , "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{7})", "$1", ["575"]], [, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [
      ,
      "(\\d{3})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["140"],
      ,
      ,
      1
    ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", , 1], [
      ,
      "(\\d{3})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      [
        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
      ],
      "0$1",
      ,
      1
    ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
      "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
      "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
      "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
    ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
      ,
      "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
      "$1 $2 $3 $4",
      ["0"]
    ], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [[, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], , , 1], [
      ,
      "(\\d{2})(\\d{4})(\\d{4})",
      "$1 $2 $3",
      ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
      "0$1",
      ,
      1
    ], [
      ,
      "(\\d{3})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      [
        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
      ],
      "0$1",
      ,
      1
    ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
      "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
      "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
      "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
    ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
      ,
      "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
      "$1 $2 $3 $4",
      ["18"],
      ,
      ,
      1
    ]], [, , , , , , , , , [-1]], , , [, , "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]],
    IO: [, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, , "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    IQ: [, [
      ,
      ,
      "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
      ,
      ,
      ,
      ,
      ,
      ,
      [8, 9, 10],
      [6, 7]
    ], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    IR: [
      ,
      [, , "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", , , , , , , [4, 5, 6, 7, 10], [8]],
      [, , "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}", , , , "2123456789", , , [6, 7, 10], [4, 5, 8]],
      [, , "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", , , , "9123456789", , , [10]],
      [, , , , , , , , , [-1]],
      [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "IR",
      98,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))", , , , , , , [4, 5, 10]],
      [
        ,
        ,
        "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
        ,
        ,
        ,
        "9601",
        ,
        ,
        [4, 5]
      ],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    IS: [, [, , "(?:38\\d|[4-9])\\d{6}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", , , , "4101234", , , [7]], [, , "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}", , , , "6111234"], [, , "80[0-8]\\d{4}", , , , "8001234", , , [7]], [
      ,
      ,
      "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
      ,
      ,
      ,
      "9001234",
      ,
      ,
      [7]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49[0-24-79]\\d{4}", , , , "4921234", , , [7]], "IS", 354, "00|1(?:0(?:01|[12]0)|100)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:689|8(?:7[18]|80)|95[48])\\d{4}", , , , "6891234", , , [7]]],
    IT: [, [, , "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [
      ,
      ,
      "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
      ,
      ,
      ,
      "0212345678",
      ,
      ,
      [6, 7, 8, 9, 10, 11]
    ], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [, , "80(?:0\\d{3}|3)\\d{3}", , , , "800123456", , , [6, 9]], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "IT", 39, "00", , , , , , , , [
      [, "(\\d{4,5})", "$1", ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]],
      [, "(\\d{6})", "$1", ["1(?:1|92)"]],
      [, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
      [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],
      [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
      [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]],
      [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
      [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]],
      [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]],
      [
        ,
        "(\\d{2})(\\d{4})(\\d{5})",
        "$1 $2 $3",
        ["0[26]"]
      ],
      [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
      [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]
    ], [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [
      ,
      "(\\d{3})(\\d{3})(\\d{3,4})",
      "$1 $2 $3",
      ["1(?:44|[679])|[378]"]
    ], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
    JE: [, [, , "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [
      ,
      ,
      "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}",
      ,
      ,
      ,
      "7797712345"
    ], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , , , , , , , , [-1]], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "([0-24-8]\\d{5})$|0", "1534$1", , , , , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [
      ,
      ,
      "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
      ,
      ,
      ,
      "5512345678"
    ], , , [, , , , , , , , , [-1]]],
    JM: [, [, , "(?:[58]\\d\\d|658|900)\\d{7}", , , , , , , [10], [7]], [, , "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[025-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", , , , "8765230123", , , , [7]], [
      ,
      ,
      "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
      ,
      ,
      ,
      "8762101234",
      ,
      ,
      ,
      [7]
    ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "658|876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ]],
    JO: [, [, , "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", , , , , , , [8, 9]], [
      ,
      ,
      "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
      ,
      ,
      ,
      "62001234",
      ,
      ,
      [8]
    ], [, , "7(?:[78][0-25-9]|9\\d)\\d{6}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "9\\d{7}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [
      ,
      ,
      "74(?:66|77)\\d{5}",
      ,
      ,
      ,
      "746612345",
      ,
      ,
      [9]
    ], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]],
    JP: [, [, , "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", , , , "312345678", , , [9]], [
      ,
      ,
      "[7-9]0[1-9]\\d{7}",
      ,
      ,
      ,
      "9012345678",
      ,
      ,
      [10]
    ], [, , "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}", , , , "120123456"], [, , "990\\d{6}", , , , "990123456", , , [9]], [, , , , , , , , , [-1]], [, , "60\\d{7}", , , , "601234567", , , [9]], [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]], "JP", 81, "010", "0", , , "0", , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077", "00777", "00777[01]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", [
      "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])",
      "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
      "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
    ], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [
      ,
      "(\\d)(\\d{4})(\\d{4})",
      "$1-$2-$3",
      ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],
      "0$1"
    ], [
      ,
      "(\\d{2})(\\d{3})(\\d{4})",
      "$1-$2-$3",
      [
        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
      ],
      "0$1"
    ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [
      ,
      "(\\d{4})(\\d{6})(\\d{6,7})",
      "$1-$2-$3",
      ["0"]
    ]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
      ,
      "(\\d{4})(\\d)(\\d{4})",
      "$1-$2-$3",
      ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
      "0$1"
    ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
      ,
      "(\\d{2})(\\d{3})(\\d{4})",
      "$1-$2-$3",
      [
        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
      ],
      "0$1"
    ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], [, , "20\\d{8}", , , , "2012345678", , , [10]], , , [, , "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"], [, , "570\\d{6}", , , , "570123456", , , [9]], , , [, , , , , , , , , [-1]]],
    KE: [, [, , "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", , , , , , , [7, 8, 9, 10]], [
      ,
      ,
      "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
      ,
      ,
      ,
      "202012345",
      ,
      ,
      [7, 8, 9]
    ], [, , "(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}", , , , "712123456", , , [9]], [, , "800[2-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    KG: [
      ,
      [
        ,
        ,
        "8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9, 10],
        [5, 6]
      ],
      [, , "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", , , , "312123456", , , [9], [5, 6]],
      [, , "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|99[05-9])\\d{6}", , , , "700123456", , , [9]],
      [, , "800\\d{6,7}", , , , "800123456"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "KG",
      996,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    KH: [
      ,
      [, , "1\\d{9}|[1-9]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]],
      [
        ,
        ,
        "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
        ,
        ,
        ,
        "23756789",
        ,
        ,
        [8, 9],
        [6, 7]
      ],
      [, , "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", , , , "91234567", , , [8, 9]],
      [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]],
      [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "KH",
      855,
      "00[14-9]",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    KI: [, [, , "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}", , , , "31234"], [
      ,
      ,
      "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
      ,
      ,
      ,
      "72001234",
      ,
      ,
      [8]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", , , , "30010000", , , [8]], "KI", 686, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    KM: [, [, , "[3478]\\d{6}", , , , , , , [7], [4]], [, , "7[4-7]\\d{5}", , , , "7712345", , , , [4]], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[
      ,
      "(\\d{3})(\\d{2})(\\d{2})",
      "$1 $2 $3",
      ["[3478]"]
    ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    KN: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
      ,
      ,
      "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
      ,
      ,
      ,
      "5002345678"
    ], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "([2-7]\\d{6})$|1", "869$1", , , , , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    KP: [, [, , "85\\d{6}|(?:19\\d|[2-7])\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}", , , , "21234567", , , , [6, 7]], [, , "19[1-3]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[
      ,
      "(\\d{2})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["8"],
      "0$1"
    ], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    KR: [, [, , "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [
      ,
      ,
      "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
      ,
      ,
      ,
      "22123456",
      ,
      ,
      [5, 6, 8, 9, 10],
      [3, 4, 7]
    ], [, , "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", , , , "1020000000", , , [9, 10]], [, , "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8,9}", , , , "5012345678", , , [10, 11]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "0", , , "0(8(?:[1-46-8]|5\\d\\d))?", , , , [[
      ,
      "(\\d{5})",
      "$1",
      ["1[016-9]1", "1[016-9]11", "1[016-9]114"],
      "0$1"
    ], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030"]], [
      ,
      "(\\d{2})(\\d{5})(\\d{4})",
      "$1-$2-$3",
      ["5"],
      "0$1",
      "0$CC-$1"
    ], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [
      [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"],
      [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]],
      [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"],
      [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"],
      [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"],
      [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"],
      [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"]
    ], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})", , , , , , , [11, 12, 13, 14]], [, , "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[168]|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]],
    KW: [, [, , "18\\d{5}|(?:[2569]\\d|41)\\d{6}", , , , , , , [7, 8]], [, , "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", , , , "22345678", , , [8]], [
      ,
      ,
      "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
      ,
      ,
      ,
      "50012345",
      ,
      ,
      [8]
    ], [, , "18\\d{5}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    KY: [, [, , "(?:345|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
      ,
      ,
      "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",
      ,
      ,
      ,
      "3452221234",
      ,
      ,
      ,
      [7]
    ], [, , "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "(?:345976|900[2-9]\\d\\d)\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [
      ,
      ,
      "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
      ,
      ,
      ,
      "5002345678"
    ], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "([2-9]\\d{6})$|1", "345$1", , , , , [, , "345849\\d{4}", , , , "3458491234"], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    KZ: [, [, , "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", , , , , , , [10, 14], [5, 6, 7]], [
      ,
      ,
      "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
      ,
      ,
      ,
      "7123456789",
      ,
      ,
      [10],
      [5, 6, 7]
    ], [, , "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", , , , "7710009998", , , [10]], [, , "8(?:00|108\\d{3})\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , "751\\d{7}", , , , "7511234567", , , [10]], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , "33|7", [, , "751\\d{7}", , , , , , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    LA: [, [, , "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", , , , , , , [8, 9, 10], [6]], [
      ,
      ,
      "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
      ,
      ,
      ,
      "21212862",
      ,
      ,
      [8],
      [6]
    ], [, , "(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}", , , , "2023123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "30[013-9]\\d{6}", , , , "301234567", , , [9]], , , [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ]],
    LB: [, [, , "[27-9]\\d{7}|[13-9]\\d{6}", , , , , , , [7, 8]], [, , "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}", , , , "1123456"], [, , "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[
      ,
      "(\\d)(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
      "0$1"
    ], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    LC: [
      ,
      [, , "(?:[58]\\d\\d|758|900)\\d{7}", , , , , , , [10], [7]],
      [, , "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}", , , , "7584305678", , , , [7]],
      [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}", , , , "7582845678", , , , [7]],
      [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
      [, , "900[2-9]\\d{6}", , , , "9002123456"],
      [, , , , , , , , , [-1]],
      [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
      [, , , , , , , , , [-1]],
      "LC",
      1,
      "011",
      "1",
      ,
      ,
      "([2-8]\\d{6})$|1",
      "758$1",
      ,
      ,
      ,
      ,
      [, , , , , , , , , [-1]],
      ,
      "758",
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    LI: [, [, , "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", , , , , , , [7, 9]], [
      ,
      ,
      "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
      ,
      ,
      ,
      "2345678",
      ,
      ,
      [7]
    ], [, , "(?:6(?:(?:4[5-9]|5[0-4])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}", , , , "660234567"], [, , "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}", , , , "8002222"], [, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", , , , "9002222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "(1001)|0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [
      ,
      "(\\d{2})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["69"],
      ,
      "$CC $1"
    ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d\\d", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]],
    LK: [, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}", , , , "112345678", , , , [7]], [, , "7(?:[0-25-8]\\d|4[0-4])\\d{6}", , , , "712345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , , , , , , , , [-1]], "LK", 94, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "1973\\d{5}", , , , "197312345"], , , [, , , , , , , , , [-1]]],
    LR: [, [, , "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", , , , , , , [7, 8, 9]], [, , "2\\d{7}", , , , "21234567", , , [8]], [, , "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [
      ,
      ,
      "332(?:02|[34]\\d)\\d{4}",
      ,
      ,
      ,
      "332021234",
      ,
      ,
      [9]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    LS: [, [, , "(?:[256]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    LT: [, [, , "(?:[3469]\\d|52|[78]0)\\d{6}", , , , , , , [8]], [, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"], [, , "6\\d{7}", , , , "61234567"], [, , "80[02]\\d{5}", , , , "80012345"], [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , "70[05]\\d{5}", , , , "70012345"], [, , "[89]01\\d{5}", , , , "80123456"], "LT", 370, "00", "8", , , "[08]", , , , [[
      ,
      "(\\d)(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["52[0-7]"],
      "(8-$1)",
      ,
      1
    ], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", , 1], [, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", , 1], [, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70[67]\\d{5}", , , , "70712345"], , , [, , , , , , , , , [-1]]],
    LU: [, [, , "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11]], [
      ,
      ,
      "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
      ,
      ,
      ,
      "27123456"
    ], [, , "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [, , "20(?:1\\d{5}|[2-689]\\d{1,7})", , , , "20201234", , , [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [
      ,
      "(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3",
      ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
      ,
      "$CC $1"
    ], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [
      ,
      "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
      "$1 $2 $3 $4",
      ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],
      ,
      "$CC $1"
    ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    LV: [, [, , "(?:[268]\\d|90)\\d{6}", , , , , , , [8]], [, , "6\\d{7}", , , , "63123456"], [, , "23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[
      ,
      "(\\d{2})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["[269]|8[01]"]
    ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    LY: [
      ,
      [, , "[2-9]\\d{8}", , , , , , , [9], [7]],
      [, , "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}", , , , "212345678", , , , [7]],
      [, , "9[1-6]\\d{7}", , , , "912345678"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "LY",
      218,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    MA: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}", , , , "520123456"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , "592(?:4[0-2]|93)\\d{4}", , , , "592401234"], "MA", 212, "00", "0", , , "0", , , , [[, "(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[1289]|389)", "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], [, "(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], [, "(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MC: [, [, , "(?:[3489]|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "(?:870|9[2-47-9]\\d)\\d{5}", , , , "99123456", , , [8]], [, , "4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}", , , , "612345678"], [, , "(?:800|90\\d)\\d{5}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MC", 377, "00", "0", , , "0", , , , [
      [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["87"]],
      [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"],
      [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]],
      [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]
    ], [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "8[07]0\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MD: [
      ,
      [, , "(?:[235-7]\\d|[89]0)\\d{6}", , , , , , , [8]],
      [, , "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"],
      [, , "562\\d{5}|(?:6\\d|7[16-9])\\d{6}", , , , "62112345"],
      [, , "800\\d{5}", , , , "80012345"],
      [, , "90[056]\\d{5}", , , , "90012345"],
      [, , "808\\d{5}", , , , "80812345"],
      [, , , , , , , , , [-1]],
      [, , "3[08]\\d{6}", , , , "30123456"],
      "MD",
      373,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , "803\\d{5}", , , , "80312345"],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    ME: [, [, , "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", , , , , , , [8, 9], [6]], [
      ,
      ,
      "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
      ,
      ,
      ,
      "30234567",
      ,
      ,
      [8],
      [6]
    ], [, , "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", , , , "67622901", , , [8]], [, , "80(?:[0-2578]|9\\d)\\d{5}", , , , "80080002"], [, , "9(?:4[1568]|5[178])\\d{5}", , , , "94515151", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780", , , [8]], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012", , , [8]], , , [, , , , , , , , , [-1]]],
    MF: [, [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [
      ,
      ,
      "590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}",
      ,
      ,
      ,
      "590271234"
    ], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:395|76[018])\\d|475[0-2])\\d{4}", , , , "976012345"], "MF", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MG: [, [, , "[23]\\d{8}", , , , , , , [9], [7]], [, , "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}", , , , "202123456", , , , [7]], [, , "3[2-47-9]\\d{7}", , , , "321234567"], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "22\\d{7}", , , , "221234567"], "MG", 261, "00", "0", , , "([24-9]\\d{6})$|0", "20$1", , , [[, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MH: [, [, , "329\\d{4}|(?:[256]\\d|45)\\d{5}", , , , , , , [7]], [, , "(?:247|45[78]|528|625)\\d{4}", , , , "2471234"], [, , "(?:(?:23|54)5|329|45[356])\\d{4}", , , , "2351234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      "635\\d{4}",
      ,
      ,
      ,
      "6351234"
    ], "MH", 692, "011", "1", , , "1", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MK: [, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", , , , "22012345", , , , [6, 7]], [
      ,
      ,
      "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
      ,
      ,
      ,
      "72345678"
    ], [, , "800\\d{5}", , , , "80012345"], [, , "5\\d{7}", , , , "50012345"], [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MK", 389, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    ML: [, [, , "[24-9]\\d{7}", , , , , , , [8]], [
      ,
      ,
      "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
      ,
      ,
      ,
      "20212345"
    ], [, , "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}", , , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MM: [
      ,
      [, , "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", , , , , , , [6, 7, 8, 9, 10], [5]],
      [
        ,
        ,
        "(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:(?:3\\d|8[01459])\\d|4[67]0)))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
        ,
        ,
        ,
        "1234567",
        ,
        ,
        [6, 7, 8, 9],
        [5]
      ],
      [, , "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", , , , "92123456", , , [7, 8, 9, 10]],
      [, , "80080(?:0[1-9]|2\\d)\\d{3}", , , , "8008001234", , , [10]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , "1333\\d{4}|[12]468\\d{4}", , , , "13331234", , , [8]],
      "MM",
      95,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{3})",
        "$1 $2 $3",
        ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],
        "0$1"
      ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [, "(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [, "(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]],
      ,
      [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    MN: [, [, , "[12]\\d{7,9}|[5-9]\\d{7}", , , , , , , [8, 9, 10], [4, 5, 6]], [, , "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}", , , , "53123456", , , , [4, 5, 6]], [, , "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}", , , , "88123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      "712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}",
      ,
      ,
      ,
      "75123456",
      ,
      ,
      [8]
    ], "MN", 976, "001", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MO: [, [, , "0800\\d{3}|(?:28|[68]\\d)\\d{6}", , , , , , , [7, 8]], [
      ,
      ,
      "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
      ,
      ,
      ,
      "28212345",
      ,
      ,
      [8]
    ], [, , "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", , , , "66123456", , , [8]], [, , "0800\\d{3}", , , , "0800501", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , [[, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MP: [, [, , "[58]\\d{9}|(?:67|90)0\\d{7}", , , , , , , [10], [7]], [
      ,
      ,
      "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
      ,
      ,
      ,
      "6702345678",
      ,
      ,
      ,
      [7]
    ], [, , "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
      ,
      ,
      "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
      ,
      ,
      ,
      "5002345678"
    ], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "([2-9]\\d{6})$|1", "670$1", , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MQ: [
      ,
      [, , "596\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
      [, , "596(?:[03-7]\\d|10|2[7-9]|8[09]|9[4-9])\\d{4}", , , , "596301234"],
      [, , "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}", , , , "696201234"],
      [, , "80[0-5]\\d{6}", , , , "800012345"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , "9(?:397[01]|477[0-2]|76(?:6\\d|7[0-367]))\\d{4}", , , , "976612345"],
      "MQ",
      596,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    MR: [, [, , "(?:[2-4]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "(?:25[08]|35\\d|45[1-7])\\d{5}", , , , "35123456"], [, , "[2-4][0-46-9]\\d{6}", , , , "22123456"], [, , "800\\d{5}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MR", 222, "00", , , , , , , , [[
      ,
      "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[2-48]"]
    ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MS: [, [, , "(?:[58]\\d\\d|664|900)\\d{7}", , , , , , , [10], [7]], [, , "6644(?:1[0-3]|91)\\d{4}", , , , "6644912345", , , , [7]], [, , "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
      ,
      ,
      "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
      ,
      ,
      ,
      "5002345678"
    ], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "([34]\\d{6})$|1", "664$1", , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MT: [, [, , "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}", , , , "96961234"], [, , "800(?:02|[3467]\\d)\\d{3}", , , , "80071234"], [
      ,
      ,
      "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
      ,
      ,
      ,
      "50037123"
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], , [, , "7117\\d{4}", , , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]],
    MU: [, [, , "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", , , , , , , [7, 8, 10]], [, , "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-7])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", , , , "54480123", , , [7, 8]], [
      ,
      ,
      "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-2]|3[013]))\\d{5}",
      ,
      ,
      ,
      "52512345",
      ,
      ,
      [8]
    ], [, , "802\\d{7}|80[0-2]\\d{4}", , , , "8001234", , , [7, 10]], [, , "30\\d{5}", , , , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[24-7]0|3[03])", , , , , , "020", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], [, "(\\d{5})(\\d{5})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MV: [, [, , "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", , , , , , , [7, 10]], [
      ,
      ,
      "(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
      ,
      ,
      ,
      "6701234",
      ,
      ,
      [7]
    ], [, , "(?:46[46]|[79]\\d\\d)\\d{4}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "4(?:0[01]|50)\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]],
    MW: [, [, , "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", , , , , , , [7, 9]], [
      ,
      ,
      "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
      ,
      ,
      ,
      "1234567"
    ], [, , "111\\d{6}|(?:31|77|[89][89])\\d{7}", , , , "991234567", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MW", 265, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    MX: [
      ,
      [
        ,
        ,
        "1(?:(?:[27]2|44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [10, 11],
        [7, 8]
      ],
      [, , "657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}", , , , "2001234567", , , [10], [7, 8]],
      [
        ,
        ,
        "657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",
        ,
        ,
        ,
        "12221234567",
        ,
        ,
        ,
        [7, 8]
      ],
      [, , "8(?:00|88)\\d{7}", , , , "8001234567", , , [10]],
      [, , "900\\d{7}", , , , "9001234567", , , [10]],
      [, , "300\\d{7}", , , , "3001234567", , , [10]],
      [, , "500\\d{7}", , , , "5001234567", , , [10]],
      [, , , , , , , , , [-1]],
      "MX",
      52,
      "0[09]",
      "01",
      ,
      ,
      "0(?:[12]|4[45])|1",
      ,
      "00",
      ,
      [[, "(\\d{5})", "$1", ["53"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], , , 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], , , 1], [
        ,
        "(\\d)(\\d{3})(\\d{3})(\\d{4})",
        "$2 $3 $4",
        ["1"],
        ,
        ,
        1
      ]],
      [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], , , 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], , , 1], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], , , 1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    MY: [, [, , "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [
      ,
      ,
      "(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
      ,
      ,
      ,
      "323856789",
      ,
      ,
      [8, 9],
      [6, 7]
    ], [, , "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-6]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", , , , "123456789", , , [9, 10]], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
      ,
      ,
      ,
      "1546012345",
      ,
      ,
      [10]
    ], "MY", 60, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], , , [, , , , , , , , , [-1]]],
    MZ: [, [, , "(?:2|8\\d)\\d{7}", , , , , , , [8, 9]], [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]], [, , "8[2-79]\\d{7}", , , , "821234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MZ", 258, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    NA: [, [
      ,
      ,
      "[68]\\d{7,8}",
      ,
      ,
      ,
      ,
      ,
      ,
      [8, 9]
    ], [, , "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}", , , , "61221234"], [, , "(?:60|8[1245])\\d{7}", , , , "811234567", , , [9]], [, , "80\\d{7}", , , , "800123456", , , [9]], [
      ,
      ,
      "8701\\d{5}",
      ,
      ,
      ,
      "870123456",
      ,
      ,
      [9]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d\\d|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    NC: [, [, , "(?:050|[2-57-9]\\d\\d)\\d{3}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [
      ,
      ,
      "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",
      ,
      ,
      ,
      "751234"
    ], [, , "050\\d{3}", , , , "050012"], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{3})", "$1", ["5[6-8]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    NE: [, [, , "[027-9]\\d{7}", , , , , , , [8]], [
      ,
      ,
      "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
      ,
      ,
      ,
      "20201234"
    ], [, , "(?:23|7[047]|[89]\\d)\\d{6}", , , , "93123456"], [, , "08\\d{6}", , , , "08123456"], [, , "09\\d{6}", , , , "09123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NE", 227, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    NF: [, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}", , , , "106609", , , , [5]], [
      ,
      ,
      "(?:14|3[58])\\d{4}",
      ,
      ,
      ,
      "381234",
      ,
      ,
      ,
      [5]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , "([0-258]\\d{4})$", "3$1", , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], [, "(\\d)(\\d{5})", "$1 $2", ["[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    NG: [, [, , "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", , , , , , , [7, 8, 10, 11, 12, 13, 14], [5, 6]], [
      ,
      ,
      "(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}",
      ,
      ,
      ,
      "18040123",
      ,
      ,
      [7, 8],
      [5, 6]
    ], [, , "(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}", , , , "8021234567", , , [10]], [, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NG", 234, "009", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], [
      ,
      "(\\d{3})(\\d{3})(\\d{3,4})",
      "$1 $2 $3",
      ["[7-9]"],
      "0$1"
    ], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "700\\d{7,11}", , , , "7001234567", , , [10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]]],
    NI: [, [, , "(?:1800|[25-8]\\d{3})\\d{4}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [, , "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}", , , , "81234567"], [, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    NL: [, [, , "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", , , , , , , [5, 6, 7, 8, 9, 10, 11]], [
      ,
      ,
      "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
      ,
      ,
      ,
      "101234567",
      ,
      ,
      [9]
    ], [, , "(?:6[1-58]|970\\d)\\d{7}", , , , "612345678", , , [9, 11]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:85|91)\\d{7}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["1[238]|[34]"]], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [
      ,
      "(\\d{3})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
      "0$1"
    ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [
      ,
      "(\\d{3})(\\d{3})(\\d{5})",
      "$1 $2 $3",
      ["9"],
      "0$1"
    ]], [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d", , , , , , , [5, 6]], [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", , , , "14020", , , [5, 6, 9]], , , [, , , , , , , , , [-1]]],
    NO: [, [, , "(?:0|[2-9]\\d{3})\\d{4}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [
      ,
      ,
      "(?:4[015-8]|59|9\\d)\\d{6}",
      ,
      ,
      ,
      "40612345",
      ,
      ,
      [8]
    ], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], , [, , , , , , , , , [-1]], 1, "[02-689]|7[0-8]", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
      ,
      ,
      "81[23]\\d{5}",
      ,
      ,
      ,
      "81212345",
      ,
      ,
      [8]
    ]],
    NP: [, [, , "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", , , , , , , [8, 10, 11], [6, 7]], [, , "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", , , , "14567890", , , [8], [6, 7]], [, , "9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}", , , , "9841234567", , , [10]], [, , "1(?:66001|800\\d\\d)\\d{5}", , , , "16600101234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [
      ,
      "(\\d{2})(\\d{6})",
      "$1-$2",
      ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],
      "0$1"
    ], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]], [, "(\\d{4})(\\d{2})(\\d{5})", "$1-$2-$3", ["1"]]], [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    NR: [, [, , "(?:444|(?:55|8\\d)\\d|666)\\d{4}", , , , , , , [7]], [, , "444\\d{4}", , , , "4441234"], [, , "(?:55[3-9]|666|8\\d\\d)\\d{4}", , , , "5551234"], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NR", 674, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    NU: [, [, , "(?:[47]|888\\d)\\d{3}", , , , , , , [4, 7]], [, , "[47]\\d{3}", , , , "7012", , , [4]], [, , "888[4-9]\\d{3}", , , , "8884012", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NU", 683, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], , , [, , , , , , , , , [-1]]],
    NZ: [, [, , "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", , , , "32345678", , , [8], [7]], [, , "2[0-27-9]\\d{7,8}|2(?:1\\d|75)\\d{5}", , , , "211234567", , , [8, 9, 10]], [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456", , , [8, 9, 10]], [, , "(?:11\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", , , , "900123456", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [
      ,
      ,
      "70\\d{7}",
      ,
      ,
      ,
      "701234567",
      ,
      ,
      [9]
    ], [, , , , , , , , , [-1]], "NZ", 64, "0(?:0|161)", "0", , , "0", , "00", , [[, "(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], , [
      ,
      ,
      "[28]6\\d{6,7}",
      ,
      ,
      ,
      "26123456",
      ,
      ,
      [8, 9]
    ], , , [, , , , , , , , , [-1]], [, , "8(?:1[6-9]|22|3\\d|4[045]|5[459]|7[0-3579]|90)\\d{2,7}", , , , "83012378"], , , [, , , , , , , , , [-1]]],
    OM: [, [, , "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", , , , , , , [7, 8, 9]], [, , "2[1-6]\\d{6}", , , , "23123456", , , [8]], [, , "1505\\d{4}|(?:7(?:[1289]\\d|69|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}", , , , "92123456", , , [8]], [, , "8007\\d{4,5}|(?:500|800[05])\\d{4}", , , , "80071234"], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "OM", 968, "00", , , , , , , , [[
      ,
      "(\\d{3})(\\d{4,6})",
      "$1 $2",
      ["[58]"]
    ], [, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    PA: [, [, , "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", , , , , , , [7, 8, 10, 11]], [
      ,
      ,
      "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
      ,
      ,
      ,
      "2001234",
      ,
      ,
      [7]
    ], [, , "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", , , , "61234567", , , [7, 8]], [, , "800\\d{4,5}|(?:00800|800\\d)\\d{6}", , , , "8001234"], [, , "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    PE: [, [
      ,
      ,
      "(?:[14-8]|9\\d)\\d{7}",
      ,
      ,
      ,
      ,
      ,
      ,
      [8, 9],
      [6, 7]
    ], [, , "(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "00|19(?:1[124]|77|90)00", "0", " Anexo ", , "0", , "00", , [[
      ,
      "(\\d{3})(\\d{5})",
      "$1 $2",
      ["80"],
      "(0$1)"
    ], [, "(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    PF: [
      ,
      [, , "4\\d{5}(?:\\d{2})?|8\\d{7,8}", , , , , , , [6, 8, 9]],
      [, , "4(?:0[4-689]|9[4-68])\\d{5}", , , , "40412345", , , [8]],
      [, , "8[7-9]\\d{6}", , , , "87123456", , , [8]],
      [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , "499\\d{5}", , , , "49901234", , , [8]],
      "PF",
      689,
      "00",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , "44\\d{4}", , , , , , , [6]],
      [, , "44\\d{4}", , , , "440123", , , [6]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    PG: [, [, , "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", , , , , , , [7, 8]], [, , "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", , , , "3123456", , , [7]], [, , "(?:7\\d|8[128])\\d{6}", , , , "70123456", , , [8]], [
      ,
      ,
      "180\\d{4}",
      ,
      ,
      ,
      "1801234",
      ,
      ,
      [7]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-57]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "00|140[1-3]", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], , [, , "27[01]\\d{4}", , , , "2700123", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    PH: [, [, , "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [
      ,
      ,
      "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
      ,
      ,
      ,
      "232345678",
      ,
      ,
      [6, 8, 9, 10],
      [4, 5, 7]
    ], [, , "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [
      ,
      "(\\d{4})(\\d{4,6})",
      "$1 $2",
      ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
      "(0$1)"
    ], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    PK: [, [
      ,
      ,
      "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
      ,
      ,
      ,
      ,
      ,
      ,
      [8, 9, 10, 11, 12],
      [5, 6, 7]
    ], [, , "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", , , , "2123456789", , , [9, 10], [5, 6, 7, 8]], [, , "3(?:[0-24]\\d|3[0-7]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}(?:\\d{3})?", , , , "80012345", , , [8, 11]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [
      ,
      ,
      "122\\d{6}",
      ,
      ,
      ,
      "122044444",
      ,
      ,
      [9]
    ], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [
      ,
      "(\\d{3})(\\d{6,7})",
      "$1 $2",
      ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
      "(0$1)"
    ], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
      ,
      ,
      "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
      ,
      ,
      ,
      "21111825888",
      ,
      ,
      [11, 12]
    ], , , [, , , , , , , , , [-1]]],
    PL: [, [, , "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [, , "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", , , , "123456789", , , [7, 9]], [, , "21(?:1(?:[145]\\d|3[1-5])|2[0-4]\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [
      ,
      ,
      "801\\d{6}",
      ,
      ,
      ,
      "801234567",
      ,
      ,
      [9]
    ], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [
      [, "(\\d{5})", "$1", ["19"]],
      [, "(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]],
      [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],
      [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]],
      [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],
      [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]],
      [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]
    ], , [, , "64\\d{4,7}", , , , "641234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]],
    PM: [, [, , "[45]\\d{5}|(?:708|80\\d)\\d{6}", , , , , , , [6, 9]], [, , "(?:4[1-356]|50)\\d{4}", , , , "430123", , , [6]], [, , "(?:4[02-4]|5[056]|708[45][0-5])\\d{4}", , , , "551234"], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], "PM", 508, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    PR: [, [, , "(?:[589]\\d\\d|787)\\d{7}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
      ,
      ,
      "900[2-9]\\d{6}",
      ,
      ,
      ,
      "9002345678"
    ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    PS: [, [, , "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", , , , , , , [8, 9, 10], [7]], [
      ,
      ,
      "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
      ,
      ,
      ,
      "22234567",
      ,
      ,
      [8],
      [7]
    ], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    PT: [
      ,
      [, , "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", , , , , , , [9]],
      [, , "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}", , , , "212345678"],
      [, , "6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}", , , , "912345678"],
      [, , "80[02]\\d{6}", , , , "800123456"],
      [, , "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}", , , , "760123456"],
      [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"],
      [, , "884[0-4689]\\d{5}", , , , "884123456"],
      [, , "30\\d{7}", , , , "301234567"],
      "PT",
      351,
      "00",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["2[12]"]
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]],
      ,
      [, , "6222\\d{5}", , , , "622212345"],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}", , , , "707123456"],
      ,
      ,
      [, , "600\\d{6}|6[06]9233\\d{3}", , , , "600110000"]
    ],
    PW: [, [, , "(?:[24-8]\\d\\d|345|900)\\d{4}", , , , , , , [7]], [, , "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}", , , , "2771234"], [, , "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}", , , , "6201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PW", 680, "01[12]", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    PY: [, [, , "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [
      ,
      ,
      "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
      ,
      ,
      ,
      "212345678",
      ,
      ,
      [7, 8, 9],
      [5, 6]
    ], [, , "9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , "9800\\d{5,7}", , , , "98000123456", , , [9, 10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], [
      ,
      "(\\d{2})(\\d{3})(\\d{3,4})",
      "$1 $2 $3",
      ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
      "(0$1)"
    ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]]],
    QA: [, [, , "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", , , , , , , [7, 8, 9, 11]], [
      ,
      ,
      "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
      ,
      ,
      ,
      "44123456",
      ,
      ,
      [8]
    ], [, , "[35-7]\\d{7}", , , , "33123456", , , [8]], [, , "800\\d{4}|(?:0080[01]|800)\\d{6}", , , , "8001234", , , [7, 9, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], , [, , "2[16]\\d{5}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    RE: [, [, , "(?:26|[689]\\d)\\d{7}", , , , , , , [9]], [, , "26(?:2\\d\\d|3(?:0\\d|1[0-3]))\\d{4}", , , , "262161234"], [
      ,
      ,
      "(?:69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|6[0-6]|7[0-27]|8[0-8]|9[0-479]))|9(?:399[0-3]|479[0-2]|76(?:2[27]|3[0-37]|9\\d)))\\d{4}",
      ,
      ,
      ,
      "692123456"
    ], [, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RE", 262, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    RO: [, [, , "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", , , , , , , [6, 9]], [, , "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d", , , , "211234567"], [
      ,
      ,
      "7020\\d{5}|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-29])\\d{6}",
      ,
      ,
      ,
      "712034567",
      ,
      ,
      [9]
    ], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[0136]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
      ,
      ,
      "(?:37\\d|80[578])\\d{6}",
      ,
      ,
      ,
      "372123456",
      ,
      ,
      [9]
    ], , , [, , , , , , , , , [-1]]],
    RS: [, [, , "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", , , , , , , [6, 7, 8, 9, 10, 11, 12], [4, 5]], [, , "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", , , , "10234567", , , [7, 8, 9, 10, 11, 12], [4, 5, 6]], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [, , "800\\d{3,9}", , , , "80012345"], [, , "(?:78\\d|90[0169])\\d{3,7}", , , , "90012345", , , [6, 7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], "RS", 381, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], [, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]],
    RU: [, [, , "8\\d{13}|[347-9]\\d{9}", , , , , , , [10, 14], [7]], [, , "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", , , , "3011234567", , , [10], [7]], [
      ,
      ,
      "9\\d{9}",
      ,
      ,
      ,
      "9123456789",
      ,
      ,
      [10]
    ], [, , "8(?:0[04]|108\\d{3})\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[0-79]"]], [, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [
      ,
      "(\\d{5})(\\d)(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
      "8 ($1)",
      ,
      1
    ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [
      ,
      "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
      "$1 $2 $3 $4",
      ["8"],
      "8 ($1)"
    ]], [[, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [
      ,
      "(\\d{5})(\\d)(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
      "8 ($1)",
      ,
      1
    ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [, , , , , , , , , [-1]], 1, "3[04-689]|[489]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    RW: [, [, , "(?:06|[27]\\d\\d|[89]00)\\d{6}", , , , , , , [8, 9]], [, , "(?:06|2[23568]\\d)\\d{6}", , , , "250123456"], [, , "7[2389]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
      ,
      ,
      "900\\d{6}",
      ,
      ,
      ,
      "900123456",
      ,
      ,
      [9]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    SA: [, [, , "92\\d{7}|(?:[15]|8\\d)\\d{8}", , , , , , , [9, 10], [7]], [, , "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", , , , "112345678", , , [9], [7]], [
      ,
      ,
      "579[01]\\d{5}|5(?:[013-689]\\d|7[0-35-8])\\d{6}",
      ,
      ,
      ,
      "512345678",
      ,
      ,
      [9]
    ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "925\\d{6}", , , , "925012345", , , [9]], [, , "920\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["9"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
      ,
      ,
      "811\\d{7}",
      ,
      ,
      ,
      "8110123456",
      ,
      ,
      [10]
    ], , , [, , , , , , , , , [-1]]],
    SB: [
      ,
      [, , "(?:[1-6]|[7-9]\\d\\d)\\d{4}", , , , , , , [5, 7]],
      [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]],
      [, , "48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}", , , , "7421234"],
      [, , "1[38]\\d{3}", , , , "18123", , , [5]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , "5[12]\\d{3}", , , , "51123", , , [5]],
      "SB",
      677,
      "0[01]",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[, "(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    SC: [, [, , "800\\d{4}|(?:[249]\\d|64)\\d{5}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[125-8]\\d{5}", , , , "2510123"], [, , "800[08]\\d{3}", , , , "8000000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "971\\d{4}|(?:64|95)\\d{5}", , , , "6412345"], "SC", 248, "010|0[0-2]", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    SD: [, [, , "[19]\\d{8}", , , , , , , [9]], [
      ,
      ,
      "1(?:5\\d|8[35-7])\\d{6}",
      ,
      ,
      ,
      "153123456"
    ], [, , "(?:1[0-2]|9[0-3569])\\d{7}", , , , "911231234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    SE: [, [, , "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", , , , , , , [6, 7, 8, 9, 10, 12]], [
      ,
      ,
      "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
      ,
      ,
      ,
      "8123456",
      ,
      ,
      [7, 8, 9]
    ], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77[0-7]\\d{6}", , , , "771234567", , , [9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1"], [
      ,
      "(\\d{2})(\\d{3})(\\d{2})",
      "$1-$2 $3",
      ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
      "0$1"
    ], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1"], [
      ,
      "(\\d)(\\d{3})(\\d{3})(\\d{2})",
      "$1-$2 $3 $4",
      ["8"],
      "0$1"
    ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1"]], [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["9(?:00|39|44|9)"]], [, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [
      ,
      "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["8"]
    ], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["10|7"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [
      ,
      "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]
    ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "10[1-8]\\d{6}", , , , "102345678", , , [9]], , , [, , "(?:25[245]|67[3-68])\\d{9}", , , , "254123456789", , , [12]]],
    SG: [, [, , "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", , , , , , , [8, 10, 11]], [
      ,
      ,
      "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
      ,
      ,
      ,
      "61234567",
      ,
      ,
      [8]
    ], [, , "8(?:06[0-689]|95[0-2])\\d{4}|(?:8(?:0[1-5]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}", , , , "81234567", , , [8]], [, , "(?:18|8)00\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[12]\\d|666)\\d{5}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [
      [, "(\\d{4,5})", "$1", ["1[013-9]|77", "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]],
      [, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-6]|[1-9])"]],
      [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]],
      [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]],
      [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]
    ], [[, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-6]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]],
    SH: [, [, , "(?:[256]\\d|8)\\d{3}", , , , , , , [4, 5]], [, , "2(?:[0-57-9]\\d|6[4-9])\\d\\d", , , , "22158"], [
      ,
      ,
      "[56]\\d{4}",
      ,
      ,
      ,
      "51234",
      ,
      ,
      [5]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "262\\d\\d", , , , "26212", , , [5]], "SH", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], 1, "[256]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    SI: [
      ,
      [, , "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", , , , , , , [5, 6, 7, 8]],
      [, , "(?:[1-357][2-8]|4[24-8])\\d{6}", , , , "12345678", , , [8], [7]],
      [, , "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", , , , "31234567", , , [8]],
      [, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 8]],
      [, , "89[1-3]\\d{2,5}|90\\d{4,6}", , , , "90123456"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", , , , "59012345", , , [8]],
      "SI",
      386,
      "00|10(?:22|66|88|99)",
      "0",
      ,
      ,
      "0",
      ,
      "00",
      ,
      [[, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    SJ: [, [, , "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}", , , , , , , [5, 8]], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|59|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "79", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
      ,
      ,
      "81[23]\\d{5}",
      ,
      ,
      ,
      "81212345",
      ,
      ,
      [8]
    ]],
    SK: [
      ,
      [, , "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", , , , , , , [6, 7, 9]],
      [, , "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d", , , , "221234567"],
      [, , "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", , , , "912123456", , , [9]],
      [, , "800\\d{6}", , , , "800123456", , , [9]],
      [, , "9(?:00|[78]\\d)\\d{6}", , , , "900123456", , , [9]],
      [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]],
      [, , , , , , , , , [-1]],
      [, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]],
      "SK",
      421,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]],
      [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", [
        "[3-5][1-8]1",
        "[3-5][1-8]1[67]"
      ], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]],
      [, , "9090\\d{3}", , , , "9090123", , , [7]],
      ,
      ,
      [, , "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}", , , , , , , [7, 9]],
      [, , "96\\d{7}", , , , "961234567", , , [9]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    SL: [, [, , "(?:[237-9]\\d|66)\\d{6}", , , , , , , [8], [6]], [, , "22[2-4][2-9]\\d{4}", , , , "22221234", , , , [6]], [
      ,
      ,
      "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",
      ,
      ,
      ,
      "25123456"
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    SM: [, [, , "(?:0549|[5-7]\\d)\\d{6}", , , , , , , [8, 10], [6]], [, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]], [, , "6[16]\\d{6}", , , , "66661212", , , [8]], [, , , , , , , , , [-1]], [, , "7[178]\\d{6}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      "5[158]\\d{6}",
      ,
      ,
      ,
      "58001110",
      ,
      ,
      [8]
    ], "SM", 378, "00", , , , "([89]\\d{5})$", "0549$1", , , [[, "(\\d{6})", "$1", ["[89]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    SN: [, [, , "(?:[378]\\d|93)\\d{7}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [
      ,
      ,
      "7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}",
      ,
      ,
      ,
      "701234567"
    ], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", , , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    SO: [, [, , "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", , , , , , , [6, 7, 8, 9]], [
      ,
      ,
      "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
      ,
      ,
      ,
      "4012345",
      ,
      ,
      [6, 7]
    ], [, , "(?:(?:15|(?:3[59]|4[89]|6\\d|79|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [
      [, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]],
      [, "(\\d{6})", "$1", ["[134]"]],
      [, "(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],
      [, "(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]],
      [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]],
      [, "(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|9[2-9]"]]
    ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    SR: [, [, , "(?:[2-5]|68|[78]\\d)\\d{5}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}", , , , "211234"], [, , "(?:7[124-7]|8[124-9])\\d{5}", , , , "7412345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "56\\d{4}", , , , "561234", , , [6]], "SR", 597, "00", , , , , , , , [[
      ,
      "(\\d{2})(\\d{2})(\\d{2})",
      "$1-$2-$3",
      ["56"]
    ], [, "(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    SS: [, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1[89]\\d{7}", , , , "181234567"], [, , "(?:12|9[1257-9])\\d{7}", , , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    ST: [, [, , "(?:22|9\\d)\\d{5}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}", , , , "9812345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    SV: [, [, , "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", , , , , , , [7, 8, 11]], [, , "2(?:(?:[1-6]\\d\\d|990)\\d|790[034]|890[0245])\\d{3}", , , , "21234567", , , [8]], [
      ,
      ,
      "66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}",
      ,
      ,
      ,
      "70123456",
      ,
      ,
      [8]
    ], [, , "800\\d{4}(?:\\d{4})?", , , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    SX: [
      ,
      [, , "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
      [
        ,
        ,
        "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
        ,
        ,
        ,
        "7215425678",
        ,
        ,
        ,
        [7]
      ],
      [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]],
      [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
      [, , "900[2-9]\\d{6}", , , , "9002123456"],
      [, , , , , , , , , [-1]],
      [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
      [, , , , , , , , , [-1]],
      "SX",
      1,
      "011",
      "1",
      ,
      ,
      "(5\\d{6})$|1",
      "721$1",
      ,
      ,
      ,
      ,
      [, , , , , , , , , [-1]],
      ,
      "721",
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    SY: [, [, , "[1-39]\\d{8}|[1-5]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}", , , , "112345678", , , , [6, 7]], [, , "9[1-689]\\d{7}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", , 1], [
      ,
      "(\\d{3})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["9"],
      "0$1",
      ,
      1
    ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    SZ: [, [, , "0800\\d{4}|(?:[237]\\d|900)\\d{6}", , , , , , , [8, 9]], [, , "[23][2-5]\\d{6}", , , , "22171234", , , [8]], [, , "7[6-9]\\d{6}", , , , "76123456", , , [8]], [, , "0800\\d{4}", , , , "08001234", , , [8]], [, , "900\\d{6}", , , , "900012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70\\d{6}", , , , "70012345", , , [8]], "SZ", 268, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["9"]]], , [, , , , , , , , , [-1]], , , [, , "0800\\d{4}", , , , , , , [8]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], , , [, , , , , , , , , [-1]]],
    TA: [, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    TC: [, [, , "(?:[58]\\d\\d|649|900)\\d{7}", , , , , , , [10], [7]], [, , "649(?:266|712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]], [, , "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}", , , , "6492311234", , , , [7]], [
      ,
      ,
      "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
      ,
      ,
      ,
      "8002345678"
    ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "649(?:71[01]|966)\\d{4}", , , , "6497101234", , , , [7]], "TC", 1, "011", "1", , , "([2-479]\\d{6})$|1", "649$1", , , , , [, , , , , , , , , [-1]], , "649", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    TD: [, [, , "(?:22|[69]\\d|77)\\d{6}", , , , , , , [8]], [, , "22(?:[37-9]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:6[0235689]|77|9\\d)\\d{6}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", , , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    TG: [, [, , "[279]\\d{7}", , , , , , , [8]], [, , "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}", , , , "22212345"], [
      ,
      ,
      "(?:7[019]|9[0-36-9])\\d{6}",
      ,
      ,
      ,
      "90112345"
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    TH: [, [, , "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", , , , , , , [8, 9, 10, 13]], [, , "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [, , "671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", , , , "812345678", , , [9]], [
      ,
      ,
      "(?:001800\\d|1800)\\d{6}",
      ,
      ,
      ,
      "1800123456",
      ,
      ,
      [10, 13]
    ], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00[1-9]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    TJ: [
      ,
      [, , "[0-57-9]\\d{8}", , , , , , , [9], [3, 5, 6, 7]],
      [
        ,
        ,
        "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
        ,
        ,
        ,
        "372123456",
        ,
        ,
        ,
        [3, 5, 6, 7]
      ],
      [, , "41[18]\\d{6}|(?:0[0-27]|1[017]|2[02]|[34]0|5[05]|7[0178]|8[078]|9\\d)\\d{7}", , , , "917123456"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "TJ",
      992,
      "810",
      ,
      ,
      ,
      ,
      ,
      "8~10",
      ,
      [[, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"]], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    TK: [, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    TL: [, [, , "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", , , , , , , [7, 8]], [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]], [, , "7[2-8]\\d{6}", , , , "77212345", , , [8]], [, , "80\\d{5}", , , , "8012345", , , [7]], [
      ,
      ,
      "90\\d{5}",
      ,
      ,
      ,
      "9012345",
      ,
      ,
      [7]
    ], [, , , , , , , , , [-1]], [, , "70\\d{5}", , , , "7012345", , , [7]], [, , , , , , , , , [-1]], "TL", 670, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    TM: [
      ,
      [, , "[1-6]\\d{7}", , , , , , , [8]],
      [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"],
      [, , "6\\d{7}", , , , "66123456"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "TM",
      993,
      "810",
      "8",
      ,
      ,
      "8",
      ,
      "8~10",
      ,
      [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    TN: [
      ,
      [, , "[2-57-9]\\d{7}", , , , , , , [8]],
      [, , "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}", , , , "30010123"],
      [, , "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}", , , , "20123456"],
      [, , "8010\\d{4}", , , , "80101234"],
      [, , "88\\d{6}", , , , "88123456"],
      [, , "8[12]10\\d{4}", , , , "81101234"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "TN",
      216,
      "00",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    TO: [, [, , "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", , , , , , , [5, 7]], [, , "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", , , , "20123", , , [5]], [
      ,
      ,
      "(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
      ,
      ,
      ,
      "7715123",
      ,
      ,
      [7]
    ], [, , "0800\\d{3}", , , , "0800222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "55[0-37-9]\\d{4}", , , , "5510123", , , [7]], "TO", 676, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    TR: [, [, , "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", , , , , , , [7, 10, 12, 13]], [
      ,
      ,
      "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
      ,
      ,
      ,
      "2123456789",
      ,
      ,
      [10]
    ], [, , "56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", , , , "5012345678", , , [10]], [, , "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", , , , "8001234567", , , [10, 12, 13]], [, , "(?:8[89]8|900)\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , "592(?:21[12]|461)\\d{4}", , , , "5922121234", , , [10]], [, , "850\\d{7}", , , , "8500123456", , , [10]], "TR", 90, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [
      ,
      "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"],
      "0$1",
      ,
      1
    ], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1], [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1], [
      ,
      "(\\d{3})(\\d{3})(\\d{6,7})",
      "$1 $2 $3",
      ["80"],
      "0$1",
      ,
      1
    ]], [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "(?:444|811\\d{3})\\d{4}", , , , , , , [7, 10]], [, , "444\\d{4}", , , , "4441444", , , [7]], , , [, , , , , , , , , [-1]]],
    TT: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [, , "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}", , , , "8682911234", , , , [7]], [
      ,
      ,
      "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
      ,
      ,
      ,
      "8002345678"
    ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "([2-46-8]\\d{6})$|1", "868$1", , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]],
    TV: [, [
      ,
      ,
      "(?:2|7\\d\\d|90)\\d{4}",
      ,
      ,
      ,
      ,
      ,
      ,
      [5, 6, 7]
    ], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:7[01]\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2"]], [, "(\\d{2})(\\d{4})", "$1 $2", ["90"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    TW: [, [, , "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", , , , , , , [7, 8, 9, 10, 11]], [
      ,
      ,
      "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
      ,
      ,
      ,
      "221234567",
      ,
      ,
      [8, 9]
    ], [, , "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}|800\\d{5}", , , , "800123456", , , [8, 9]], [, , "20(?:[013-9]\\d\\d|2)\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", , , , "7012345678", , , [10, 11]], "TW", 886, "0(?:0[25-79]|19)", "0", "#", , "0", , , , [[, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], [
      ,
      "(\\d)(\\d{3,4})(\\d{4})",
      "$1 $2 $3",
      ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],
      "0$1"
    ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]],
    TZ: [, [, , "(?:[25-8]\\d|41|90)\\d{7}", , , , , , , [9]], [, , "2[2-8]\\d{7}", , , , "222345678"], [, , "77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}", , , , "621234567"], [, , "80[08]\\d{6}", , , , "800123456"], [
      ,
      ,
      "90\\d{7}",
      ,
      ,
      ,
      "900123456"
    ], [, , "8(?:40|6[01])\\d{6}", , , , "840123456"], [, , , , , , , , , [-1]], [, , "41\\d{7}", , , , "412345678"], "TZ", 255, "00[056]", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["5"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    UA: [, [, , "[89]\\d{9}|[3-9]\\d{8}", , , , , , , [9, 10], [5, 6, 7]], [
      ,
      ,
      "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
      ,
      ,
      ,
      "311234567",
      ,
      ,
      [9],
      [5, 6, 7]
    ], [, , "(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}", , , , "501234567", , , [9]], [, , "800[1-8]\\d{5,6}", , , , "800123456"], [, , "900[239]\\d{5,6}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567", , , [9]], "UA", 380, "00", "0", , , "0", , "0~0", , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], [
      ,
      "(\\d{4})(\\d{5})",
      "$1 $2",
      ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],
      "0$1"
    ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    UG: [, [, , "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", , , , , , , [9], [5, 6, 7]], [
      ,
      ,
      "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
      ,
      ,
      ,
      "312345678",
      ,
      ,
      ,
      [5, 6, 7]
    ], [, , "726[01]\\d{5}|7(?:[01578]\\d|20|36|[46][0-4]|9[89])\\d{6}", , , , "712345678"], [, , "800[1-3]\\d{5}", , , , "800123456"], [, , "90[1-3]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    US: [, [
      ,
      ,
      "[2-9]\\d{9}|3\\d{6}",
      ,
      ,
      ,
      ,
      ,
      ,
      [10],
      [7]
    ], [
      ,
      ,
      "5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
      ,
      ,
      ,
      "2015550123",
      ,
      ,
      ,
      [7]
    ], [
      ,
      ,
      "5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
      ,
      ,
      ,
      "2015550123",
      ,
      ,
      ,
      [7]
    ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "US", 1, "011", "1", , , "1", , , 1, [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [
      ,
      "(\\d{3})(\\d{4})",
      "$1-$2",
      ["[24-9]|3(?:[02-9]|1[1-9])"]
    ], [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], , , 1]], [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    UY: [, [, , "(?:0004|4)\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", , , , , , , [7, 8, 10, 13]], [, , "(?:1(?:770|987)|(?:2\\d|4[2-7])\\d\\d)\\d{4}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [
      ,
      ,
      "(?:(?:0004|4)\\d{5}|80[05])\\d{4}|405\\d{4}",
      ,
      ,
      ,
      "8001234",
      ,
      ,
      [7, 10, 13]
    ], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ", , "0", , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    UZ: [, [
      ,
      ,
      "(?:33|[5-79]\\d|88)\\d{7}",
      ,
      ,
      ,
      ,
      ,
      ,
      [9]
    ], [, , "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}", , , , "669050123"], [
      ,
      ,
      "(?:(?:33|50|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
      ,
      ,
      ,
      "912345678"
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    VA: [, [, , "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , "06698\\d{1,6}", , , , "0669812345", , , [6, 7, 8, 9, 10, 11]], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [
      ,
      ,
      "80(?:0\\d{3}|3)\\d{3}",
      ,
      ,
      ,
      "800123456",
      ,
      ,
      [6, 9]
    ], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "06698", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
    VC: [
      ,
      [, , "(?:[58]\\d\\d|784|900)\\d{7}", , , , , , , [10], [7]],
      [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]],
      [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}", , , , "7844301234", , , , [7]],
      [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
      [, , "900[2-9]\\d{6}", , , , "9002345678"],
      [, , , , , , , , , [-1]],
      [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ],
      [, , "78451[0-2]\\d{4}", , , , "7845101234", , , , [7]],
      "VC",
      1,
      "011",
      "1",
      ,
      ,
      "([2-7]\\d{6})$|1",
      "784$1",
      ,
      ,
      ,
      ,
      [, , , , , , , , , [-1]],
      ,
      "784",
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    VE: [
      ,
      [, , "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", , , , , , , [10], [7]],
      [, , "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}", , , , "2121234567", , , , [7]],
      [, , "4(?:1[24-8]|2[46])\\d{7}", , , , "4121234567"],
      [, , "800\\d{7}", , , , "8001234567"],
      [, , "90[01]\\d{7}", , , , "9001234567"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "VE",
      58,
      "00",
      "0",
      ,
      ,
      "0",
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1", "$CC $1"]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , "501\\d{7}", , , , "5010123456", , , , [7]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    VG: [, [, , "(?:284|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}", , , , "2842291234", , , , [7]], [, , "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
      ,
      ,
      "900[2-9]\\d{6}",
      ,
      ,
      ,
      "9002345678"
    ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "([2-578]\\d{6})$|1", "284$1", , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    VI: [, [, , "[58]\\d{9}|(?:34|90)0\\d{7}", , , , , , , [10], [7]], [
      ,
      ,
      "340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
      ,
      ,
      ,
      "3406421234",
      ,
      ,
      ,
      [7]
    ], [, , "340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [
      ,
      ,
      "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
      ,
      ,
      ,
      "5002345678"
    ], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "([2-9]\\d{6})$|1", "340$1", , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    VN: [, [, , "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", , , , , , , [7, 8, 9, 10]], [, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", , , , "2101234567", , , [10]], [, , "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", , , , "912345678", , , [9]], [
      ,
      ,
      "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
      ,
      ,
      ,
      "1800123456",
      ,
      ,
      [8, 9, 10]
    ], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "672\\d{6}", , , , "672012345", , , [9]], "VN", 84, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", , 1], [
      ,
      "(\\d{2})(\\d{4})(\\d{4})",
      "$1 $2 $3",
      ["2[48]"],
      "0$1",
      ,
      1
    ], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [[, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , , , , [7, 8]], [
      ,
      ,
      "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
      ,
      ,
      ,
      "1992000",
      ,
      ,
      [7, 8]
    ], , , [, , , , , , , , , [-1]]],
    VU: [
      ,
      [, , "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", , , , , , , [5, 7]],
      [, , "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", , , , "22123", , , [5]],
      [, , "(?:[58]\\d|7[013-7])\\d{5}", , , , "5912345", , , [7]],
      [, , "81[18]\\d\\d", , , , "81123", , , [5]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , "9(?:0[1-9]|1[01])\\d{4}", , , , "9010123", , , [7]],
      "VU",
      678,
      "00",
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [[, "(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , "(?:3[03]|900\\d)\\d{3}", , , , "30123"],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    WF: [, [, , "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", , , , , , , [6, 9]], [, , "72\\d{4}", , , , "721234", , , [6]], [, , "(?:72|8[23])\\d{4}", , , , "821234", , , [6]], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234", , , [6]]],
    WS: [, [
      ,
      ,
      "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
      ,
      ,
      ,
      ,
      ,
      ,
      [5, 6, 7, 10]
    ], [, , "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", , , , "22123", , , [5, 6]], [, , "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", , , , "7212345", , , [7, 10]], [, , "800\\d{3}", , , , "800123", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WS", 685, "0", , , , , , , , [[, "(\\d{5})", "$1", ["[2-5]|6[1-9]"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    XK: [, [, , "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", , , , , , , [
      8,
      9
    ]], [, , "(?:2[89]|39)0\\d{6}|[23][89]\\d{6}", , , , "28012345"], [, , "4[3-9]\\d{6}", , , , "43201234", , , [8]], [, , "800\\d{5}", , , , "80001234", , , [8]], [, , "900\\d{5}", , , , "90001234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "XK", 383, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    YE: [, [
      ,
      ,
      "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
      ,
      ,
      ,
      ,
      ,
      ,
      [7, 8, 9],
      [6]
    ], [, , "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", , , , "1234567", , , [7, 8], [6]], [, , "7[01378]\\d{7}", , , , "712345678", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YE", 967, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    YT: [, [
      ,
      ,
      "(?:(?:(?:26|63)9|80\\d)\\d|9398)\\d{5}",
      ,
      ,
      ,
      ,
      ,
      ,
      [9]
    ], [, , "269(?:0[0-467]|5[0-3]|6\\d|[78]0)\\d{4}", , , , "269601234"], [, , "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|9398[01])\\d{4}", , , , "639012345"], [, , "80\\d{7}", , , , "801234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YT", 262, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , "269|63|9398", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    ZA: [, [, , "[1-79]\\d{8}|8\\d{4,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [
      ,
      ,
      "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
      ,
      ,
      ,
      "101234567",
      ,
      ,
      [9]
    ], [, , "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", , , , "711234567", , , [5, 6, 7, 8, 9]], [, , "80\\d{7}", , , , "801234567", , , [9]], [, , "(?:86[2-9]|9[0-2]\\d)\\d{6}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [
      ,
      ,
      "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
      ,
      ,
      ,
      "871234567",
      ,
      ,
      [9]
    ], "ZA", 27, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6,7}", , , , "861123456", , , [9, 10]], , , [, , , , , , , , , [-1]]],
    ZM: [, [, , "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", , , , , , , [9], [6]], [
      ,
      ,
      "21[1-8]\\d{6}",
      ,
      ,
      ,
      "211234567",
      ,
      ,
      ,
      [6]
    ], [, , "(?:7[5-79]|9[5-8])\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "63\\d{7}", , , , "630123456"], "ZM", 260, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[1-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ]],
    ZW: [, [, , "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [
      ,
      ,
      "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
      ,
      ,
      ,
      "1312345",
      ,
      ,
      ,
      [3, 4]
    ], [, , "7(?:[178]\\d|3[1-9])\\d{6}", , , , "712345678", , , [9]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [
      [, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"],
      [, "(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"],
      [, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
      [, "(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"],
      [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
      [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"],
      [, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"],
      [
        ,
        "(\\d{2})(\\d{3,5})",
        "$1 $2",
        ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
        "0$1"
      ],
      [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"],
      [, "(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]
    ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    800: [
      ,
      [, , "(?:00|[1-9]\\d)\\d{6}", , , , , , , [8]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , "(?:00|[1-9]\\d)\\d{6}", , , , "12345678"],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      "001",
      800,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      1,
      [[, "(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]],
      ,
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]],
      [, , , , , , , , , [-1]],
      ,
      ,
      [, , , , , , , , , [-1]]
    ],
    808: [, [, , "[1-9]\\d{7}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1-9]\\d{7}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    870: [, [, , "7\\d{11}|[35-7]\\d{8}", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    878: [, [, , "10\\d{10}", , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    881: [, [, , "[0-36-9]\\d{8}", , , , , , , [9]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , "[0-36-9]\\d{8}", , , , "612345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 881, , , , , , , , , [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    882: [, [, , "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", , , , "3421234", , , [7, 8, 9, 10, 12]], [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["49"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], [, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], [
      ,
      "(\\d{2})(\\d{4})(\\d{4})",
      "$1 $2 $3",
      ["10|23|3(?:[15]|4[57])|4|51"]
    ], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]],
    883: [, [, , "(?:[1-4]\\d|51)\\d{6,10}", , , , , , , [8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
      ,
      ,
      ,
      "510012345"
    ], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
    888: [, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      [-1]
    ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], , , [, , , , , , , , , [-1]]],
    979: [, [, , "[1359]\\d{8}", , , , , , , [9], [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1359]\\d{8}", , , , "123456789", , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]
  };
  function de() {
    this.g = {};
  }
  de.i = void 0, de.g = function() {
    return de.i ? de.i : de.i = new de();
  };
  var ce = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "０": "0", "１": "1", "２": "2", "３": "3", "４": "4", "５": "5", "６": "6", "７": "7", "８": "8", "９": "9", "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4", "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9", "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4", "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9" }, ye = {
    0: "0",
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    "０": "0",
    "１": "1",
    "２": "2",
    "３": "3",
    "４": "4",
    "５": "5",
    "６": "6",
    "７": "7",
    "８": "8",
    "９": "9",
    "٠": "0",
    "١": "1",
    "٢": "2",
    "٣": "3",
    "٤": "4",
    "٥": "5",
    "٦": "6",
    "٧": "7",
    "٨": "8",
    "٩": "9",
    "۰": "0",
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
    A: "2",
    B: "2",
    C: "2",
    D: "3",
    E: "3",
    F: "3",
    G: "4",
    H: "4",
    I: "4",
    J: "5",
    K: "5",
    L: "5",
    M: "6",
    N: "6",
    O: "6",
    P: "7",
    Q: "7",
    R: "7",
    S: "7",
    T: "8",
    U: "8",
    V: "8",
    W: "9",
    X: "9",
    Y: "9",
    Z: "9"
  }, De = RegExp("^[+＋]+"), ze = RegExp("([0-9０-９٠-٩۰-۹])"), be = RegExp("[+＋0-9０-９٠-٩۰-۹]"), Ne = /[\\\/] *x/, rt = RegExp("[^0-9０-９٠-٩۰-۹A-Za-z#]+$"), Ke = /(?:.*?[A-Za-z]){3}.*/, Ze = RegExp("^\\+([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*[0-9０-９٠-٩۰-۹]([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*$"), Xe = RegExp("^([A-Za-z0-9０-９٠-٩۰-۹]+((\\-)*[A-Za-z0-9０-９٠-٩۰-۹])*\\.)*[A-Za-z]+((\\-)*[A-Za-z0-9０-９٠-٩۰-۹])*\\.?$");
  function Ee(a) {
    return "([0-9０-９٠-٩۰-۹]{1," + a + "})";
  }
  function qe() {
    return ";ext=" + Ee("20") + "|[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*" + (Ee("20") + "#?|[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*") + (Ee("9") + "#?|[- ]+") + (Ee("6") + "#|[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*") + (Ee("15") + "#?|[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*") + (Ee("9") + "#?");
  }
  var Je = new RegExp("(?:" + qe() + ")$", "i"), Ge = new RegExp("^[0-9０-９٠-٩۰-۹]{2}$|^[+＋]*(?:[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～*]*[0-9０-９٠-٩۰-۹]){3,}[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～*A-Za-z0-9０-９٠-٩۰-۹]*(?:" + qe() + ")?$", "i"), lt = /(\$\d)/;
  function Te(a) {
    return 2 > a.length ? !1 : we(Ge, a);
  }
  function Ye(a) {
    return we(Ke, a) ? Se(a, ye) : Se(a, ce);
  }
  function nt(a) {
    var c = Ye(a.toString());
    a.i = "", a.g(c);
  }
  function Qe(a) {
    return a != null && (v(a, 9) != 1 || g(a, 9)[0] != -1);
  }
  function Se(a, c) {
    for (var I = new H(), x, D = a.length, O = 0; O < D; ++O)
      x = a.charAt(O), x = c[x.toUpperCase()], x != null && I.g(x);
    return I.toString();
  }
  function Me(a) {
    return a != null && isNaN(a) && a.toUpperCase() in le;
  }
  function it(a, c, I) {
    if (F(c, 2) == 0 && c.g[5] != null) {
      var x = Z(c, 5);
      if (0 < x.length)
        return x;
    }
    x = Z(c, 1);
    var D = Ue(c);
    if (I == 0)
      return ot(x, 0, D, "");
    if (!(x in ie))
      return D;
    a = Be(a, x, xe(x)), c = c.g[3] != null && F(c, 3).length != 0 ? I == 3 ? ";ext=" + F(c, 3) : a.g[13] != null ? F(a, 13) + Z(c, 3) : " ext. " + Z(c, 3) : "";
    e: {
      a = g(a, 20).length == 0 || I == 2 ? g(a, 19) : g(a, 20);
      for (var O, k = a.length, B = 0; B < k; ++B) {
        O = a[B];
        var p = v(O, 3);
        if ((p == 0 || D.search(F(O, 3, p - 1)) == 0) && (p = new RegExp(F(O, 1)), we(p, D))) {
          a = O;
          break e;
        }
      }
      a = null;
    }
    return a != null && (k = a, a = Z(k, 2), O = new RegExp(F(k, 1)), Z(k, 5), k = Z(k, 4), D = I == 2 && k != null && 0 < k.length ? D.replace(O, a.replace(lt, k)) : D.replace(O, a), I == 3 && (D = D.replace(RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]+"), ""), D = D.replace(RegExp("[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]+", "g"), "-"))), ot(x, I, D, c);
  }
  function Be(a, c, I) {
    return I == "001" ? Ae(a, "" + c) : Ae(a, I);
  }
  function Ue(a) {
    if (a.g[2] == null)
      return "";
    var c = "" + F(a, 2);
    return a.g[4] != null && F(a, 4) && 0 < Z(a, 8) ? Array(Z(a, 8) + 1).join("0") + c : c;
  }
  function ot(a, c, I, x) {
    switch (c) {
      case 0:
        return "+" + a + I + x;
      case 1:
        return "+" + a + " " + I + x;
      case 3:
        return "tel:+" + a + "-" + I + x;
      default:
        return I + x;
    }
  }
  function je(a, c) {
    switch (c) {
      case 4:
        return F(a, 5);
      case 3:
        return F(a, 4);
      case 1:
        return F(a, 3);
      case 0:
      case 2:
        return F(a, 2);
      case 5:
        return F(a, 6);
      case 6:
        return F(a, 8);
      case 7:
        return F(a, 7);
      case 8:
        return F(a, 21);
      case 9:
        return F(a, 25);
      case 10:
        return F(a, 28);
      default:
        return F(a, 1);
    }
  }
  function He(a, c) {
    return ge(a, F(c, 1)) ? ge(a, F(c, 5)) ? 4 : ge(a, F(c, 4)) ? 3 : ge(a, F(c, 6)) ? 5 : ge(a, F(c, 8)) ? 6 : ge(a, F(c, 7)) ? 7 : ge(a, F(c, 21)) ? 8 : ge(a, F(c, 25)) ? 9 : ge(a, F(c, 28)) ? 10 : ge(a, F(c, 2)) ? F(c, 18) || ge(a, F(c, 3)) ? 2 : 0 : !F(c, 18) && ge(a, F(c, 3)) ? 1 : -1 : -1;
  }
  function Ae(a, c) {
    if (c == null)
      return null;
    c = c.toUpperCase();
    var I = a.g[c];
    if (I == null) {
      if (I = le[c], I == null)
        return null;
      I = new T().g(b.j(), I), a.g[c] = I;
    }
    return I;
  }
  function ge(a, c) {
    var I = a.length;
    return 0 < v(c, 9) && g(c, 9).indexOf(I) == -1 ? !1 : we(Z(c, 2), a);
  }
  function et(a, c) {
    if (c == null)
      return null;
    var I = Z(c, 1);
    if (I = ie[I], I == null)
      a = null;
    else if (I.length == 1)
      a = I[0];
    else
      e: {
        c = Ue(c);
        for (var x, D = I.length, O = 0; O < D; O++) {
          x = I[O];
          var k = Ae(a, x);
          if (k.g[23] != null) {
            if (c.search(F(k, 23)) == 0) {
              a = x;
              break e;
            }
          } else if (He(c, k) != -1) {
            a = x;
            break e;
          }
        }
        a = null;
      }
    return a;
  }
  function xe(a) {
    return a = ie[a], a == null ? "ZZ" : a[0];
  }
  function Fe(a, c, I, x) {
    var D = je(I, x), O = v(D, 9) == 0 ? g(F(I, 1), 9) : g(D, 9);
    if (D = g(D, 10), x == 2)
      if (Qe(je(I, 0)))
        a = je(I, 1), Qe(a) && (O = O.concat(v(a, 9) == 0 ? g(F(I, 1), 9) : g(a, 9)), O.sort(), D.length == 0 ? D = g(a, 10) : (D = D.concat(g(a, 10)), D.sort()));
      else
        return Fe(a, c, I, 1);
    return O[0] == -1 ? 5 : (c = c.length, -1 < D.indexOf(c) ? 4 : (I = O[0], I == c ? 0 : I > c ? 2 : O[O.length - 1] < c ? 3 : -1 < O.indexOf(c, 1) ? 0 : 5));
  }
  function Ve(a, c) {
    var I = Ue(c);
    return c = Z(c, 1), c in ie ? (c = Be(a, c, xe(c)), Fe(a, I, c, -1)) : 1;
  }
  function tt(a, c, I, x, D, O) {
    if (c.length == 0)
      return 0;
    c = new H(c);
    var k;
    I != null && (k = F(I, 11)), k == null && (k = "NonMatch");
    var B = c.toString();
    if (B.length == 0)
      k = 20;
    else if (De.test(B))
      B = B.replace(De, ""), c.i = "", c.g(Ye(B)), k = 1;
    else {
      if (B = new RegExp(k), nt(c), k = c.toString(), k.search(B) == 0) {
        B = k.match(B)[0].length;
        var p = k.substring(B).match(ze);
        p && p[1] != null && 0 < p[1].length && Se(p[1], ce) == "0" ? k = !1 : (c.i = "", c.g(k.substring(B)), k = !0);
      } else
        k = !1;
      k = k ? 5 : 20;
    }
    if (D && $(O, 6, k), k != 20) {
      if (2 >= c.i.length)
        throw Error("Phone number too short after IDD");
      e: {
        if (a = c.toString(), a.length != 0 && a.charAt(0) != "0") {
          for (D = a.length, c = 1; 3 >= c && c <= D; ++c)
            if (I = parseInt(a.substring(0, c), 10), I in ie) {
              x.g(a.substring(c)), x = I;
              break e;
            }
        }
        x = 0;
      }
      if (x != 0)
        return $(O, 1, x), x;
      throw Error("Invalid country calling code");
    }
    return I != null && (k = Z(I, 10), B = "" + k, p = c.toString(), p.lastIndexOf(B, 0) == 0 && (B = new H(p.substring(B.length)), p = F(I, 1), p = new RegExp(Z(p, 2)), at(B, I, null), B = B.toString(), !we(p, c.toString()) && we(p, B) || Fe(a, c.toString(), I, -1) == 3)) ? (x.g(B), D && $(O, 6, 10), $(O, 1, k), k) : ($(O, 1, 0), 0);
  }
  function at(a, c, I) {
    var x = a.toString(), D = x.length, O = F(c, 15);
    if (D != 0 && O != null && O.length != 0) {
      var k = new RegExp("^(?:" + O + ")");
      if (D = k.exec(x)) {
        O = new RegExp(Z(F(c, 1), 2));
        var B = we(O, x), p = D.length - 1;
        c = F(c, 16), c == null || c.length == 0 || D[p] == null || D[p].length == 0 ? (!B || we(O, x.substring(D[0].length))) && (I != null && 0 < p && D[p] != null && I.g(D[1]), a.set(x.substring(D[0].length))) : (x = x.replace(k, c), (!B || we(O, x)) && (I != null && 0 < p && I.g(D[1]), a.set(x)));
      }
    }
  }
  function Pe(a, c, I) {
    if (!Me(I) && 0 < c.length && c.charAt(0) != "+")
      throw Error("Invalid country calling code");
    return dt(a, c, I, !0);
  }
  function dt(a, c, I, x) {
    if (c == null)
      throw Error("The string supplied did not seem to be a phone number");
    if (250 < c.length)
      throw Error("The string supplied is too long to be a phone number");
    var D = new H(), O = c.indexOf(";phone-context=");
    if (O === -1)
      O = null;
    else if (O += 15, O >= c.length)
      O = "";
    else {
      var k = c.indexOf(";", O);
      O = k !== -1 ? c.substring(O, k) : c.substring(O);
    }
    var B = O;
    if (B == null ? k = !0 : B.length === 0 ? k = !1 : (k = Ze.exec(B), B = Xe.exec(B), k = k !== null || B !== null), !k || (O != null ? (O.charAt(0) === "+" && D.g(O), O = c.indexOf("tel:"), D.g(c.substring(0 <= O ? O + 4 : 0, c.indexOf(";phone-context=")))) : (O = D.g, k = c ?? "", B = k.search(be), 0 <= B ? (k = k.substring(B), k = k.replace(rt, ""), B = k.search(Ne), 0 <= B && (k = k.substring(0, B))) : k = "", O.call(D, k)), O = D.toString(), k = O.indexOf(";isub="), 0 < k && (D.i = "", D.g(O.substring(0, k))), !Te(D.toString())))
      throw Error("The string supplied did not seem to be a phone number");
    if (O = D.toString(), !(Me(I) || O != null && 0 < O.length && De.test(O)))
      throw Error("Invalid country calling code");
    O = new K(), x && $(O, 5, c);
    e: {
      if (c = D.toString(), k = c.search(Je), 0 <= k && Te(c.substring(0, k))) {
        B = c.match(Je);
        for (var p = B.length, M = 1; M < p; ++M)
          if (B[M] != null && 0 < B[M].length) {
            D.i = "", D.g(c.substring(0, k)), c = B[M];
            break e;
          }
      }
      c = "";
    }
    0 < c.length && $(O, 3, c), k = Ae(a, I), c = new H(), B = 0, p = D.toString();
    try {
      B = tt(a, p, k, c, x, O);
    } catch (j) {
      if (j.message == "Invalid country calling code" && De.test(p)) {
        if (p = p.replace(De, ""), B = tt(a, p, k, c, x, O), B == 0)
          throw j;
      } else
        throw j;
    }
    if (B != 0 ? (D = xe(B), D != I && (k = Be(a, B, D))) : (nt(D), c.g(D.toString()), I != null ? (B = Z(k, 10), $(
      O,
      1,
      B
    )) : x && (delete O.g[6], O.i && delete O.i[6])), 2 > c.i.length || (k != null && (I = new H(), D = new H(c.toString()), at(D, k, I), a = Fe(a, D.toString(), k, -1), a != 2 && a != 4 && a != 5 && (c = D, x && 0 < I.toString().length && $(O, 7, I.toString()))), x = c.toString(), a = x.length, 2 > a))
      throw Error("The string supplied is too short to be a phone number");
    if (17 < a)
      throw Error("The string supplied is too long to be a phone number");
    if (1 < x.length && x.charAt(0) == "0") {
      for ($(O, 4, !0), a = 1; a < x.length - 1 && x.charAt(a) == "0"; )
        a++;
      a != 1 && $(O, 8, a);
    }
    return $(O, 2, parseInt(x, 10)), O;
  }
  function we(a, c) {
    return !!((a = typeof a == "string" ? c.match("^(?:" + a + ")$") : c.match(a)) && a[0].length == c.length);
  }
  e("intlTelInputUtils", {}), e("intlTelInputUtils.formatNumber", (a, c, I) => {
    try {
      const D = de.g(), O = Pe(D, a, c);
      var x = Ve(D, O);
      return x == 0 || x == 4 ? it(D, O, typeof I > "u" ? 0 : I) : a;
    } catch {
      return a;
    }
  }), e("intlTelInputUtils.getExampleNumber", (a, c, I) => {
    try {
      const B = de.g();
      e: {
        var x = B;
        if (Me(a)) {
          var D = je(Ae(x, a), I);
          try {
            if (D.g[6] != null) {
              var O = F(D, 6), k = dt(x, O, a, !1);
              break e;
            }
          } catch {
          }
        }
        k = null;
      }
      return it(B, k, c ? 2 : 1);
    } catch {
      return "";
    }
  }), e("intlTelInputUtils.getExtension", (a, c) => {
    try {
      return F(Pe(de.g(), a, c), 3);
    } catch {
      return "";
    }
  }), e("intlTelInputUtils.getNumberType", (a, c) => {
    try {
      const B = de.g();
      var I = Pe(B, a, c);
      a = B;
      var x = et(a, I), D = Be(a, Z(I, 1), x);
      if (D == null)
        var O = -1;
      else {
        var k = Ue(I);
        O = He(k, D);
      }
      return O;
    } catch {
      return -99;
    }
  }), e("intlTelInputUtils.getValidationError", (a, c) => {
    try {
      const I = de.g(), x = Pe(I, a, c);
      return Ve(I, x);
    } catch (I) {
      return I.message === "Invalid country calling code" ? 1 : I.message === "Phone number too short after IDD" || I.message === "The string supplied is too short to be a phone number" ? 2 : I.message === "The string supplied is too long to be a phone number" ? 3 : -99;
    }
  }), e("intlTelInputUtils.isValidNumber", (a, c) => {
    try {
      const se = de.g();
      var I = Pe(se, a, c);
      a = se;
      var x = et(a, I), D = Z(I, 1), O = Be(a, D, x), k;
      if (!(k = O == null)) {
        var B;
        if (B = x != "001") {
          var p = Ae(a, x);
          if (p == null)
            throw Error("Invalid region code: " + x);
          var M = Z(p, 10);
          B = D != M;
        }
        k = B;
      }
      if (k)
        var j = !1;
      else {
        var J = Ue(I);
        j = He(J, O) != -1;
      }
      return j;
    } catch {
      return !1;
    }
  }), e("intlTelInputUtils.isPossibleNumber", (a, c) => {
    try {
      const I = de.g(), x = Pe(I, a, c);
      return Ve(I, x) === 0;
    } catch {
      return !1;
    }
  }), e("intlTelInputUtils.numberFormat", { E164: 0, INTERNATIONAL: 1, NATIONAL: 2, RFC3966: 3 }), e("intlTelInputUtils.numberType", { FIXED_LINE: 0, MOBILE: 1, FIXED_LINE_OR_MOBILE: 2, TOLL_FREE: 3, PREMIUM_RATE: 4, SHARED_COST: 5, VOIP: 6, PERSONAL_NUMBER: 7, PAGER: 8, UAN: 9, VOICEMAIL: 10, UNKNOWN: -1 }), e("intlTelInputUtils.validationError", { IS_POSSIBLE: 0, INVALID_COUNTRY_CODE: 1, TOO_SHORT: 2, TOO_LONG: 3, IS_POSSIBLE_LOCAL_ONLY: 4, INVALID_LENGTH: 5 });
})();
const intlTelInput = "";
/*! js-cookie v3.0.1 | MIT */
function assign(t) {
  for (var e = 1; e < arguments.length; e++) {
    var d = arguments[e];
    for (var r in d)
      t[r] = d[r];
  }
  return t;
}
var defaultConverter = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function init(t, e) {
  function d(o, l, h) {
    if (!(typeof document > "u")) {
      h = assign({}, e, h), typeof h.expires == "number" && (h.expires = new Date(Date.now() + h.expires * 864e5)), h.expires && (h.expires = h.expires.toUTCString()), o = encodeURIComponent(o).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var f = "";
      for (var y in h)
        h[y] && (f += "; " + y, h[y] !== !0 && (f += "=" + h[y].split(";")[0]));
      return document.cookie = o + "=" + t.write(l, o) + f;
    }
  }
  function r(o) {
    if (!(typeof document > "u" || arguments.length && !o)) {
      for (var l = document.cookie ? document.cookie.split("; ") : [], h = {}, f = 0; f < l.length; f++) {
        var y = l[f].split("="), R = y.slice(1).join("=");
        try {
          var S = decodeURIComponent(y[0]);
          if (h[S] = t.read(R, S), o === S)
            break;
        } catch {
        }
      }
      return o ? h[o] : h;
    }
  }
  return Object.create(
    {
      set: d,
      get: r,
      remove: function(o, l) {
        d(
          o,
          "",
          assign({}, l, {
            expires: -1
          })
        );
      },
      withAttributes: function(o) {
        return init(this.converter, assign({}, this.attributes, o));
      },
      withConverter: function(o) {
        return init(assign({}, this.converter, o), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
var api = init(defaultConverter, { path: "/" });
function updateOrSetQueryStringParam(t, e, d) {
  if (typeof d > "u")
    return t;
  var r = new RegExp("([?&])" + e + "=.*?(&|$)", "i"), o = t.indexOf("?") !== -1 ? "&" : "?";
  return t.match(r) ? t.replace(r, "$1" + e + "=" + d + "$2") : t + o + e + "=" + d;
}
function getUrlVars(t) {
  var e = [], d = t.split("?")[1];
  if (!d)
    return e;
  for (var r = d.split("&"), o = 0; o < r.length; o++) {
    var l = r[o].split("=");
    e.push({ key: l[0], value: l[1] });
  }
  return e;
}
const widgetId = () => {
  var t;
  return (t = window.AXLData) == null ? void 0 : t.widgetId;
}, inIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return !0;
  }
}, isInsideWidget = (t) => (t || (t = widgetId()), t && inIframe()), buildProperHref = (t) => t.startsWith("/") ? document.location.protocol + "//" + document.location.host + t : t, emulateClick = (t, e) => {
  if (t != "") {
    if (isInsideWidget()) {
      window.parent.postMessage({
        type: "emulateClick",
        href: buildProperHref(t),
        target: e,
        from: widgetId()
      }, "*");
      return;
    }
    var d = document.createElement("a");
    document.body.appendChild(d), d.href = t, e && (d.target = e), setTimeout(() => {
      d.click(), d.remove();
    }, 10);
  }
}, injectScript = (t, e = "head", d = !1) => new Promise((r, o) => {
  try {
    const h = e == "head" ? document.getElementsByTagName("head")[0] : document.body;
    var l = document.createElement("script");
    l.type = "text/javascript", l.src = t, l.async = d, l.onerror = (f) => o(f), l.onload = () => r(), h.appendChild(l);
  } catch (h) {
    o(h);
  }
}), makeIframesLazy = () => {
  const t = document.querySelectorAll("iframe");
  if ("IntersectionObserver" in window) {
    const e = new IntersectionObserver((d, r) => {
      d.forEach((o) => {
        if (o.isIntersecting) {
          const l = o.target;
          l.src = l.dataset.src || "", r.unobserve(l);
        }
      });
    }, {
      rootMargin: "100% 0px 0px 0px",
      threshold: 0
    });
    t.forEach((d) => {
      d.dataset.src || (d.dataset.src = d.src, d.src = ""), e.observe(d);
    });
  } else
    t.forEach((e) => {
      const d = e;
      d.src = d.dataset.src || "";
    });
}, injectStyle = (t) => new Promise((e, d) => {
  try {
    const o = document.getElementsByTagName("head")[0];
    var r = document.createElement("link");
    r.rel = "stylesheet", r.type = "text/css", r.href = t, r.media = "all", r.onerror = (l) => d(l), r.onload = () => e(), o.appendChild(r);
  } catch (o) {
    d(o);
  }
}), replaceAXLVariables = (t, e, d) => {
  if (!d || d.length == 0)
    return t;
  var r = AXLReplaceTagsRegex.find((o) => o.type == e);
  return r ? (d = d.replace(/[+]/g, "%2B"), t.replace(r.regex, d)) : t;
};
var AXLReplaceTags = /* @__PURE__ */ ((t) => (t[t.Id = 0] = "Id", t[t.FirstName = 1] = "FirstName", t[t.LastName = 2] = "LastName", t[t.Email = 3] = "Email", t[t.Phone = 4] = "Phone", t))(AXLReplaceTags || {});
const AXLReplaceTagsRegex = [
  {
    type: 0,
    regex: new RegExp("[#{]ID[}#]", "g")
  },
  {
    type: 1,
    regex: new RegExp("[#{]FirstName[}#]", "g")
  },
  {
    type: 2,
    regex: new RegExp("[#{]LastName[}#]", "g")
  },
  {
    type: 3,
    regex: new RegExp("[#{]Email[}#]", "g")
  },
  {
    type: 4,
    regex: new RegExp("[#{]Phone[}#]", "g")
  }
];
var AXLWebsiteEventEnum = /* @__PURE__ */ ((t) => (t.CheckoutSuccess = "CheckoutSuccess", t.CheckoutError = "CheckoutFail", t.CheckoutInit = "CheckoutInit", t.CheckoutStarted = "CheckoutStarted", t.FormSubmit = "FormSubmit", t))(AXLWebsiteEventEnum || {});
const URL_PARAM_REGEX = /[{#]URL\.Param\(([^#]+?)\)[}#]/;
function normalizeUrlParamName(t) {
  if (!t)
    return "";
  let e = t.trim().replace(/&quot;/gi, '"').replace(/&#0*39;/g, "'").replace(/&apos;/gi, "'").replace(/&#0*34;/g, '"');
  return (e.startsWith('"') && e.endsWith('"') || e.startsWith("'") && e.endsWith("'")) && (e = e.slice(1, -1)), e.trim().replace(/^"+|"+$/g, "").replace(/^'+|'+$/g, "");
}
function tryParseUrlParamTag(t) {
  if (!t)
    return null;
  const e = t.trim(), d = URL_PARAM_REGEX.exec(e);
  return !d || d[0] !== e ? null : normalizeUrlParamName(d[1]) || null;
}
function resolveUrlParamValue(t) {
  if (!t)
    return t ?? "";
  const e = tryParseUrlParamTag(t);
  if (!e)
    return t;
  try {
    return new URLSearchParams(window.location.search).get(e) ?? "";
  } catch {
    return "";
  }
}
function applyUrlParamToHiddenField(t) {
  var d;
  if (((d = t.type) == null ? void 0 : d.toLowerCase()) !== "hidden" || !t.value)
    return;
  const e = resolveUrlParamValue(t.value);
  e !== t.value && (t.value = e);
}
function applyUrlParamToHiddenFields(t) {
  var e;
  for (let d = 0; d < t.length; d++) {
    const r = t[d];
    ((e = r == null ? void 0 : r.type) == null ? void 0 : e.toLowerCase()) === "hidden" && applyUrlParamToHiddenField(r);
  }
}
const defaultWords$1 = {
  title: "Confirm you are not a robot",
  hint: "Drag the piece into the gap",
  start: "Click here to start the check",
  solved: "Verified",
  failed: "Verification failed, try again",
  expired: "Verification expired, try again",
  tooManyAttempts: "Too many attempts, try again later",
  unavailable: "Verification is temporarily unavailable"
}, errorCodes = {
  invalid: 70003,
  expired: 70004,
  tooManyAttempts: 70005
};
class EZCaptcha {
  constructor(e, d) {
    this.container = e, this.options = d, this.challenge = null, this.tokenValue = null, this.busy = !1, this.pendingError = null, this.loadedImages = 0, this.requested = !1, this.positionX = 0, this.maxPositionX = 0, this.dragPointerId = null, this.dragStartClientX = 0, this.dragStartPositionX = 0, this.interactionStartedAt = 0, this.ensureRequested = () => {
      this.requested || (this.requested = !0, this.load());
    }, this.onPieceDown = (r) => {
      var o, l;
      this.ensureRequested(), !(!this.challenge || this.busy) && (this.dragPointerId = r.pointerId, this.interactionStartedAt || (this.interactionStartedAt = Date.now()), this.dragStartClientX = r.clientX, this.dragStartPositionX = this.positionX, (l = (o = this.piece).setPointerCapture) == null || l.call(o, r.pointerId), this.root.classList.add("dragging"), r.preventDefault());
    }, this.onPieceMove = (r) => {
      this.dragPointerId === r.pointerId && (this.setPosition(this.dragStartPositionX + (r.clientX - this.dragStartClientX) / this.displayRatio), r.preventDefault());
    }, this.onPieceUp = (r) => {
      var o, l;
      this.dragPointerId === r.pointerId && (this.dragPointerId = null, (l = (o = this.piece).releasePointerCapture) == null || l.call(o, r.pointerId), this.root.classList.remove("dragging"), this.verify());
    }, this.onPieceKeyDown = (r) => {
      if (!this.challenge || this.busy)
        return;
      const o = r.shiftKey ? 10 : 1;
      if (this.interactionStartedAt || (this.interactionStartedAt = Date.now()), r.key === "ArrowLeft") {
        this.setPosition(this.positionX - o), r.preventDefault();
        return;
      }
      if (r.key === "ArrowRight") {
        this.setPosition(this.positionX + o), r.preventDefault();
        return;
      }
      (r.key === "Enter" || r.key === " ") && (this.verify(), r.preventDefault());
    }, this.onImageLoaded = () => {
      if (this.loadedImages++, this.loadedImages < 2 || !this.challenge)
        return;
      const r = this.background.naturalWidth, o = this.background.naturalHeight;
      this.maxPositionX = Math.max(0, r - this.piece.naturalWidth), this.piece.style.width = `${this.piece.naturalWidth / r * 100}%`, this.piece.style.top = `${this.challenge.payload.positionY / o * 100}%`, this.piece.setAttribute("aria-valuemax", `${Math.round(this.maxPositionX)}`), this.root.classList.remove("loading"), this.setPosition(0), this.setDisabled(!1);
    }, this.words = { ...defaultWords$1, ...d.words || {} }, this.build();
  }
  get token() {
    return this.tokenValue;
  }
  get solved() {
    return this.tokenValue != null;
  }
  reset() {
    var e, d;
    this.tokenValue = null, (d = (e = this.options).onStateChange) == null || d.call(e, !1), this.requested = !0, this.load();
  }
  showError(e) {
    this.status.textContent = e || this.options.errorText || this.words.failed, this.status.className = "ez-captcha-status error";
  }
  showHint() {
    this.status.className = "ez-captcha-status", this.status.textContent = this.words.hint;
  }
  build() {
    this.root = document.createElement("div"), this.root.className = "ez-captcha loading", this.title = document.createElement("div"), this.title.className = "ez-captcha-title", this.title.textContent = this.words.title, this.root.appendChild(this.title), this.frame = document.createElement("div"), this.frame.className = "ez-captcha-frame", this.stage = document.createElement("div"), this.stage.className = "ez-captcha-stage", this.background = document.createElement("img"), this.background.className = "ez-captcha-bg", this.background.draggable = !1, this.background.alt = "", this.piece = document.createElement("img"), this.piece.className = "ez-captcha-piece", this.piece.draggable = !1, this.piece.alt = "", this.piece.tabIndex = 0, this.piece.setAttribute("role", "slider"), this.piece.setAttribute("aria-label", this.words.hint), this.piece.setAttribute("aria-valuemin", "0"), this.piece.addEventListener("pointerdown", this.onPieceDown), this.piece.addEventListener("pointermove", this.onPieceMove), this.piece.addEventListener("pointerup", this.onPieceUp), this.piece.addEventListener("pointercancel", this.onPieceUp), this.piece.addEventListener("keydown", this.onPieceKeyDown), this.piece.addEventListener("focus", this.ensureRequested), this.stage.appendChild(this.background), this.stage.appendChild(this.piece), this.frame.appendChild(this.stage), this.root.appendChild(this.frame), this.status = document.createElement("div"), this.status.className = "ez-captcha-status", this.status.textContent = this.words.start, this.root.appendChild(this.status), this.applyAppearance(), this.root.addEventListener("pointerdown", this.ensureRequested), this.container.appendChild(this.root), this.observeVisibility();
  }
  applyAppearance() {
    this.options.width && this.root.style.setProperty("--ez-captcha-width", this.options.width), this.options.textSize && this.root.style.setProperty("--ez-captcha-text-size", this.options.textSize), this.options.align && this.root.classList.add(`align-${this.options.align}`), this.options.textAlign && this.root.classList.add(`text-${this.options.textAlign}`);
  }
  observeVisibility() {
    if (typeof IntersectionObserver > "u") {
      this.ensureRequested();
      return;
    }
    const e = new IntersectionObserver((d) => {
      d.some((r) => r.isIntersecting) && (e.disconnect(), this.ensureRequested());
    });
    e.observe(this.root);
  }
  get displayRatio() {
    const e = this.background.clientWidth;
    return !e || !this.background.naturalWidth ? 1 : e / this.background.naturalWidth;
  }
  setPosition(e) {
    this.positionX = Math.min(this.maxPositionX, Math.max(0, e)), this.piece.style.left = `${this.positionX / this.background.naturalWidth * 100}%`, this.piece.setAttribute("aria-valuenow", `${Math.round(this.positionX)}`);
  }
  async load() {
    var e, d;
    if (!this.busy) {
      this.busy = !0, this.setDisabled(!0);
      try {
        const r = await fetch(`${this.options.apiBaseUrl}/c`, {
          method: "POST",
          headers: { Accept: "application/json", "Content-Type": "application/json" },
          body: JSON.stringify({ type: this.options.type || "Puzzle" })
        }), o = await r.json();
        if (!r.ok || !((d = (e = o == null ? void 0 : o.body) == null ? void 0 : e.payload) != null && d.backgroundImageBytes)) {
          this.showError(this.messageFor(o));
          return;
        }
        this.apply(o.body);
      } catch {
        this.showError(this.words.unavailable);
      } finally {
        this.busy = !1;
      }
    }
  }
  apply(e) {
    var d, r;
    this.challenge = e, this.tokenValue = null, this.root.classList.remove("solved"), (r = (d = this.options).onStateChange) == null || r.call(d, !1), this.loadedImages = 0, this.interactionStartedAt = 0, this.background.onload = this.onImageLoaded, this.piece.onload = this.onImageLoaded, this.background.src = `data:image/jpeg;base64,${e.payload.backgroundImageBytes}`, this.piece.src = `data:image/png;base64,${e.payload.puzzleImageBytes}`, this.pendingError ? (this.showError(this.pendingError), this.pendingError = null) : this.showHint();
  }
  async verify() {
    var e, d, r;
    if (!(!this.challenge || this.busy)) {
      this.busy = !0, this.setDisabled(!0);
      try {
        const o = await fetch(`${this.options.apiBaseUrl}/c/${this.challenge.id}/solution`, {
          method: "POST",
          headers: { Accept: "application/json", "Content-Type": "application/json" },
          body: JSON.stringify({
            positionX: Math.round(this.positionX),
            solveMs: this.interactionStartedAt ? Date.now() - this.interactionStartedAt : 0
          })
        }), l = await o.json();
        if (o.ok && ((e = l == null ? void 0 : l.body) != null && e.token)) {
          this.tokenValue = l.body.token, this.root.classList.add("solved"), this.status.className = "ez-captcha-status solved", this.status.textContent = this.words.solved, (r = (d = this.options).onStateChange) == null || r.call(d, !0);
          return;
        }
        this.pendingError = this.messageFor(l), this.busy = !1, await this.load();
        return;
      } catch {
        this.showError(this.words.unavailable);
      } finally {
        this.busy = !1;
      }
    }
  }
  messageFor(e) {
    var r, o;
    switch ((o = (r = e == null ? void 0 : e.errors) == null ? void 0 : r[0]) == null ? void 0 : o.code) {
      case errorCodes.expired:
        return this.words.expired;
      case errorCodes.tooManyAttempts:
        return this.words.tooManyAttempts;
      case errorCodes.invalid:
        return this.options.errorText || this.words.failed;
      default:
        return this.words.unavailable;
    }
  }
  setDisabled(e) {
    this.root.classList.toggle("disabled", e);
  }
}
let phoneUtilsPromise;
const phoneUtilsStart = () => (phoneUtilsPromise || (phoneUtilsPromise = Promise.resolve()), phoneUtilsPromise), phoneUtilsWait = () => phoneUtilsPromise ? Promise.race([phoneUtilsPromise, new Promise((t) => setTimeout(t, 1500))]) : Promise.resolve(), phoneUtilsAvailable = () => typeof window.intlTelInputUtils < "u", CaptchaRequiredErrorCode = 70002, CaptchaSlotClass = "ez-captcha-slot", TrapFieldName = "_axl_confirm";
function ezInitForms(t, e) {
  const d = document.querySelectorAll(".ez-form form, form.ez-form");
  if (!(!d || d.length == 0))
    for (var r = 0; r < d.length; r++)
      new EZForm(d[r], t, e);
}
const CountryCookieName = "ez-country";
class EZForm {
  constructor(e, d, r) {
    var l, h;
    this.form = e, this.formParams = d, this.isAuthorized = r, this.isSubmitting = !1, this.currentCountry = api.get(CountryCookieName) || "us", this.loader = null, this.anyFieldHiddenDueToAuth = !1, this.captcha = null, this.captchaRequired = !1, this.trapField = null, this.renderedAt = Date.now(), this.onFormFocusIn = () => {
      var f;
      (f = this.captcha) == null || f.ensureRequested();
    }, this.fieldChangeHandler = (f) => {
      var y = f.currentTarget;
      if (y.touched) {
        var R = this.fieldIsValid(y);
        if (R.available === !1) {
          this.fieldHideError(y), this.fieldKeyUpHandler(f);
          return;
        }
        if (R.isValid)
          this.fieldHideError(y);
        else {
          this.fieldShowError(R);
          return;
        }
        this.fieldKeyUpHandler(f);
      }
    }, this.fieldKeyUpHandler = (f) => {
      var y = f.currentTarget;
      y.nodeName.toUpperCase() != "TEXTAREA" && f instanceof KeyboardEvent && f.key == "Enter" && this.submit();
    }, this.fieldAddEnterKeyListener = (f) => {
      f.nodeName.toUpperCase() != "TEXTAREA" && f.addEventListener("keyup", (y) => {
        y.key == "Enter" && this.submit();
      });
    }, this.phoneResult = (f) => {
      var y = f.intlTelInput, R = (f.value || "").toString().trim();
      if (!R)
        return { isValid: !0, available: !0, value: "" };
      if (!y || !phoneUtilsAvailable()) {
        var S = R.charAt(0) == "+", N = R.replace(/\D/g, "").slice(0, 15), C = y && y.getSelectedCountryData ? y.getSelectedCountryData() : null, z = C && C.dialCode ? C.dialCode : "";
        !S && z == "7" && (N.length == 11 && N.charAt(0) == "8" ? N = "7" + N.slice(1) : N.length == 10 && (N = "7" + N), N.length == 11 && N.charAt(0) == "7" && (S = !0));
        var W = S && N.length ? "+" + N : N;
        return { isValid: N.length >= 10, available: !1, value: W };
      }
      var Y = y.isValidNumber() === !0;
      return { isValid: Y, available: !0, value: Y ? y.getNumber() : "" };
    }, this.fieldIsValid = (f) => {
      var N;
      f.classList.remove("invalid");
      var y = { dom: f, name: f.name, isValid: !0, message: "" };
      if (f.required && f.value.length == 0)
        return { ...y, isValid: !1, message: this.localize.words.required };
      if (f.required && f.getAttribute("type") == "checkbox" && !f.checked)
        return { ...y, isValid: !1, message: this.localize.words.required };
      var R = f.getAttribute("validation");
      if (!R || f.type == "hidden" || !f.required && f.value.length == 0)
        return y;
      switch (R) {
        case "email":
          return f.value = (N = f.value) == null ? void 0 : N.trim(), {
            ...y,
            isValid: isEmail(f.value),
            message: this.localize.words.invalidEmail
          };
        case "phone":
          var S = this.phoneResult(f);
          return {
            ...y,
            isValid: S.isValid,
            available: S.available,
            message: this.localize.words.invalidPhone
          };
        case "number":
          return {
            ...y,
            isValid: isNumeric(f.value) || _default(f.value),
            message: this.localize.words.invalidNumber
          };
        case "url":
          return {
            ...y,
            isValid: isURL(f.value),
            message: this.localize.words.invalidUrl
          };
      }
    }, this.fieldShowError = (f) => {
      var S;
      if (f.dom.getAttribute("type") == "checkbox" ? (S = f.dom.parentElement) == null || S.classList.add("invalid") : f.dom.classList.add("invalid"), f.message) {
        var y = f.dom.closest(".form-control");
        if (y) {
          f.dom.errorField && f.dom.errorField.remove();
          var R = document.createElement("div");
          R.classList.add("field-error"), R.innerText = f.message || "", y.appendChild(R), f.dom.errorField = R;
        }
      }
    }, this.fieldHideError = (f) => {
      var y = f.closest(".form-control");
      y == null || y.querySelectorAll(".field-error").forEach((R) => R.remove());
    }, this.sendFormCallBack = async ({ status: f, data: y }) => {
      var N, C, z, W, Y, P, F;
      if (this.formResponse = y, this.setIsSubmitting(!1), f != 200) {
        if ((C = (N = this.formResponse) == null ? void 0 : N.errors) != null && C.some((Z) => Z.code == CaptchaRequiredErrorCode) && ((z = this.formParams) != null && z.captchaBaseUrl)) {
          this.handleCaptchaRequired(this.formResponse);
          return;
        }
        var R;
        !y.message && y.errors && y.errors.length > 0 ? R = y.errors.map((Z) => Z.message).join(`
`) : y.message && (R = y.message), this.showError(R, 3);
        return;
      }
      if (typeof window.fbq < "u") {
        const g = (((W = window.AXLData) == null ? void 0 : W.sitePageId) || ((Y = window.AXLData) == null ? void 0 : Y.widgetId) || "") + "_" + ((F = (P = this.formResponse) == null ? void 0 : P.body) == null ? void 0 : F.contactId);
        window.fbq("track", "Lead", {}, { eventId: g });
      }
      typeof window._axlOnSuccessFormSubmit == "function" && window._axlOnSuccessFormSubmit(this.formData);
      var S = window.AXLWebsite;
      S && S.dispatch("FormSubmit", this.formData), this.showMessage(this.formMessageToShow), await this.execJS(), this.execRedirect(), this.submitButton && typeof this.submitButton._onSuccessFormSubmit == "function" && this.submitButton._onSuccessFormSubmit(this.submitButton);
    }, this.initSubmit(), this.initFields(), this.hideFieldsIfAuthorized(), this.initButtonSubmit(), this.initCaptcha(), this.initTrap();
    var o = (h = (l = window.AXLData) == null ? void 0 : l.formSettings) == null ? void 0 : h.loc;
    this.localize = new FormLocalization(o);
  }
  get fields() {
    return Array.from(this.form.elements).filter((e) => e.name != TrapFieldName && !e.closest(`.${CaptchaSlotClass}`));
  }
  get submitButton() {
    return this.form.querySelector("[type='submit']");
  }
  get captchaSlot() {
    return this.form.querySelector(`.${CaptchaSlotClass}`);
  }
  get formId() {
    return this.form.getAttribute("form-id");
  }
  get captchaSettings() {
    var e, d;
    return (d = (e = window.AXLData) == null ? void 0 : e.formSettings) == null ? void 0 : d.captcha;
  }
  initCaptcha() {
    var o, l, h;
    const e = this.captchaSlot;
    if (!(((o = this.captchaSettings) == null ? void 0 : o.enabled) === !0 && !!((l = this.formParams) != null && l.captchaBaseUrl) && (e == null ? void 0 : e.getAttribute("data-captcha-required")) != "false")) {
      e == null || e.remove();
      return;
    }
    if (this.captchaRequired = !0, ((h = this.captchaSettings) == null ? void 0 : h.skipKnownVisitor) === !0 && typeof this.isAuthorized == "function" && this.isAuthorized()) {
      e == null || e.remove();
      return;
    }
    this.mountCaptcha(e ?? this.ensureCaptchaSlot()), this.form.addEventListener("focusin", this.onFormFocusIn, { once: !0 });
  }
  mountCaptcha(e) {
    var d, r;
    this.captcha || !((d = this.formParams) != null && d.captchaBaseUrl) || (e.innerHTML = "", this.captcha = new EZCaptcha(e, {
      apiBaseUrl: this.formParams.captchaBaseUrl,
      type: e.getAttribute("data-captcha-type") || ((r = this.captchaSettings) == null ? void 0 : r.type) || "Puzzle",
      errorText: e.getAttribute("data-captcha-error") || void 0,
      width: e.getAttribute("data-captcha-width") || void 0,
      align: e.getAttribute("data-captcha-align") || void 0,
      textSize: e.getAttribute("data-captcha-text-size") || void 0,
      textAlign: e.getAttribute("data-captcha-text-align") || void 0,
      words: this.captchaWords
    }));
  }
  get captchaWords() {
    var e, d, r;
    return ((r = (d = (e = window.AXLData) == null ? void 0 : e.formSettings) == null ? void 0 : d.captcha) == null ? void 0 : r.loc) || {};
  }
  initTrap() {
    this.captchaRequired && (this.trapField = document.createElement("input"), this.trapField.type = "text", this.trapField.name = TrapFieldName, this.trapField.tabIndex = -1, this.trapField.autocomplete = "off", this.trapField.setAttribute("aria-hidden", "true"), this.trapField.style.cssText = "position:absolute;left:-10000px;width:1px;height:1px;opacity:0;", this.form.appendChild(this.trapField));
  }
  ensureCaptchaSlot() {
    const e = this.captchaSlot;
    if (e)
      return e;
    const d = document.createElement("div");
    d.className = `form-control ${CaptchaSlotClass}`;
    const r = this.form.querySelector(".form-control.submit");
    return r ? this.form.insertBefore(d, r) : this.form.appendChild(d), d;
  }
  initSubmit() {
    this.form.addEventListener("submit", (e) => {
      e.preventDefault(), this.submit();
    });
  }
  initButtonSubmit() {
    var e;
    (e = this.submitButton) == null || e.addEventListener("click", (d) => {
      d.preventDefault(), this.submit();
    });
  }
  initFields() {
    this.fields.forEach((e) => {
      var l;
      ((l = e.type) == null ? void 0 : l.toLowerCase()) === "hidden" && applyUrlParamToHiddenField(e);
      var d = e.getAttribute("validation");
      if (d == "phone") {
        var r = e.getAttribute("default-country-code");
        e.value = r ? `+${r}` : "", this.initPhoneField(e, r == null);
      }
      if (e.type.toLowerCase() == "checkbox") {
        var o = e.getAttribute("default-checked");
        o && (e.checked = !0);
      }
      e.addEventListener("blur", (h) => {
        e.touched = !0, this.fieldChangeHandler(h);
      }), e.addEventListener("keyup", this.fieldChangeHandler.bind(this)), e.addEventListener("change", this.fieldChangeHandler.bind(this));
    });
  }
  hideFieldsIfAuthorized() {
    typeof this.isAuthorized == "function" && this.isAuthorized() && this.fields.forEach((e) => {
      var d = e.closest(".form-control");
      if (d) {
        var r = d.getAttribute("hide-if-auth") == "true";
        r && (d.remove(), this.anyFieldHiddenDueToAuth = !0);
      }
    });
  }
  attachPhoneMask(e) {
    var d = () => {
      if (!phoneUtilsAvailable()) {
        var r = e.value || "";
        if (r) {
          var o = r.charAt(0) == "+", l = r.replace(/\D/g, "").slice(0, 15), h = o ? l.length ? "+" + l : "+" : l;
          if (h != r) {
            var f = e.selectionStart == null ? r.length : e.selectionStart, y = r.slice(0, f).replace(/\D/g, "");
            o && f > 0 && (y = "+" + y), e.value = h;
            var R = Math.min(y.length, h.length);
            try {
              e.setSelectionRange(R, R);
            } catch {
            }
          }
        }
      }
    };
    e.addEventListener("input", d);
  }
  initPhoneField(e, d = !1) {
    phoneUtilsStart(), this.attachPhoneMask(e);
    var r = {
      autoPlaceholder: "polite",
      nationalMode: !0,
      dropdownContainer: document.getElementsByClassName("ez-wrapper")[0] || document.body
    };
    d && (r.initialCountry = "auto"), e.intlTelInput = intlTelInput$2(e, r), d && this.getCountryName().then((o) => {
      this.currentCountry = o, e.intlTelInput.setCountry(o);
    });
  }
  async getCountryName() {
    try {
      var e = api.get(CountryCookieName);
      if (e)
        return e.toLowerCase();
      var d = await fetch("https://ipinfo.io", {
        headers: { Accept: "application/json" }
      }), r = await d.json(), o = r && r.country ? r.country : "us";
      return api.set(CountryCookieName, o.toLowerCase(), { expires: 7 }), o.toLowerCase();
    } catch {
      return "us";
    }
  }
  get accelPixel() {
    var e = window.ao;
    return e || null;
  }
  get formMessageToShow() {
    const e = this.form.getAttribute("form-message");
    return e && e.length > 0 ? e : "";
  }
  showMessage(e) {
    var d = document.createElement("div");
    d.className = "ez-form-message", this.form.appendChild(d), d.innerText = e || "Thank you!";
  }
  showError(e, d) {
    var o;
    var r = document.createElement("div");
    r.className = "form-error", (o = this.form) == null || o.appendChild(r), r.innerText = e, setTimeout(() => {
      r.remove();
    }, (d || 3) * 1e3);
  }
  addVariablesToString(e) {
    var y, R;
    const d = (S) => S.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    for (var r of this.formData.fields) {
      var o = r.value ?? "";
      if (typeof o == "string" && (o = o.replace(/[+]/g, "%2B")), typeof o == "boolean") {
        if (!r.key)
          continue;
        e = e.replace(new RegExp(`(#|{)(${d(r.key)})(#|})`, "g"), o ? "true" : "false");
      } else {
        var l = r.key ? d(r.key) : "", h = r.name ? d(r.name) : "", f = l && h ? `${l}|${h}` : l || h;
        if (!f)
          continue;
        e = e.replace(new RegExp(`(#|{)(${f})(#|})`, "g"), o);
      }
    }
    return (R = (y = this.formResponse) == null ? void 0 : y.body) != null && R.contactId && (e = replaceAXLVariables(e, AXLReplaceTags.Id, this.formResponse.body.contactId)), e;
  }
  async execJS() {
    var e = this.form.getAttribute("form-js");
    if (e)
      try {
        var d = new Function(e);
        await d();
      } catch (r) {
        console.error("Error in form JS function", r);
      }
  }
  execRedirect() {
    var o, l;
    let e = this.form.getAttribute("form-redirect");
    if (!e || e.length == 0)
      return;
    if (e = this.addVariablesToString(e), this.form.getAttribute("form-redirect-add-url-params"))
      for (var r of getUrlVars(document.location.href))
        e = updateOrSetQueryStringParam(e, r.key, r.value);
    if (this.formParams && this.formParams.contactQueryCookieName && ((l = (o = this.formResponse) == null ? void 0 : o.body) != null && l.contactId) && (e = updateOrSetQueryStringParam(e, this.formParams.contactQueryCookieName, this.formResponse.body.contactId)), isInsideWidget()) {
      emulateClick(e, null);
      return;
    }
    document.location.href = e;
  }
  async submit() {
    var y, R, S, N;
    if (!this.isSubmitting) {
      this.setIsSubmitting(!0), await phoneUtilsWait(), this.fields.forEach((C) => {
        var z;
        ((z = C.type) == null ? void 0 : z.toLowerCase()) === "hidden" && applyUrlParamToHiddenField(C);
      }), this.fields.forEach((C) => this.fieldHideError(C));
      var e = [];
      for (var d of this.fields)
        e.push(this.fieldIsValid(d));
      var r = e.filter((C) => C.isValid !== !0);
      if (r.length > 0) {
        r.forEach((C) => this.fieldShowError(C)), this.setIsSubmitting(!1), (y = r[0].dom.parentElement) == null || y.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        return;
      }
      if (!this.captchaIsValid()) {
        this.setIsSubmitting(!1);
        return;
      }
      var o = {
        name: this.form.getAttribute("form-name"),
        formId: this.formId,
        captcha: this.captchaRequired ? this.captchaData() : void 0,
        fields: []
      };
      for (var d of this.fields) {
        let z = d.getAttribute("type") == "checkbox" ? d.checked : d.value;
        d.intlTelInput && (z = this.phoneResult(d).value), o.fields.push({
          key: d.getAttribute("name"),
          name: d.getAttribute("label"),
          value: z
        });
      }
      if (this.anyFieldHiddenDueToAuth && o.fields.push({
        key: "isAuthorized",
        name: "isAuthorized",
        value: "true"
      }), this.formData = o, this.accelPixel)
        this.accelPixel.track("form", this.formData, this.sendFormCallBack);
      else if ((R = this.formParams) != null && R.onSubmit)
        try {
          var { status: l, data: h } = await ((S = this.formParams) == null ? void 0 : S.onSubmit(this.formData));
          await this.sendFormCallBack({ status: l, data: h });
        } catch {
          this.showError("Error submitting form. Please try again later.");
        }
      else if ((N = this.formParams) != null && N.submitUrl)
        try {
          var f = await fetch(this.formParams.submitUrl, {
            method: "POST",
            headers: { Accept: "application/json" },
            body: JSON.stringify(this.formData)
          }), h = await f.json();
          await this.sendFormCallBack({ status: f.status, data: h });
        } catch {
          this.showError("Error submitting form. Please try again later.");
        }
      else {
        if (!this.accelPixel) {
          console.warn("Can't find Accel Pixel. This is sad. Configure your Accel Pixel to send forms"), this.setIsSubmitting(!1);
          return;
        }
        if (!this.accelPixel.track) {
          console.warn("Track form is not configured."), this.setIsSubmitting(!1);
          return;
        }
      }
    }
  }
  captchaIsValid() {
    return !this.captcha || !this.captchaRequired || this.captcha.solved ? !0 : (this.captcha.ensureRequested(), this.captcha.showError(), !1);
  }
  captchaData() {
    var e, d;
    return {
      token: ((e = this.captcha) == null ? void 0 : e.token) || null,
      trap: ((d = this.trapField) == null ? void 0 : d.value) || "",
      filledInMs: Date.now() - this.renderedAt
    };
  }
  handleCaptchaRequired(e) {
    var r, o;
    if (!((r = this.formParams) != null && r.captchaBaseUrl))
      return;
    const d = this.ensureCaptchaSlot();
    this.captchaRequired = !0, this.captcha ? this.captcha.reset() : this.mountCaptcha(d), (o = this.captcha) == null || o.showError(), d.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  }
  setIsSubmitting(e) {
    var d, r;
    e ? ((r = this.submitButton) == null || r.setAttribute("disabled", "disabled"), this.isSubmitting = !0, this.createLoader()) : ((d = this.submitButton) == null || d.removeAttribute("disabled"), this.isSubmitting = !1, this.destroyLoader());
  }
  createLoader() {
    this.loader = document.createElement("div"), this.loader.className = "spin-loader-wrapper";
    var e = document.createElement("div");
    e.className = "spin-loader", this.loader.appendChild(e), this.form.appendChild(this.loader);
  }
  destroyLoader() {
    this.loader && (this.loader.remove(), this.loader = null);
  }
}
class FormLocalization {
  constructor(e) {
    var r, o;
    if (this.words = new FormLocalizationWordsEn(), e)
      this.words = e;
    else {
      var d = (o = (r = Intl.NumberFormat()) == null ? void 0 : r.resolvedOptions()) == null ? void 0 : o.locale;
      switch (d || (d = navigator.language || "us"), d.indexOf("-") > -1 && (d = d.split("-")[0]), d) {
        case "en":
          this.words = new FormLocalizationWordsEn();
          break;
        case "ru":
          this.words = new FormLocalizationWordsRu();
          break;
      }
    }
  }
}
class FormLocalizationWordsEn {
  constructor() {
    this.invalidEmail = "Enter valid email", this.invalidPhone = "Enter international phone number", this.invalidNumber = "Enter valid number", this.invalidUrl = "Enter valid URL", this.required = "This field is required";
  }
}
class FormLocalizationWordsRu {
  constructor() {
    this.invalidEmail = "Введите корректный email", this.invalidPhone = "Введите телефон в международном формате", this.invalidNumber = "Введите корректное число", this.invalidUrl = "Введите корректный URL", this.required = "Обязательно для заполнения";
  }
}
const zoomImage = (t, e) => {
  var d = document.body.style.overflow, r = document.createElement("div");
  r.classList.add("ez-zoom-image-holder");
  const o = () => {
    r.classList.add("hide"), setTimeout(() => {
      r.remove(), document.body.style.overflow = d;
    }, 300);
  };
  var l = document.createElement("div");
  l.classList.add("backdrop"), l.addEventListener("click", o), r.append(l);
  var h = document.createElement("img");
  h.src = t, h.addEventListener("click", o), r.append(h), e.append(r), document.body.style.overflow = "hidden", h.height < window.innerHeight && h.classList.add("center");
}, PLAYER_URL_REGEX = /src\s*=\s*\\?["'][^"'\\]*?\/v\/([a-zA-Z0-9_-]+)[\\"'?&#]/gi, getPlayerVideoIds = (t) => {
  if (!t)
    return [];
  const e = [];
  let d;
  for (PLAYER_URL_REGEX.lastIndex = 0; (d = PLAYER_URL_REGEX.exec(t)) != null; )
    e.indexOf(d[1]) == -1 && e.push(d[1]);
  return e;
}, parseVideoMomentSettings = (t) => {
  if (!t)
    return {};
  if (t.charAt(0) != "{")
    return { time: t };
  try {
    const e = JSON.parse(t);
    return { time: e.time, target: e.target ?? e.videoId };
  } catch {
    return {};
  }
}, toVideoMomentSettings = (t) => JSON.stringify(t), SRC_REGEX = /src\s*=\s*\\?["']([^"'\\]+)/i, PLAYER_PATH_REGEX$1 = /\/v\/[a-zA-Z0-9_-]+/, DEFAULT_EMBED_WIDTH = 560, DEFAULT_EMBED_HEIGHT = 315, isOurPlayerEmbed = (t) => {
  const e = getEmbedSrc(t);
  return e != null && PLAYER_PATH_REGEX$1.test(e);
}, getPlayerParam = (t, e) => {
  const d = getEmbedSrc(t);
  if (d == null)
    return null;
  const r = d.split("?")[1];
  if (!r)
    return null;
  const o = r.split(/&amp;|&/).map((l) => l.split("=")).filter((l) => decode(l[0]) == e)[0];
  return o && o.length > 1 ? decode(o[1]) : null;
}, setPlayerParam = (t, e, d) => {
  const r = getEmbedSrc(t);
  if (t == null || r == null)
    return t || "";
  const [o, l] = r.split("?"), h = (l || "").indexOf("&amp;") > -1 ? "&amp;" : "&", f = (l || "").split(/&amp;|&/).filter((R) => R.length > 0 && decode(R.split("=")[0]) != e);
  d != null && f.push(`${e}=${encodeURIComponent(d)}`);
  const y = f.length > 0 ? `${o}?${f.join(h)}` : o;
  return t.replace(r, y);
}, buildPlayerEmbedCode = (t, e) => {
  const d = `${t}/v/${e}?showTitle=true&showControls=true`;
  return `<iframe width="${DEFAULT_EMBED_WIDTH}" height="${DEFAULT_EMBED_HEIGHT}" src="${d}" frameBorder=0 allow="accelerometer; fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>`;
}, decode = (t) => {
  try {
    return decodeURIComponent(t);
  } catch {
    return t;
  }
}, getEmbedSrc = (t) => {
  if (!t)
    return null;
  const e = t.match(SRC_REGEX);
  return e ? e[1] : null;
}, SECONDS_IN_MINUTE = 60, MINUTES_IN_HOUR = 60, toTimecodeParts = (t) => {
  const e = parseTimecode(t) ?? 0;
  return {
    hours: Math.floor(e / (SECONDS_IN_MINUTE * MINUTES_IN_HOUR)),
    minutes: Math.floor(e / SECONDS_IN_MINUTE) % MINUTES_IN_HOUR,
    seconds: e % SECONDS_IN_MINUTE
  };
}, fromTimecodeParts = (t) => {
  const e = Math.max(0, Math.floor(t.hours || 0)), d = Math.max(0, Math.floor(t.minutes || 0)), r = Math.max(0, Math.floor(t.seconds || 0)), o = (l) => l < 10 ? `0${l}` : `${l}`;
  return e > 0 ? `${e}:${o(d)}:${o(r)}` : `${d}:${o(r)}`;
}, TIMECODE_PART_REGEX = /^\d{1,3}$/, MAX_TIMECODE_PARTS = 3, parseTimecode = (t) => {
  if (t == null || t === "")
    return null;
  if (typeof t == "number")
    return t >= 0 ? Math.floor(t) : null;
  let e = t;
  try {
    e = decodeURIComponent(t);
  } catch {
  }
  const d = e.trim().split(":");
  if (d.length > MAX_TIMECODE_PARTS)
    return null;
  let r = 0;
  for (const o of d) {
    const l = o.trim();
    if (!TIMECODE_PART_REGEX.test(l))
      return null;
    r = r * SECONDS_IN_MINUTE + parseInt(l, 10);
  }
  return r;
}, formatTimecode = (t) => fromTimecodeParts(toTimecodeParts(t)), TIMECODE_HREF_REGEX = /^#t=([^&]+)(?:&(?:v|b)=([\w-]+))?$/i, PLAYER_PATH_REGEX = /^\/v\/[\w-]+$/, TIMECODE_COPY_CLASS = "ez-timecode-copy", TIMECODE_COPIED_CLASS = "ez-timecode-copied", TIMECODE_COPIED_LIFETIME_MS = 2e3, TIMECODE_COPY_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>';
let videoWords = {
  copyTimecodeLink: "Copy the link to this moment",
  timecodeLinkCopied: "Link copied"
}, timecodeLinksStarted = !1, openedTimecode = null;
const parseTimecodeHref = (t) => {
  if (!t)
    return null;
  const e = TIMECODE_HREF_REGEX.exec(t.trim());
  if (!e)
    return null;
  const d = parseTimecode(e[1]);
  return d == null ? null : { seconds: d, target: e[2] };
}, playingIframes = [];
let videoTrackingStarted = !1;
const onPlayerMessage = (t) => {
  const e = (d) => {
    const r = d.data;
    if (!r || r.source != "AccelPlayer")
      return;
    const o = getPlayerIframeOf(d);
    o != null && t(r, o, d);
  };
  return window.addEventListener("message", e), () => window.removeEventListener("message", e);
}, getPlayerIframeOf = (t) => {
  const e = t.source;
  return e == null ? null : getPlayerIframes().filter((d) => d.contentWindow == e)[0] || null;
}, initVideoTracking = () => {
  videoTrackingStarted || (videoTrackingStarted = !0, onPlayerMessage((t, e) => {
    var o;
    const d = playingIframes.indexOf(e), r = t.event == "onPlay" || t.event == "onStart" || t.event == "onProgress" && ((o = t.value) == null ? void 0 : o.playing) == !0;
    r && d == -1 ? playingIframes.push(e) : !r && (t.event == "onPause" || t.event == "onStop") && d > -1 && playingIframes.splice(d, 1);
  }));
}, sendToPlayer = (t, e, d) => {
  t == null || t.postMessage(d === void 0 ? { action: e } : { action: e, value: d }, "*");
}, pausePlayingVideos = () => {
  const t = playingIframes.filter((e) => document.body.contains(e));
  return t.forEach((e) => sendToPlayer(e.contentWindow, "pause")), t;
}, playVideos = (t) => {
  t.forEach((e) => sendToPlayer(e.contentWindow, "play"));
}, pauseOtherVideos = (t) => {
  getPlayerIframes().filter((e) => e != t).forEach((e) => sendToPlayer(e.contentWindow, "pause"));
}, onVideoTimeReached = (t, e, d, r) => {
  const o = onPlayerMessage((l, h) => {
    var y;
    if (l.event != "onProgress")
      return;
    const f = (y = l.value) == null ? void 0 : y.currentTime;
    typeof f != "number" || f < t || h == findPlayerIframe(e, d) && (o(), r());
  });
}, initTimecodeLinks = (t, e) => {
  e && (videoWords = e), addTimecodeCopyButtons(t), openTimecodeFromUrl(), !timecodeLinksStarted && (timecodeLinksStarted = !0, window.addEventListener("hashchange", openTimecodeFromUrl));
}, openTimecodeFromUrl = () => {
  if (openedTimecode != null && openedTimecode.url == location.href && document.body.contains(openedTimecode.iframe))
    return;
  const t = parseTimecodeHref(location.hash);
  if (t == null)
    return;
  const e = getTimecodeLinks("body").filter((o) => o.timecode.seconds == t.seconds && o.timecode.target == t.target)[0], d = findPlayerIframe(t.target, (e == null ? void 0 : e.element) ?? document.body);
  if (d == null)
    return;
  openedTimecode = { url: location.href, iframe: d }, d.scrollIntoView({ block: "center" });
  const r = onPlayerMessage((o, l) => {
    if (l != d)
      return;
    const h = o.event == "onReady" || o.action == "currentTime";
    !h && o.event != "onUnavailable" || (r(), h && startPlayerAt(d, e ? "playAt" : "playAtLimited", t.seconds));
  });
  sendToPlayer(d.contentWindow, "getCurrentTime");
}, addTimecodeCopyButtons = (t) => {
  getTimecodeLinks(t).filter((e) => {
    var d;
    return !((d = e.element.nextElementSibling) != null && d.classList.contains(TIMECODE_COPY_CLASS));
  }).forEach((e) => e.element.insertAdjacentElement("afterend", createTimecodeCopyButton(e.element)));
}, createTimecodeCopyButton = (t) => {
  const e = document.createElement("button");
  e.type = "button", e.className = TIMECODE_COPY_CLASS, e.title = videoWords.copyTimecodeLink, e.setAttribute("aria-label", videoWords.copyTimecodeLink), e.dataset.copied = videoWords.timecodeLinkCopied, e.innerHTML = TIMECODE_COPY_ICON;
  let d = 0;
  return e.addEventListener("click", async (r) => {
    r.preventDefault(), r.stopPropagation(), await copyText(new URL(t.getAttribute("href") || "", location.href).href) && (window.clearTimeout(d), e.classList.add(TIMECODE_COPIED_CLASS), d = window.setTimeout(() => e.classList.remove(TIMECODE_COPIED_CLASS), TIMECODE_COPIED_LIFETIME_MS));
  }), e;
}, copyText = async (t) => {
  try {
    return await navigator.clipboard.writeText(t), !0;
  } catch {
    return copyTextBySelection(t);
  }
}, copyTextBySelection = (t) => {
  const e = document.createElement("textarea");
  e.value = t, e.setAttribute("readonly", ""), e.style.position = "fixed", e.style.top = "0", e.style.opacity = "0", document.body.appendChild(e), e.select();
  try {
    return document.execCommand("copy");
  } catch {
    return !1;
  } finally {
    document.body.removeChild(e);
  }
}, getTimecodeLinks = (t) => {
  const e = Array.prototype.slice.call(document.querySelectorAll(`${t} .ez [href]`)), d = [];
  return e.forEach((r) => {
    const o = parseTimecodeHref(r.getAttribute("href"));
    o != null && d.push({ element: r, timecode: o });
  }), d;
}, playVideoAt = (t, e) => {
  const d = findPlayerIframe(t.target, e);
  d != null && startPlayerAt(d, "playAt", t.seconds);
}, startPlayerAt = (t, e, d) => {
  t.contentWindow && (sendToPlayer(t.contentWindow, e, d), t.scrollIntoView({ behavior: "smooth", block: "center" }));
}, getPlayerIframes = () => Array.prototype.slice.call(document.querySelectorAll('iframe[src*="/v/"], iframe[data-src*="/v/"]')).filter((t) => isPlayerSrc(getPlayerSrc(t))), getPlayerSrc = (t) => t.getAttribute("src") || t.dataset.src || "", findPlayerIframe = (t, e) => {
  var o;
  const d = getPlayerIframes();
  if (d.length == 0)
    return null;
  if (t) {
    const l = (o = document.getElementById(t)) == null ? void 0 : o.querySelector("iframe");
    return l != null && isPlayerSrc(getPlayerSrc(l)) ? l : d.filter((h) => getPlayerVideoId(getPlayerSrc(h)) == t)[0] || null;
  }
  const r = d.filter((l) => (e.compareDocumentPosition(l) & Node.DOCUMENT_POSITION_PRECEDING) != 0);
  return r.length > 0 ? r[r.length - 1] : d[0];
}, isPlayerSrc = (t) => getPlayerVideoId(t) != null, getPlayerVideoId = (t) => {
  try {
    const e = new URL(t, document.baseURI).pathname;
    return PLAYER_PATH_REGEX.test(e) ? e.substring(3) : null;
  } catch {
    return null;
  }
}, MINI_PLAYER_CLASS = "ez-video-mini", MINI_PLAYER_PLACEHOLDER_CLASS = "ez-video-mini-placeholder", MINI_PLAYER_CLOSE_CLASS = "ez-video-mini-close", MINI_PLAYER_RESIZE_CLASS = "ez-video-mini-resize", MINI_PLAYER_WIDTH_KEY = "video-mini-width", MINI_PLAYER_CORNER_KEY = "video-mini-corner", MINI_PLAYER_MOVE_CLASS = "ez-video-mini-move", MINI_PLAYER_ARROW_UP = "↑", MINI_PLAYER_ARROW_DOWN = "↓", MINI_PLAYER_ARROW_LEFT = "←", MINI_PLAYER_ARROW_RIGHT = "→", MINI_PLAYER_EDGE = 20, MINI_PLAYER_MIN_WIDTH = 220, MINI_PLAYER_MAX_SCREEN_SHARE = 0.8, MINI_PLAYER_DEFAULT_WIDTH = 320, MINI_PLAYER_RATIO = 9 / 16;
let shownMiniPlayer = null, miniPlayerStarted = !1;
const initVideoMiniPlayer = () => {
  if (miniPlayerStarted || typeof IntersectionObserver > "u")
    return;
  miniPlayerStarted = !0;
  const t = [], e = (r) => {
    let o = t.filter((l) => l.iframe == r)[0];
    return o == null && (o = {
      iframe: r,
      enabled: !1,
      playing: !1,
      dismissed: !1,
      visible: !0,
      placeholder: null,
      close: null,
      resize: null,
      moveVertical: null,
      moveHorizontal: null,
      onResizeWindow: null,
      observer: d
    }, t.push(o), d.observe(r)), o;
  }, d = new IntersectionObserver((r) => {
    r.forEach((o) => {
      const l = t.filter((h) => h.iframe == o.target || h.placeholder == o.target)[0];
      l != null && (l.visible = o.isIntersecting, l.visible && (l.dismissed = !1), apply(l));
    });
  }, { threshold: 0 });
  onPlayerMessage((r, o) => {
    var f;
    const l = e(o);
    r.event == "onReady" && (l.enabled = r.miniPlayerEnabled == !0);
    const h = r.event != "onProgress" || ((f = r.value) == null ? void 0 : f.playing) == !0;
    (r.event == "onPlay" || r.event == "onStart" || r.event == "onProgress") && h && (!l.playing && r.byAutoplay != !0 && pauseOtherVideos(l.iframe), l.playing = !0), (r.event == "onPause" || r.event == "onStop" || r.event == "onUnavailable") && (l.playing = !1), apply(l);
  });
}, apply = (t) => {
  if (!document.body.contains(t.iframe)) {
    hide(t);
    return;
  }
  const e = shownMiniPlayer == null || shownMiniPlayer == t, d = t.enabled && t.playing && !t.visible && !t.dismissed && e;
  d != (t.placeholder != null) && (d ? show(t) : hide(t));
}, show = (t) => {
  var l;
  if (shownMiniPlayer != null && shownMiniPlayer != t)
    return;
  const e = t.iframe.getBoundingClientRect(), d = document.createElement("div");
  d.className = MINI_PLAYER_PLACEHOLDER_CLASS, d.style.width = `${e.width}px`, d.style.height = `${e.height}px`, (l = t.iframe.parentElement) == null || l.insertBefore(d, t.iframe), t.placeholder = d, t.observer.unobserve(t.iframe), t.observer.observe(d);
  const r = document.createElement("div");
  r.className = MINI_PLAYER_CLOSE_CLASS, r.innerHTML = "&times;", r.addEventListener("click", () => {
    t.dismissed = !0, apply(t);
  }), document.body.appendChild(r), t.close = r, t.moveVertical = addMoveButton(t, !0), t.moveHorizontal = addMoveButton(t, !1);
  const o = document.createElement("div");
  o.className = MINI_PLAYER_RESIZE_CLASS, o.addEventListener("pointerdown", (h) => startResizing(t, h)), document.body.appendChild(o), t.resize = o, t.iframe.classList.add(MINI_PLAYER_CLASS), layout(t, getStoredWidth()), t.onResizeWindow = () => layout(t, t.iframe.getBoundingClientRect().width), window.addEventListener("resize", t.onResizeWindow), shownMiniPlayer = t;
}, startResizing = (t, e) => {
  e.preventDefault();
  const d = e.clientX, r = t.iframe.getBoundingClientRect().width, o = getStoredCorner().indexOf("left") > -1, l = (f) => {
    const y = o ? f.clientX - d : d - f.clientX;
    layout(t, r + y);
  }, h = () => {
    window.removeEventListener("pointermove", l), window.removeEventListener("pointerup", h), storeWidth(t.iframe.getBoundingClientRect().width);
  };
  window.addEventListener("pointermove", l), window.addEventListener("pointerup", h);
}, layout = (t, e) => {
  const d = Math.round(Math.max(MINI_PLAYER_MIN_WIDTH, Math.min(e, getMaxWidth()))), r = Math.round(d * MINI_PLAYER_RATIO);
  t.iframe.style.setProperty("width", `${d}px`, "important"), t.iframe.style.setProperty("height", `${r}px`, "important");
  const o = t.iframe.getBoundingClientRect(), l = Math.round(o.width), h = Math.round(o.height), f = getStoredCorner(), y = f.indexOf("top") == 0, R = f.indexOf("left") > -1;
  place(t.iframe, y, R, MINI_PLAYER_EDGE, MINI_PLAYER_EDGE), t.close != null && place(t.close, y, R, MINI_PLAYER_EDGE + h + 6, MINI_PLAYER_EDGE + 4);
  const S = Math.max(34, l - 54);
  t.moveVertical != null && (place(t.moveVertical, y, R, MINI_PLAYER_EDGE + h + 6, MINI_PLAYER_EDGE + S), t.moveVertical.innerHTML = y ? MINI_PLAYER_ARROW_DOWN : MINI_PLAYER_ARROW_UP), t.moveHorizontal != null && (place(t.moveHorizontal, y, R, MINI_PLAYER_EDGE + h + 6, MINI_PLAYER_EDGE + S + 30), t.moveHorizontal.innerHTML = R ? MINI_PLAYER_ARROW_RIGHT : MINI_PLAYER_ARROW_LEFT), t.resize != null && place(t.resize, y, R, MINI_PLAYER_EDGE, MINI_PLAYER_EDGE + l - 22);
}, place = (t, e, d, r, o) => {
  t.style.setProperty(e ? "top" : "bottom", `${r}px`, "important"), t.style.setProperty(e ? "bottom" : "top", "auto", "important"), t.style.setProperty(d ? "left" : "right", `${o}px`, "important"), t.style.setProperty(d ? "right" : "left", "auto", "important");
}, addMoveButton = (t, e) => {
  const d = document.createElement("div");
  return d.className = MINI_PLAYER_MOVE_CLASS, d.addEventListener("click", () => {
    const r = getStoredCorner(), o = r.indexOf("top") == 0, l = r.indexOf("left") > -1;
    storeCorner(`${(e ? !o : o) ? "top" : "bottom"}-${(e ? l : !l) ? "left" : "right"}`), layout(t, t.iframe.getBoundingClientRect().width);
  }), document.body.appendChild(d), d;
}, getStoredCorner = () => {
  try {
    const t = localStorage.getItem(MINI_PLAYER_CORNER_KEY);
    return t == "top-left" || t == "top-right" || t == "bottom-left" ? t : "bottom-right";
  } catch {
    return "bottom-right";
  }
}, storeCorner = (t) => {
  try {
    localStorage.setItem(MINI_PLAYER_CORNER_KEY, t);
  } catch {
  }
}, getMaxWidth = () => {
  const t = window.innerWidth * MINI_PLAYER_MAX_SCREEN_SHARE, e = (window.innerHeight - MINI_PLAYER_EDGE * 2) / MINI_PLAYER_RATIO;
  return Math.max(MINI_PLAYER_MIN_WIDTH, Math.min(t, e));
}, getStoredWidth = () => {
  try {
    const t = parseInt(localStorage.getItem(MINI_PLAYER_WIDTH_KEY) || "", 10);
    return isNaN(t) ? MINI_PLAYER_DEFAULT_WIDTH : t;
  } catch {
    return MINI_PLAYER_DEFAULT_WIDTH;
  }
}, storeWidth = (t) => {
  try {
    localStorage.setItem(MINI_PLAYER_WIDTH_KEY, Math.round(t).toString());
  } catch {
  }
}, hide = (t) => {
  var e, d, r, o, l, h, f, y, R;
  t.iframe.classList.remove(MINI_PLAYER_CLASS), t.iframe.style.removeProperty("width"), t.iframe.style.removeProperty("height"), shownMiniPlayer == t && (shownMiniPlayer = null), t.placeholder != null && (t.observer.unobserve(t.placeholder), (e = t.placeholder.parentElement) == null || e.removeChild(t.placeholder), t.placeholder = null, t.observer.observe(t.iframe)), (r = (d = t.close) == null ? void 0 : d.parentElement) == null || r.removeChild(t.close), t.close = null, (l = (o = t.resize) == null ? void 0 : o.parentElement) == null || l.removeChild(t.resize), t.resize = null, (f = (h = t.moveVertical) == null ? void 0 : h.parentElement) == null || f.removeChild(t.moveVertical), t.moveVertical = null, (R = (y = t.moveHorizontal) == null ? void 0 : y.parentElement) == null || R.removeChild(t.moveHorizontal), t.moveHorizontal = null, t.onResizeWindow != null && (window.removeEventListener("resize", t.onResizeWindow), t.onResizeWindow = null);
}, POPUP_HOLDER_CLASS = "ez-popup-holder", POPUP_CLASS = "ez-popup", POPUP_CLOSE_CLASS = "ez-popup-close", POPUP_SHOWN_CLASS = "shown", POPUP_BACKDROP_CLASS = "ez-popup-backdrop", POPUP_AUTO_SHOW_ATTR = "ez-popup-auto-show", POPUP_STACK_ON_OPEN_ATTR = "ez-popup-stack-on-open", POPUP_VIDEO_TIME_ATTR = "ez-popup-video-time", POPUP_VIDEO_ID_ATTR = "ez-popup-video-id", POPUP_VIDEO_PAUSE_ATTR = "ez-popup-video-pause";
let videosPausedByPopup = [];
const BODY_POPUP_SHOW_CLASS = "ez-popup-shown", BODY_MIN_HEIGHT_CACHE = "bodyMinHeightCache", BACKDROP_BOUND = "popupBackdropBound", popupStack = [];
let popupZCounter = 0, bodyScrollCache = 0;
const holderOf = (t) => t.closest(`.${POPUP_HOLDER_CLASS}`), pruneStack = () => {
  for (let t = popupStack.length - 1; t >= 0; t--) {
    const e = popupStack[t];
    document.contains(e) && e.classList.contains(POPUP_SHOWN_CLASS) || popupStack.splice(t, 1);
  }
}, topPopup = () => (pruneStack(), popupStack[popupStack.length - 1] || null), initPopupTimers = (t) => {
  const e = document.querySelectorAll(`${t} .${POPUP_CLASS}`);
  for (let d = 0; d < e.length; d++) {
    const r = e[d], o = r.getAttribute(POPUP_AUTO_SHOW_ATTR);
    if (o) {
      const h = parseInt(o || "0");
      h > 0 && setTimeout(() => {
        showPopup(r.id);
      }, h * 1e3);
    }
    const l = r.getAttribute(POPUP_VIDEO_TIME_ATTR);
    if (l) {
      const h = parseTimecode(l);
      h != null && onVideoTimeReached(
        h,
        r.getAttribute(POPUP_VIDEO_ID_ATTR) || void 0,
        r,
        () => showPopup(r.id)
      );
    }
  }
}, hidePopup = (t) => {
  pruneStack();
  const e = typeof t == "string" ? popupStack.filter((o) => o.id == t).pop() : popupStack[popupStack.length - 1];
  if (!e)
    return;
  videosPausedByPopup.length > 0 && (playVideos(videosPausedByPopup), videosPausedByPopup = []), popupStack.splice(popupStack.indexOf(e), 1), e.classList.remove(POPUP_SHOWN_CLASS);
  const d = holderOf(e);
  if (d && !popupStack.some((o) => holderOf(o) == d)) {
    d.classList.remove(POPUP_SHOWN_CLASS), d.style.zIndex = "";
    const o = d.querySelector(`.${POPUP_BACKDROP_CLASS}`);
    o && o.classList.remove(POPUP_SHOWN_CLASS);
  }
  const r = e.querySelector("." + POPUP_CLOSE_CLASS);
  if (r && r.remove(), isInsideWidget() && d) {
    const o = document.querySelector("body");
    o && (d.style.overflow = "auto", o.style.minHeight = e[BODY_MIN_HEIGHT_CACHE] || "", window.dispatchEvent(new Event("resize")));
  }
  popupStack.length == 0 && (popupZCounter = 0, document.body.classList.remove(BODY_POPUP_SHOW_CLASS), document.body.style.position = "", document.body.style.top = "", window.scrollTo(0, bodyScrollCache));
}, showPopup = (t) => {
  const e = document.getElementById(t);
  if (!e || e.classList.contains(POPUP_CLASS) == !1)
    return;
  const d = holderOf(e);
  if (!d || d.classList.contains(POPUP_HOLDER_CLASS) == !1 || topPopup() == e)
    return;
  if (e.getAttribute(POPUP_STACK_ON_OPEN_ATTR) == null)
    for (; popupStack.length > 0; )
      hidePopup();
  d.classList.add(POPUP_SHOWN_CLASS);
  const r = d.querySelector(`.${POPUP_BACKDROP_CLASS}`);
  r && (r[BACKDROP_BOUND] || (r[BACKDROP_BOUND] = !0, r.addEventListener("click", () => hidePopup())), r.classList.add(POPUP_SHOWN_CLASS)), e.classList.add(POPUP_SHOWN_CLASS), e.getAttribute(POPUP_VIDEO_PAUSE_ATTR) && (videosPausedByPopup = videosPausedByPopup.concat(pausePlayingVideos())), popupStack.push(e), popupStack.length == 1 && (bodyScrollCache = window.pageYOffset || document.documentElement.scrollTop, document.body.classList.add(BODY_POPUP_SHOW_CLASS), document.body.style.position = "fixed", document.body.style.top = `-${bodyScrollCache}px`), popupZCounter++;
  const o = parseInt(getComputedStyle(d).zIndex);
  d.style.zIndex = String((isNaN(o) ? 0 : o) + popupZCounter);
  const l = document.createElement("div");
  if (l.classList.add(POPUP_CLOSE_CLASS), l.innerHTML = "×", l.addEventListener("click", () => hidePopup(e.id)), e.appendChild(l), isInsideWidget()) {
    const h = document.querySelector("body");
    h && (d.style.overflow = "hidden", e[BODY_MIN_HEIGHT_CACHE] = h.style.minHeight, h.style.minHeight = e.scrollHeight + 40 + "px", window.dispatchEvent(new Event("resize")));
  }
}, BOUND_ATTR = "ezclickbound", isOwnClick = (t, e) => {
  const d = e.target;
  if (!d || typeof d.closest != "function")
    return !0;
  const r = d.closest(`[${BOUND_ATTR}]`);
  return !r || r == t;
}, isActivationKey = (t) => t.key == "Enter" || t.key == " " || t.key == "Spacebar", onActivationKey = (t, e) => {
  t.addEventListener("keydown", (d) => {
    t.getAttribute("tabindex") != null && d.target == t && isActivationKey(d) && (d.preventDefault(), e());
  });
}, ensureCheckout = async () => {
  var t;
  await ((t = window.AXLEnsureCheckout) == null ? void 0 : t.call(window));
}, initClicks = (t) => {
  const e = document.querySelectorAll(`${t} [${ACTION_ATTR}], ${t} .ez [href]`);
  for (var d = 0; d < e.length; d++) {
    const r = e[d], o = r.getAttribute("href"), l = r.getAttribute("type") == "submit";
    if (l && r.removeAttribute("href"), r.setAttribute(BOUND_ATTR, ""), !o)
      l ? r._onSuccessFormSubmit = () => clickActionHandler(r) : (r.addEventListener("click", (h) => {
        isOwnClick(r, h) && clickActionHandler(r);
      }), onActivationKey(r, () => clickActionHandler(r)));
    else {
      const h = parseTimecodeHref(o);
      h ? r.addEventListener("click", (f) => {
        f.preventDefault(), playVideoAt(h, r);
      }) : l ? r._onSuccessFormSubmit = () => emulateClick(o || "", r.getAttribute("target")) : (r.addEventListener("click", (f) => {
        isOwnClick(r, f) && (f.preventDefault(), emulateClick(o || "", r.getAttribute("target")));
      }), onActivationKey(r, () => emulateClick(o || "", r.getAttribute("target"))));
    }
  }
}, copyToClipboard = async (t) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(t);
      return;
    }
  } catch (d) {
    console.error(d);
  }
  const e = document.createElement("textarea");
  e.value = t, e.setAttribute("readonly", ""), e.style.position = "fixed", e.style.opacity = "0", document.body.appendChild(e), e.select();
  try {
    document.execCommand("copy");
  } catch (d) {
    console.error(d);
  } finally {
    e.remove();
  }
}, clickActionHandler = (t) => {
  if (!t)
    return;
  const e = JSON.parse(t.getAttribute(ACTION_ATTR) || "");
  e.length > 0 && clickActionRun(0, e, t);
}, clickActionRun = async (index, actions, target) => {
  const currentAction = actions[index];
  if (currentAction)
    switch (currentAction.type) {
      case "link":
        const linkTo = replaceAXLVariables(currentAction.href || "", AXLReplaceTags.Id, axl_contactId());
        emulateClick(linkTo || "", currentAction.blank ? "_blank" : null);
        break;
      case "file":
        if (!currentAction.data)
          break;
        var fileUrl = `${axl_fileDownloadUrl()}/${currentAction.data}`;
        try {
          if (typeof axl_clickActions.fileDownload == "function") {
            var fileUrlResult = await axl_clickActions.fileDownload(currentAction.data);
            fileUrlResult && (fileUrl = fileUrlResult);
          }
        } catch (t) {
          console.error(t);
        }
        target.setAttribute("download", "true"), emulateClick(`${fileUrl}`, "_blank"), await clickActionRun(index + 1, actions, target);
        break;
      case "addToCart":
        var fastCheckout = currentAction.data2 == !0;
        await ensureCheckout(), await window.accel_checkout.cart.addToCart(currentAction.data, 1, fastCheckout), await clickActionRun(index + 1, actions, target);
        break;
      case "removeFromCart":
        var fullRemove = currentAction.data2 == !0;
        await ensureCheckout(), await window.accel_checkout.cart.removeFromCart(currentAction.data, fullRemove), await clickActionRun(index + 1, actions, target);
        break;
      case "goToCheckout":
        var checkoutUrl = `${axl_base_uri}/checkout`;
        isInsideWidget() && (axl_contactQueryStringParam && axl_contactId() && (checkoutUrl = updateOrSetQueryStringParam(checkoutUrl, axl_contactQueryStringParam, axl_contactId())), axl_guestQueryStringParam && axl_guestId() && (checkoutUrl = updateOrSetQueryStringParam(checkoutUrl, axl_guestQueryStringParam, axl_guestId()))), emulateClick(checkoutUrl, null);
        break;
      case "moveToSection":
        if (currentAction.data) {
          const t = document.getElementById(currentAction.data);
          if (t) {
            const e = document.querySelector(".ez-wrapper");
            if (e) {
              const d = t.offsetTop - e.offsetTop;
              document.body.scrollTop = d, document.documentElement.scrollTop = d;
            } else
              t.scrollIntoView({ block: "start" });
          }
        }
        await clickActionRun(index + 1, actions, target);
        break;
      case "redirectToCourseStep":
        window.goToCourseStep(currentAction.data, currentAction.blank);
        break;
      case "videoSeek":
        const videoSeek = parseVideoMomentSettings(currentAction.data), videoSeconds = parseTimecode(videoSeek.time);
        videoSeconds != null && playVideoAt({ seconds: videoSeconds, target: videoSeek.target }, target);
        break;
      case "imageZoom":
        var src = null;
        if (target.nodeName == "IMG")
          src = target.getAttribute("src");
        else {
          var img = target.querySelector("img");
          src = img.getAttribute("src");
        }
        if (!src)
          break;
        var container = target.closest(".ez-wrapper") || document.getElementsByClassName("ez-wrapper")[0];
        container && src && src.length > 0 && zoomImage(src, container);
        break;
      case "refreshPage":
        window.location.reload();
        break;
      case "runJS":
        const js = currentAction.data;
        try {
          if (js) {
            var replaced = replaceAXLVariables(js, AXLReplaceTags.Id, axl_contactId());
            eval(decodeURIComponent(replaced));
          }
        } finally {
          await clickActionRun(index + 1, actions, target);
          break;
        }
      case "runCustomEvent":
        try {
          axl_clickActions.runCustomEvent != null && await axl_clickActions.runCustomEvent(currentAction);
        } finally {
          await clickActionRun(index + 1, actions, target);
          break;
        }
      case "openContent":
        try {
          axl_clickActions.openContent != null && await axl_clickActions.openContent(currentAction);
        } finally {
          await clickActionRun(index + 1, actions, target);
          break;
        }
      case "copyToClipboard":
        if (currentAction.data) {
          const t = replaceAXLVariables(currentAction.data, AXLReplaceTags.Id, axl_contactId());
          await copyToClipboard(t);
        }
        await clickActionRun(index + 1, actions, target);
        break;
      case "showPopup":
        showPopup(currentAction.data), await clickActionRun(index + 1, actions, target);
        break;
      default:
        await clickActionRun(index + 1, actions, target);
    }
}, initAudios = (t) => {
  for (var e = document.querySelectorAll(`${t} .ez-audio audio`), d = 0; d < e.length; d++) {
    const o = e[d];
    if (!o.src) {
      var r = o.getAttribute("axlfileid");
      r && (o.src = `${axl_fileDownloadUrl()}/${r}`);
    }
  }
}, initHtmlEmbeds = (t) => {
  for (var e = document.querySelectorAll(`${t} .ez-html`), d = 0; d < e.length; d++) {
    const r = e[d];
    try {
      const o = r.querySelector(".ez-html-content[content]");
      if (!o)
        continue;
      let l = decodeURIComponent(o.getAttribute("content") || "");
      l = l.replace(/&nbsp;/g, " "), r.innerHTML = l;
      const h = (f) => {
        var y = r.querySelectorAll("script");
        const R = y[f];
        if (!R)
          return !0;
        const S = document.createElement("script");
        Array.from(R.attributes).forEach((N) => S.setAttribute(N.name, N.value)), S.appendChild(document.createTextNode(R.innerHTML)), R.parentNode && R.parentNode.replaceChild(S, R), S.getAttribute("onload") ? h(f + 1) : S.onload = () => {
          h(f + 1);
        };
      };
      h(0);
    } catch {
      r.remove();
    }
  }
}, initMenuToggle = (t) => {
  const e = document.querySelectorAll(`${t} .ez-menu-collapse-btn`);
  for (let d = 0; d < e.length; d++) {
    const r = e[d];
    r && r.addEventListener("click", showMenu);
  }
}, showMenu = (t) => {
  const e = t.currentTarget;
  if (!e)
    return;
  const d = e.closest(".ez-menu");
  d && d.classList.toggle("shown");
  const r = e.closest(".ez-section");
  r && r.classList.toggle("menu-shown");
}, initPseudoClicks = (t) => {
  for (var e = document.querySelectorAll(`${t} [${PSEUDO_CLICK_ATTR}]`), d = 0; d < e.length; d++) {
    const r = e[d];
    if (r != null) {
      const o = r.getAttribute("href"), l = r.getAttribute("target");
      o && (r.onclick = () => {
        emulateClick(o, l);
      });
    }
  }
}, checkConditionCache = [], isInFilter = async (t) => {
  var r;
  const e = axl_contactId() || "";
  var d = (r = checkConditionCache.find((o) => o.contactId == e && o.filterId == t)) == null ? void 0 : r.result;
  return typeof d > "u" && (d = await axl_userIsInFilter(e, t), checkConditionCache.push({ contactId: e, filterId: t, result: d || !1 })), d;
}, initConditions = async (t) => {
  var y;
  const e = document.querySelectorAll(`${t} [${CONDITION_ATTR}]`);
  for (var d = 0; d < e.length; d++) {
    const R = e[d];
    R.style.visibility = "hidden";
  }
  window.dispatchEvent(new Event("resize"));
  for (var d = 0; d < e.length; d++) {
    const S = e[d], N = JSON.parse(S.getAttribute(CONDITION_ATTR) || "[]");
    for (var r = 0; r < N.length; r++) {
      const C = N[r];
      if (!S)
        continue;
      const z = axl_contactId() != null;
      switch (C.type) {
        case "userIsAuth":
          (C.case == "showOnlyIf" && !z || C.case == "hideIf" && z) && S.remove();
          break;
        case "userIsNotAuth":
          (C.case == "showOnlyIf" && z || C.case == "hideIf" && !z) && S.remove();
          break;
        case "urlParam":
          const W = document.location.search, Y = new URLSearchParams(W);
          if (C.data && typeof C.data == "object" && C.data.key && C.data.value) {
            var o = Y.get((y = C.data) == null ? void 0 : y.key.trim()) == C.data.value.trim();
            (C.case == "showOnlyIf" && !o || C.case == "hideIf" && o) && S.remove();
          }
          break;
        case "urlContains":
          var l = document.location.href.indexOf(C.data) > -1;
          (C.case == "showOnlyIf" && !l || C.case == "hideIf" && l) && S.remove();
          break;
        case "userUnderFilter":
          if (!z && C.case == "showOnlyIf") {
            S.remove();
            break;
          }
          var h = await isInFilter(C.data);
          (C.case == "showOnlyIf" && h != !0 || C.case == "hideIf" && h == !0) && S.remove();
          break;
        case "userNotUnderFilter":
          if (!z && C.case == "hideIf") {
            S.remove();
            break;
          }
          var h = await isInFilter(C.data);
          (C.case == "showOnlyIf" && h != !1 || C.case == "hideIf" && h == !1) && S.remove();
          break;
        case "dateTime":
          try {
            let g = JSON.parse(C.data);
            if (!g.date)
              break;
            let v = new Date(g.date), $ = getComputedStyle(S).display, s = $, u = null, m = null;
            if (C.case == "showOnlyIf")
              switch (g.condition) {
                case "<":
                  m = v, s = "none";
                  break;
                case ">":
                  u = v, s = $;
                  break;
                case "period":
                  g.date2 && (u = v, m = new Date(g.date2), s = $);
                  break;
              }
            else if (C.case == "hideIf")
              switch (g.condition) {
                case "<":
                  u = v, s = $;
                  break;
                case ">":
                  m = v, s = "none";
                  break;
                case "period":
                  g.date2 && (m = v, u = new Date(g.date2), s = "none");
                  break;
              }
            checkConditionDateTime(S, $, u, m);
            let E = setInterval(() => {
              var w = checkConditionDateTime(S, $, u, m);
            }, 1e3);
          } catch {
            console.warn("Invalid condition data", C.data);
            break;
          }
          break;
        case "timeOfTheDay":
          try {
            let g = JSON.parse(C.data);
            if (!g.date)
              break;
            let v = g.date, $ = getComputedStyle(S).display, s = $, u = null, m = null;
            if (C.case == "showOnlyIf")
              switch (g.condition) {
                case "<":
                  m = v, s = "none";
                  break;
                case ">":
                  u = v, s = $;
                  break;
                case "period":
                  g.date2 && (u = v, m = g.date2, s = $);
                  break;
              }
            else if (C.case == "hideIf")
              switch (g.condition) {
                case "<":
                  u = v, s = $;
                  break;
                case ">":
                  m = v, s = "none";
                  break;
                case "period":
                  g.date2 && (u = g.date2, m = v, s = "none");
                  break;
              }
            checkConditionTime(S, $, u, m);
            let E = setInterval(() => {
              var w = checkConditionTime(S, $, u, m);
            }, 1e3);
          } catch {
            console.warn("Invalid condition data", C.data);
            break;
          }
          break;
        case "videoTime":
          const P = parseVideoMomentSettings(C.data), F = parseTimecode(P.time);
          if (F == null) {
            console.warn("Invalid condition data", C.data);
            break;
          }
          applyVideoTimeCondition(
            S,
            F,
            P.target,
            C.case == "showOnlyIf"
            /* showOnlyIf */
          );
          break;
        case "weekDay":
          let Z = JSON.parse(C.data);
          if (!Z.weekDays)
            break;
          var f = (/* @__PURE__ */ new Date()).getDay();
          Z.weekDays.indexOf(f) == -1 ? C.case == "showOnlyIf" && S.remove() : C.case == "hideIf" && S.remove();
          break;
      }
    }
    S.style.visibility = "";
  }
  window.dispatchEvent(new Event("resize"));
}, applyVideoTimeCondition = (t, e, d, r) => {
  const o = getComputedStyle(t).display, l = o == "none" ? "" : o, h = (f) => {
    const y = f == r ? l : "none";
    t.style.display != y && (t.style.display = y, window.dispatchEvent(new Event("resize")));
  };
  h(!1), onVideoTimeReached(e, d, t, () => h(!0));
}, checkConditionDateTime = (t, e, d, r) => {
  var o = getComputedStyle(t).display, l = o, h = (/* @__PURE__ */ new Date()).getTime();
  if (d && r) {
    var f = r.getTime() < d.getTime();
    f ? h > r.getTime() && h < d.getTime() ? l = "none" : l = e : h > d.getTime() && h < r.getTime() ? l = e : l = "none";
  } else
    d ? h >= d.getTime() ? l = e : l = "none" : r && (h < r.getTime() ? l = e : l = "none");
  return o != l && window.dispatchEvent(new Event("resize")), t.style.display = l, l;
}, checkConditionTime = (t, e, d, r) => {
  var o = getComputedStyle(t).display, l = o, h = /* @__PURE__ */ new Date(), f = h.getUTCHours() * 60 + h.getUTCMinutes(), y = parseInt((d == null ? void 0 : d.split(":")[0]) || "0") * 60 + parseInt((d == null ? void 0 : d.split(":")[1]) || "0"), R = parseInt((r == null ? void 0 : r.split(":")[0]) || "0") * 60 + parseInt((r == null ? void 0 : r.split(":")[1]) || "0");
  if (r == "00:00" && (R = 24 * 60), d && r) {
    var S = R > y;
    S ? f >= y && f < R ? l = e : l = "none" : f < R || f >= y ? l = e : l = "none";
  } else
    d ? f >= y ? l = e : l = "none" : r && (f < R ? l = e : l = "none");
  return o != l && window.dispatchEvent(new Event("resize")), t.style.display = l, l;
}, QUIZ_ID_ATTR = "ez-quiz-id", triggerResize = (t) => {
  window.dispatchEvent(new CustomEvent("resize", {
    detail: {
      height: t.scrollHeight
    }
  }));
}, initQuiz = (t) => {
  var r;
  var e = document.querySelectorAll(`${t} .ez-quiz`);
  if (e.length == 0)
    return;
  const d = (r = window.AXLData) == null ? void 0 : r.quizSettings;
  if (!d) {
    console.error("Couldn't init quiz. AXLData.quizSettings is undefined", t);
    return;
  }
  injectStyle(d.styleSrc), injectScript(d.scriptSrc).then(() => {
    for (var o = 0; o < e.length; o++) {
      const l = e[o], h = l.parentElement;
      try {
        const f = l.getAttribute(QUIZ_ID_ATTR);
        l.quiz = new window.AccelQuiz({
          container: l,
          quizId: f,
          lang: d.lang,
          loc: d.loc,
          config: d.config,
          onRedirect: (y, R) => emulateClick(y, R ? "_blank" : "_self"),
          // trigger to recalc widget viewport
          onMounted: () => triggerResize(h ?? l),
          onPageSwitched: () => {
            setTimeout(() => {
              triggerResize(h ?? l);
            }, 200);
          },
          onCompleted: (y) => {
            window.AXLWebsite && window.AXLWebsite.dispatch(AXLWebsiteEventEnum.FormSubmit, y), setTimeout(() => {
              triggerResize(h ?? l);
            }, 200);
          },
          onContactChanged: (y) => {
            var R;
            (R = window.ao) == null || R.setContactId(y);
          }
        });
      } catch (f) {
        console.error("[quiz] AccelQuiz init failed for quizId", l.getAttribute(QUIZ_ID_ATTR), f), l.remove();
      }
    }
  });
}, sc$1 = (t) => (t || "").replace(/[<>{}";]/g, "").trim(), parseProps$2 = (t) => {
  const e = (d, r = "") => t.getAttribute(d) || r;
  return {
    slidesPerView: parseInt(e("data-slides-per-view", "1")) || 1,
    spaceBetween: parseInt(e("data-space-between", "20")) || 20,
    autoplay: e("data-autoplay") === "true",
    autoplayDelay: parseInt(e("data-autoplay-delay", "3000")) || 3e3,
    loop: e("data-loop") === "true",
    showNavigation: e("data-show-navigation", "true") === "true",
    showPagination: e("data-show-pagination", "true") === "true",
    paginationType: e("data-pagination-type", "bullets"),
    effect: e("data-effect", "slide"),
    speed: parseInt(e("data-speed", "300")) || 300,
    navColor: e("data-nav-color", "#333333"),
    navSize: e("data-nav-size", "24px"),
    paginationColor: e("data-pagination-color", "#cccccc"),
    paginationActiveColor: e("data-pagination-active-color", "#1890ff"),
    slideMinHeight: e("data-slide-min-height", "200px")
  };
};
let sliderStyleInjected = !1;
const ensureBaseStyle = () => {
  if (sliderStyleInjected)
    return;
  sliderStyleInjected = !0;
  const t = document.createElement("style");
  t.textContent = `
		.ez-slider-vp { position: relative; overflow: hidden; width: 100%; box-sizing: border-box; }
		.ez-slider-track { display: flex; will-change: transform; }
		.ez-slider-cell { flex: 0 0 auto; box-sizing: border-box; }
		.ez-slider-cell > * { height: 100%; }
		.ez-slider-fade .ez-slider-track { display: block; position: relative; }
		.ez-slider-fade .ez-slider-cell { position: absolute; inset: 0; width: 100% !important; opacity: 0; transition: opacity var(--ez-slider-speed, 300ms) ease; }
		.ez-slider-fade .ez-slider-cell.is-active { position: relative; opacity: 1; }
		.ez-slider-nav { position: absolute; top: 50%; transform: translateY(-50%); z-index: 2; cursor: pointer; user-select: none; line-height: 1; background: transparent; border: none; padding: 4px; }
		.ez-slider-nav.prev { left: 8px; }
		.ez-slider-nav.next { right: 8px; }
		.ez-slider-dots { display: flex; justify-content: center; gap: 8px; padding-top: 10px; }
		.ez-slider-dots .ez-slider-dot { width: 9px; height: 9px; border-radius: 50%; border: none; padding: 0; cursor: pointer; }
		.ez-slider-fraction { text-align: center; padding-top: 10px; font-size: 13px; }
		.ez-slider-progress { height: 4px; margin-top: 10px; border-radius: 2px; overflow: hidden; }
		.ez-slider-progress > span { display: block; height: 100%; width: 0; transition: width var(--ez-slider-speed, 300ms) ease; }
	`, document.head.appendChild(t);
}, hydrate$1 = (t, e) => {
  const d = Array.from(
    t.querySelectorAll(":scope > .ez-slide, :scope > div > .ez-slide")
  );
  if (d.length === 0)
    return;
  ensureBaseStyle();
  const r = e.effect === "slide" || e.effect === "coverflow", o = !r, l = r ? Math.max(1, e.slidesPerView) : 1, h = r ? e.spaceBetween : 0, f = document.createElement("div");
  f.className = "ez-slider-vp" + (o ? " ez-slider-fade" : ""), f.style.setProperty("--ez-slider-speed", `${e.speed}ms`);
  const y = document.createElement("div");
  y.className = "ez-slider-track", r && (y.style.gap = `${h}px`), y.style.transition = `transform ${e.speed}ms ease`;
  const R = d.map((w) => {
    const T = document.createElement("div");
    return T.className = "ez-slider-cell", T.style.minHeight = sc$1(e.slideMinHeight || "200px"), r && (T.style.width = l > 1 ? `calc((100% - ${(l - 1) * h}px) / ${l})` : "100%"), T.appendChild(w), y.appendChild(T), T;
  });
  f.appendChild(y), t.innerHTML = "", t.style.position = "relative", t.appendChild(f);
  const S = R.length, N = r ? Math.max(0, S - l) : S - 1;
  let C = 0, z, W;
  if (e.showNavigation) {
    z = document.createElement("button"), z.type = "button", z.className = "ez-slider-nav prev", z.innerHTML = "&#10094;", W = document.createElement("button"), W.type = "button", W.className = "ez-slider-nav next", W.innerHTML = "&#10095;";
    const w = sc$1(e.navColor || "#333"), T = sc$1(e.navSize || "24px");
    [z, W].forEach((H) => {
      H.style.color = w, H.style.fontSize = T;
    }), f.appendChild(z), f.appendChild(W);
  }
  let Y, P, F;
  const Z = sc$1(e.paginationColor || "#ccc"), g = sc$1(e.paginationActiveColor || "#1890ff");
  if (e.showPagination)
    if (e.paginationType === "fraction")
      P = document.createElement("div"), P.className = "ez-slider-fraction", P.style.color = g, t.appendChild(P);
    else if (e.paginationType === "progressbar") {
      const w = document.createElement("div");
      w.className = "ez-slider-progress", w.style.background = Z, F = document.createElement("span"), F.style.background = g, w.appendChild(F), t.appendChild(w);
    } else {
      Y = document.createElement("div"), Y.className = "ez-slider-dots";
      for (let w = 0; w < (r ? N + 1 : S); w++) {
        const T = document.createElement("button");
        T.type = "button", T.className = "ez-slider-dot", T.style.background = Z;
        const H = w;
        T.addEventListener("click", () => u(H, !0)), Y.appendChild(T);
      }
      t.appendChild(Y);
    }
  const v = () => {
    var w;
    if (o)
      R.forEach((T, H) => T.classList.toggle("is-active", H === C));
    else {
      const T = ((w = R[0]) == null ? void 0 : w.getBoundingClientRect().width) || 0, H = C * (T + h);
      y.style.transform = `translateX(-${H}px)`;
    }
    if (Y && Array.from(Y.children).forEach((T, H) => {
      T.style.background = H === C ? g : Z;
    }), P) {
      const T = r ? N + 1 : S;
      P.textContent = `${C + 1} / ${T}`;
    }
    if (F) {
      const T = r ? N + 1 : S;
      F.style.width = T > 1 ? `${C / (T - 1) * 100}%` : "100%";
    }
  }, $ = (w) => e.loop ? w < 0 ? N : w > N ? 0 : w : Math.max(0, Math.min(N, w));
  let s = null;
  function u(w, T = !1) {
    C = $(w), v(), T && s && s();
  }
  z == null || z.addEventListener("click", () => u(C - 1, !0)), W == null || W.addEventListener("click", () => u(C + 1, !0));
  let m = 0, E = !1;
  if (f.addEventListener("touchstart", (w) => {
    m = w.touches[0].clientX, E = !0;
  }, { passive: !0 }), f.addEventListener("touchend", (w) => {
    if (!E)
      return;
    E = !1;
    const T = w.changedTouches[0].clientX - m;
    Math.abs(T) > 40 && u(T < 0 ? C + 1 : C - 1, !0);
  }), e.autoplay && N > 0) {
    let w = window.setInterval(() => {
      C = $(C + 1), v();
    }, e.autoplayDelay);
    s = () => {
      w && (window.clearInterval(w), w = 0);
    };
  }
  window.addEventListener("resize", () => v()), v();
}, initSlider = (t) => {
  document.querySelectorAll(`${t} [data-ez-slider="wrapper"]`).forEach((d) => {
    if (d.dataset.ezInit === "slider")
      return;
    const r = parseProps$2(d);
    d.querySelectorAll(":scope > .ez-slide, :scope > div > .ez-slide").length !== 0 && (d.dataset.ezInit = "slider", hydrate$1(d, r));
  });
}, STYLE_ID = "ez-accordion-styles", sc = (t) => (t || "").replace(/[<>{}";]/g, "").trim(), parseProps$1 = (t) => {
  const e = (d, r) => sc(t.getAttribute(d) || "") || r;
  return {
    allowMultiple: t.getAttribute("data-allow-multiple") !== "false",
    defaultOpenFirst: t.getAttribute("data-default-open-first") !== "false",
    expandIcon: e("data-expand-icon", "arrow"),
    headerBgColor: e("data-header-bg-color", "#fafafa"),
    headerTextColor: e("data-header-text-color", "#333333"),
    headerFontFamily: e("data-header-font-family", ""),
    headerPaddingV: e("data-header-padding-v", "12px"),
    headerPaddingH: e("data-header-padding-h", "16px"),
    headerBorderColor: e("data-header-border-color", "#d9d9d9"),
    bodyBgColor: e("data-body-bg-color", "#ffffff"),
    bodyPaddingV: e("data-body-padding-v", "16px"),
    bodyPaddingH: e("data-body-padding-h", "16px"),
    borderRadius: e("data-border-radius", "8px"),
    animationSpeed: e("data-animation-speed", "0.3s")
  };
}, parseDurationMs = (t) => {
  const e = parseFloat(t);
  return isNaN(e) ? 300 : t.endsWith("ms") ? e : e * 1e3;
}, ensureStyles = () => {
  if (document.getElementById(STYLE_ID))
    return;
  const t = document.createElement("style");
  t.id = STYLE_ID, t.textContent = `
		[data-ez-accordion="wrapper"] {
			overflow: hidden;
			border-radius: var(--ez-acc-radius, 8px);
			border: 1px solid var(--ez-acc-border-color, #d9d9d9);
		}
		.ez-acc-header {
			margin: 0;
			background: var(--ez-acc-header-bg, #fafafa);
			color: var(--ez-acc-header-color, #333333);
			font-family: var(--ez-acc-header-font, inherit);
			padding: var(--ez-acc-header-pad-v, 12px) var(--ez-acc-header-pad-h, 16px);
			cursor: pointer;
			user-select: none;
			display: flex;
			align-items: center;
			gap: 10px;
			border-bottom: 1px solid var(--ez-acc-border-color, #d9d9d9);
			font-weight: 500;
			transition: background var(--ez-acc-speed, 0.3s);
		}
		.ez-acc-header:hover { filter: brightness(0.97); }
		.ez-acc-header .ez-acc-icon { transition: transform var(--ez-acc-speed, 0.3s); flex-shrink: 0; font-size: 12px; }
		.ez-acc-header[data-open="true"] .ez-acc-icon { transform: rotate(90deg); }
		.ez-acc-header[data-open="true"] .ez-acc-icon-plus { transform: rotate(45deg); }
		.ez-acc-body {
			background: var(--ez-acc-body-bg, #ffffff);
			overflow: hidden;
			transition: max-height var(--ez-acc-speed, 0.3s) ease, padding var(--ez-acc-speed, 0.3s) ease;
			max-height: 0;
			padding: 0 var(--ez-acc-body-pad-h, 16px);
		}
		.ez-acc-body[data-open="true"] { padding: var(--ez-acc-body-pad-v, 16px) var(--ez-acc-body-pad-h, 16px); }
		.ez-acc-panel:last-child .ez-acc-header { border-bottom: var(--ez-acc-last-border, none); }
	`, document.head.appendChild(t);
}, applyVariables = (t, e, d) => {
  const r = {
    "--ez-acc-header-bg": e.headerBgColor,
    "--ez-acc-header-color": e.headerTextColor,
    "--ez-acc-header-font": e.headerFontFamily,
    "--ez-acc-header-pad-v": e.headerPaddingV,
    "--ez-acc-header-pad-h": e.headerPaddingH,
    "--ez-acc-border-color": e.headerBorderColor,
    "--ez-acc-body-bg": e.bodyBgColor,
    "--ez-acc-body-pad-v": e.bodyPaddingV,
    "--ez-acc-body-pad-h": e.bodyPaddingH,
    "--ez-acc-speed": e.animationSpeed,
    "--ez-acc-radius": e.borderRadius,
    "--ez-acc-last-border": d > 1 ? `1px solid ${e.headerBorderColor}` : "none"
  };
  Object.keys(r).forEach((o) => t.style.setProperty(o, r[o]));
}, setPanelOpen = (t, e, d) => {
  if (window.clearTimeout(t.releaseTimer), t.header.setAttribute("data-open", e ? "true" : "false"), t.body.setAttribute("data-open", e ? "true" : "false"), !d) {
    t.body.style.maxHeight = e ? "none" : "0px";
    return;
  }
  if (t.body.style.maxHeight = `${t.body.scrollHeight}px`, e) {
    t.releaseTimer = window.setTimeout(() => t.body.style.maxHeight = "none", t.durationMs + 50);
    return;
  }
  t.body.offsetHeight, t.body.style.maxHeight = "0px";
}, readPanels = (t) => Array.from(
  t.querySelectorAll(":scope > .ez-accordion-item, :scope > div > .ez-accordion-item")
).map((d, r) => {
  var f;
  const o = d.querySelector(".ez-accordion-item-header"), l = (f = o == null ? void 0 : o.textContent) == null ? void 0 : f.trim();
  o == null || o.remove();
  const h = d.querySelector(".ez-accordion-item-body");
  if (h) {
    const y = document.createDocumentFragment();
    for (; h.firstChild; )
      y.appendChild(h.firstChild);
    d.innerHTML = "", d.appendChild(y);
  }
  return {
    title: l || d.getAttribute("data-accordion-title") || `Panel ${r + 1}`,
    content: d,
    isOpen: d.getAttribute("data-accordion-open") === "true"
  };
}), applyOpenState = (t, e) => {
  if (e.defaultOpenFirst ? t.length > 0 && !t.some((d) => d.isOpen) && (t[0].isOpen = !0) : t.forEach((d) => d.isOpen = !1), !e.allowMultiple) {
    const d = t.findIndex((r) => r.isOpen);
    t.forEach((r, o) => r.isOpen = o === d);
  }
}, hydrate = (t, e) => {
  const d = readPanels(t);
  if (d.length === 0)
    return;
  const r = parseDurationMs(e.animationSpeed);
  applyOpenState(d, e), ensureStyles(), t.innerHTML = "", applyVariables(t, e, d.length);
  const o = () => {
    if (e.expandIcon === "none")
      return null;
    const h = document.createElement("span");
    return h.className = e.expandIcon === "plus" ? "ez-acc-icon ez-acc-icon-plus" : "ez-acc-icon", h.textContent = e.expandIcon === "plus" ? "+" : "▸", h;
  }, l = [];
  d.forEach((h) => {
    const f = document.createElement("div");
    f.className = "ez-acc-panel";
    const y = document.createElement("h3");
    y.className = "ez-acc-header";
    const R = o();
    R && y.appendChild(R);
    const S = document.createElement("span");
    S.textContent = h.title, y.appendChild(S);
    const N = document.createElement("div");
    N.className = "ez-acc-body", N.appendChild(h.content);
    const C = { header: y, body: N, durationMs: r, releaseTimer: 0 };
    l.push(C), y.addEventListener("click", () => {
      const z = y.getAttribute("data-open") !== "true";
      z && !e.allowMultiple && l.forEach((W) => {
        W !== C && setPanelOpen(W, !1, !0);
      }), setPanelOpen(C, z, !0);
    }), f.appendChild(y), f.appendChild(N), t.appendChild(f);
  }), l.forEach((h, f) => setPanelOpen(h, d[f].isOpen, !1));
}, initAccordion = (t) => {
  document.querySelectorAll(`${t} [data-ez-accordion="wrapper"]`).forEach((d) => {
    d.dataset.ezInit === "accordion" || d.querySelectorAll(":scope > .ez-accordion-item, :scope > div > .ez-accordion-item").length === 0 || (d.dataset.ezInit = "accordion", hydrate(d, parseProps$1(d)));
  });
}, defaultWords = {
  notConfigured: "Application is not configured",
  noInstance: "The installed application instance is not specified",
  unavailable: "Application is unavailable",
  loadError: "Loading error",
  guest: "Guest"
}, getWords = () => {
  var e, d;
  const t = (d = (e = window.AXLData) == null ? void 0 : e.vendorAppBlockSettings) == null ? void 0 : d.loc;
  return { ...defaultWords, ...t };
}, contactCookieName = "a_c", collectionQuery = (t) => {
  const e = new URLSearchParams();
  return e.set("limit", String(t.limit || 200)), t.filter && Object.keys(t.filter).length > 0 && e.set("filter", JSON.stringify(t.filter)), t.sort && e.set("sort", t.sort), t.sortCast && e.set("sortCast", t.sortCast), t.desc !== void 0 && e.set("desc", String(t.desc)), t.cursorSort && e.set("cursorSort", t.cursorSort), t.cursorDocId && e.set("cursorDocId", t.cursorDocId), e.toString();
}, getVisitor = () => {
  var d, r;
  const t = (r = (d = window.AXLData) == null ? void 0 : d.vendorAppBlockSettings) == null ? void 0 : r.visitor, e = (t == null ? void 0 : t.contactId) || api.get(contactCookieName) || "";
  return { isAuthorized: !!(t != null && t.isAuthorized) || !!e, contactId: e };
}, rememberVisitor = (t) => {
  var d, r;
  const e = (d = window.AXLData) == null ? void 0 : d.vendorAppBlockSettings;
  e && (e.visitor = { isAuthorized: !0, contactId: t }), (r = window.ao) == null || r.setContactId(t);
}, parseProps = (t) => {
  const e = (l, h = "") => t.getAttribute(l) || h;
  let d = {};
  try {
    d = JSON.parse(e("data-config", "{}"));
  } catch {
    d = {};
  }
  const r = e("data-css-override", "");
  let o = "";
  try {
    o = r ? decodeURIComponent(r) : "";
  } catch {
    o = "";
  }
  return {
    appSlug: e("data-app-slug", ""),
    schoolLinkId: e("data-school-link-id", ""),
    surfaceKind: e("data-surface-kind", "site-block"),
    config: d,
    minHeight: parseInt(e("data-min-height", "0"), 10) || 0,
    showHeader: e("data-show-header", "false") === "true",
    cssOverride: o
  };
}, RUNTIME_SDK = `
<script>
(function () {
  var pending = Object.create(null), rpcSeq = 0, readyCbs = [], contextCbs = [], ctx = null;
  function nextId() { return 'r' + (++rpcSeq); }
  var queryOptionNames = ['filter', 'sort', 'sortCast', 'desc', 'limit', 'cursorSort', 'cursorDocId'];
  function warnUnknownQueryOptions(method, opts) {
    if (!opts || typeof opts !== 'object') return opts;
    var unknown = Object.keys(opts).filter(function (key) { return queryOptionNames.indexOf(key) < 0; });
    if (unknown.length) console.warn('[xl] ' + method + ': unknown option(s) ' + unknown.join(', ') + ' are ignored. Supported: ' + queryOptionNames.join(', ') + '.');
    return opts;
  }

  function call(kind, args) {
    var id = nextId();
    return new Promise(function (res, rej) {
      pending[id] = { res: res, rej: rej };
      window.parent.postMessage(Object.assign({ kind: kind, rpcId: id }, args || {}), '*');
    });
  }
  window.addEventListener('message', function (e) {
    var m = e.data;
    if (!m || typeof m !== 'object') return;
    if (m.kind === 'xl.ready') {
      var wasReady = !!ctx;
      ctx = m.context;
      window.xl.user = ctx.user; window.xl.school = ctx.school; window.xl.app = ctx.app;
      window.xl.surface = ctx.surface || null; window.xl.protocolVersion = m.protocolVersion;
      window.xl.block = { config: (ctx.surface && ctx.surface.config) || {} };
      if (wasReady) {
        for (var c = 0; c < contextCbs.length; c++) try { contextCbs[c](ctx); } catch (_) {}
        return;
      }
      for (var i = 0; i < readyCbs.length; i++) try { readyCbs[i](ctx); } catch (_) {}
      readyCbs = [];
      return;
    }
    if (m.kind === 'xl.rpc.ok' && pending[m.rpcId]) { var p = pending[m.rpcId]; delete pending[m.rpcId]; p.res(m.result); return; }
    if (m.kind === 'xl.rpc.error' && pending[m.rpcId]) { var pe = pending[m.rpcId]; delete pending[m.rpcId]; var err = new Error(m.message || 'RPC error'); err.code = m.code; pe.rej(err); return; }
  });
  function xlReady(cb) {
    if (typeof cb === 'function') { if (ctx) cb(ctx); else readyCbs.push(cb); }
    return xlReady;
  }
  xlReady.then = function (onFulfilled, onRejected) {
    return new Promise(function (resolve) { xlReady(resolve); }).then(onFulfilled, onRejected);
  };
  function locale() { return (ctx && ctx.school && ctx.school.locale) || 'ru'; }
  function tz() { return (ctx && ctx.school && ctx.school.timezone) || undefined; }
  window.xl = {
    user: null, school: null, app: null, surface: null, protocolVersion: null,
    block: { config: {} },
    ready: xlReady,
    onContextChange: function (cb) {
      if (typeof cb !== 'function') return function () {};
      contextCbs.push(cb);
      return function () { var i = contextCbs.indexOf(cb); if (i >= 0) contextCbs.splice(i, 1); };
    },
    format: {
      date: function (d, opts) { var o = opts || {}, hasC = o.weekday || o.year || o.month || o.day; var base = hasC ? { timeZone: tz() } : { dateStyle: 'medium', timeZone: tz() }; return new Intl.DateTimeFormat(locale(), Object.assign(base, o)).format(new Date(d)); },
      time: function (d, opts) { var o = opts || {}, hasC = o.hour || o.minute || o.second; var base = hasC ? { timeZone: tz() } : { timeStyle: 'short', timeZone: tz() }; return new Intl.DateTimeFormat(locale(), Object.assign(base, o)).format(new Date(d)); },
      dateTime: function (d, opts) { return new Intl.DateTimeFormat(locale(), Object.assign({ dateStyle: 'medium', timeStyle: 'short', timeZone: tz() }, opts || {})).format(new Date(d)); },
      number: function (n, opts) { return new Intl.NumberFormat(locale(), opts || {}).format(Number(n)); },
      plural: function (n, forms) { if (!forms) return String(n); var rule = new Intl.PluralRules(locale()).select(Number(n)); return forms[rule] || forms.other || String(n); },
      relativeTime: function (d) { var diff = (new Date(d).getTime() - Date.now()) / 1000; var rtf = new Intl.RelativeTimeFormat(locale(), { numeric: 'auto' }); var abs = Math.abs(diff); if (abs < 60) return rtf.format(Math.round(diff), 'second'); if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute'); if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour'); if (abs < 86400 * 30) return rtf.format(Math.round(diff / 86400), 'day'); if (abs < 86400 * 365) return rtf.format(Math.round(diff / (86400 * 30)), 'month'); return rtf.format(Math.round(diff / (86400 * 365)), 'year'); },
    },
    storage: {
      get: function (collection, docId) { return call('xl.storage.get', { collection: collection, docId: docId }); },
      query: function (collection, opts) { return call('xl.storage.query', Object.assign({ collection: collection }, warnUnknownQueryOptions('xl.storage.query', opts) || {})); },
      put: function () { return Promise.reject(new Error('storage write disabled on public site')); },
      delete: function () { return Promise.reject(new Error('storage write disabled on public site')); },
    },
    public: {
      query: function (collection, opts) { return call('xl.public.query', Object.assign({ collection: collection }, warnUnknownQueryOptions('xl.public.query', opts) || {})); },
      get: function (collection, docId) { return call('xl.public.get', { collection: collection, docId: docId }); },
      create: function (collection, data) { return call('xl.public.create', { collection: collection, data: data == null ? {} : data }); },
      crm: {
        me: function () { return call('xl.public.crm.me', {}); },
        findOrCreate: function (input) { return call('xl.public.crm.findOrCreate', input || {}); },
        attachRecord: function (input) { return call('xl.public.crm.attachRecord', input || {}); },
      },
      scenarios: {
        emit: function (eventKind, data, opts) { return call('xl.public.scenarios.emit', { eventKind: eventKind, studentId: opts && opts.studentId, data: data == null ? {} : data }); },
      },
    },
    learner: {
      courses: function () { return call('xl.learner.courses', {}); },
      lessons: function (opts) { return call('xl.learner.lessons', { courseId: opts && opts.courseId }); },
    },
    state: {
      get: function (key) { return call('xl.state.get', { key: String(key) }); },
      set: function (key, value, opts) { return call('xl.state.set', { key: String(key), value: value, ttlSec: opts && opts.ttlSec }); },
    },
    config: { submit: function () {}, cancel: function () {} },
    ui: { toast: function () {}, openLink: function (u) { window.open(u, '_blank'); }, resize: function (h) { window.parent.postMessage({ kind: 'xl.ui.resize', height: h }, '*'); } },
  };
  window.parent.postMessage({ kind: 'xl.init' }, '*');
  var __lastH = 0;
  function __reportH() { var h = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight, document.body.offsetHeight); if (h && Math.abs(h - __lastH) > 1) { __lastH = h; window.parent.postMessage({ kind: 'xl.ui.resize', height: h }, '*'); } }
  if (typeof ResizeObserver !== 'undefined') { try { var __ro = new ResizeObserver(__reportH); __ro.observe(document.body); __ro.observe(document.documentElement); } catch (e) {} }
  if (typeof MutationObserver !== 'undefined') { try { new MutationObserver(__reportH).observe(document.body, { childList: true, subtree: true, attributes: true }); } catch (e) {} }
  window.addEventListener('load', __reportH); window.addEventListener('resize', __reportH);
  setTimeout(__reportH, 250); setTimeout(__reportH, 900); setTimeout(__reportH, 2500);
})();
<\/script>
`, appStateKey = (t, e) => `xl:appstate:${t}:${e}`, readAppState = (t, e) => {
  if (!e)
    return null;
  try {
    const d = window.localStorage.getItem(appStateKey(t, e));
    if (!d)
      return null;
    const r = JSON.parse(d);
    return r.expiresAt && Date.now() > r.expiresAt ? (window.localStorage.removeItem(appStateKey(t, e)), null) : r.value ?? null;
  } catch {
    return null;
  }
}, writeAppState = (t, e, d, r) => {
  if (e)
    try {
      if (d == null) {
        window.localStorage.removeItem(appStateKey(t, e));
        return;
      }
      const o = r && r > 0 ? Date.now() + r * 1e3 : void 0;
      window.localStorage.setItem(appStateKey(t, e), JSON.stringify({ value: d, expiresAt: o }));
    } catch {
      return;
    }
}, neutralizeStyleTag = (t) => t.replace(/<\s*\/\s*style/gi, "<\\/style"), assemble = (t, e) => {
  const d = e && e.trim() ? e : typeof t == "string" ? "" : t.css || "";
  if (typeof t == "string") {
    if (e && e.trim()) {
      const l = t.replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, ""), h = `<style data-source="block-override">${neutralizeStyleTag(e)}</style>`;
      return /<head\b[^>]*>/i.test(l) ? l.replace(/<head\b[^>]*>/i, (f) => f + h) : h + l;
    }
    return t;
  }
  const r = d ? `<style data-source="${e ? "block-override" : "vendor"}">${neutralizeStyleTag(d)}</style>` : "", o = t.js ? `<script>${t.js}<\/script>` : "";
  return `<!DOCTYPE html><html><head><meta charset="utf-8">${r}</head><body>${t.html || ""}${o}</body></html>`;
}, initOne = async (t, e, d) => {
  if (t.querySelector("iframe.xl-vendor-block"))
    return;
  if (t.innerHTML = "", !e.appSlug) {
    t.innerHTML = `<div style="padding:30px;text-align:center;color:#999;border:1px dashed #ddd;border-radius:8px">${d.notConfigured}</div>`;
    return;
  }
  if (!e.schoolLinkId) {
    t.innerHTML = `<div style="padding:30px;text-align:center;color:#999;border:1px dashed #ddd;border-radius:8px">${d.noInstance}</div>`;
    return;
  }
  const r = `/api/v1/public/marketplace/site-block?schoolLinkId=${encodeURIComponent(e.schoolLinkId)}&surfaceKind=${encodeURIComponent(e.surfaceKind)}&appSlug=${encodeURIComponent(e.appSlug || "")}`;
  try {
    const o = await (await fetch(r, { credentials: "include" })).json(), l = o == null ? void 0 : o.body;
    if (!l || !l.surface) {
      t.innerHTML += `<div style="padding:20px;text-align:center;color:#dc2626">${d.unavailable}: ${e.appSlug}</div>`;
      return;
    }
    const h = assemble(l.surface, e.cssOverride), f = document.createElement("iframe");
    f.className = "xl-vendor-block", f.setAttribute("sandbox", "allow-scripts allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox"), f.setAttribute("allow", "fullscreen"), f.setAttribute("allowfullscreen", "true"), f.setAttribute("scrolling", "no"), f.style.cssText = `width:100%;height:${e.minHeight || 200}px;min-height:${e.minHeight || 0}px;border:0;display:block;border-radius:8px;overflow:hidden`, f.srcdoc = RUNTIME_SDK + h, t.appendChild(f);
    const y = `/api/v1/public/application-vendor/${encodeURIComponent(l.installId || "")}`, R = `/api/v1/application-vendor-learner/${encodeURIComponent(l.installId || "")}`, S = async (Y, P, F, Z) => {
      var g;
      try {
        const v = await (await fetch(Y, { credentials: "include", ...P })).json(), $ = (g = v == null ? void 0 : v.errors) == null ? void 0 : g[0];
        if ($)
          f.contentWindow.postMessage({ kind: "xl.rpc.error", rpcId: F, code: ($.type || "UNKNOWN").toUpperCase(), message: $.message || "" }, "*");
        else {
          const s = v == null ? void 0 : v.body;
          Z && s && typeof s == "object" && Z(s), f.contentWindow.postMessage({ kind: "xl.rpc.ok", rpcId: F, result: s ?? null }, "*");
        }
      } catch (v) {
        f.contentWindow.postMessage({ kind: "xl.rpc.error", rpcId: F, code: "FETCH", message: v.message }, "*");
      }
    }, N = (Y, P, F, Z) => S(Y, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(P) }, F, Z), C = () => {
      const Y = getVisitor();
      return {
        user: Y.isAuthorized ? { id: Y.contactId, name: d.guest, email: null, role: "student" } : { id: "guest", name: d.guest, email: null, role: "guest" },
        school: { id: l.schoolId || "", name: "", locale: l.locale || "ru", currency: l.currency || "RUB", timezone: l.timezone ?? null },
        app: { slug: l.slug || e.appSlug, installId: l.installId || "", title: l.appTitle || "", settings: l.settings || {}, permissions: l.permissions || [] },
        surface: { kind: e.surfaceKind, config: e.config }
      };
    }, z = () => f.contentWindow.postMessage({ kind: "xl.ready", protocolVersion: 1, context: C() }, "*"), W = (Y) => {
      const P = typeof Y.studentId == "string" ? Y.studentId : "";
      !P || getVisitor().contactId === P || (rememberVisitor(P), z());
    };
    window.addEventListener("message", (Y) => {
      if (Y.source !== f.contentWindow)
        return;
      const P = Y.data;
      if (P)
        if (P.kind === "xl.init")
          z();
        else if (P.kind === "xl.ui.resize") {
          const F = Math.max(120, Math.min(Number(P.height) || 0, 6e3));
          F && (f.style.height = Math.max(F, e.minHeight || 0) + "px");
        } else
          (P.kind === "xl.storage.query" || P.kind === "xl.public.query") && P.rpcId ? S(`${y}/collection/${encodeURIComponent(P.collection || "")}?${collectionQuery(P)}`, {}, P.rpcId) : (P.kind === "xl.storage.get" || P.kind === "xl.public.get") && P.rpcId ? S(`${y}/collection/${encodeURIComponent(P.collection || "")}/${encodeURIComponent(P.docId || "")}`, {}, P.rpcId) : P.kind === "xl.public.create" && P.rpcId ? N(`${y}/collection/${encodeURIComponent(P.collection || "")}`, { data: P.data || {} }, P.rpcId) : P.kind === "xl.public.scenarios.emit" && P.rpcId ? N(`${y}/scenario/emit`, { eventKind: P.eventKind, studentId: P.studentId, data: P.data || {} }, P.rpcId) : P.kind === "xl.learner.courses" && P.rpcId ? S(`${R}/course`, {}, P.rpcId) : P.kind === "xl.learner.lessons" && P.rpcId ? S(`${R}/lesson?courseId=${encodeURIComponent(P.courseId || "")}`, {}, P.rpcId) : P.kind === "xl.state.get" && P.rpcId ? f.contentWindow.postMessage({ kind: "xl.rpc.ok", rpcId: P.rpcId, result: readAppState(e.schoolLinkId, P.key || "") }, "*") : P.kind === "xl.state.set" && P.rpcId ? (writeAppState(e.schoolLinkId, P.key || "", P.value, P.ttlSec), f.contentWindow.postMessage({ kind: "xl.rpc.ok", rpcId: P.rpcId, result: { ok: !0 } }, "*")) : P.kind === "xl.public.crm.me" && P.rpcId ? S(`${y}/crm/me`, {}, P.rpcId) : P.kind === "xl.public.crm.findOrCreate" && P.rpcId ? N(`${y}/crm/contact`, { email: P.email, phone: P.phone, firstName: P.firstName, lastName: P.lastName, readOnly: P.readOnly }, P.rpcId, W) : P.kind === "xl.public.crm.attachRecord" && P.rpcId && N(`${y}/crm/attached-record`, { studentId: P.studentId, kind: P.recordKind, refDocId: P.refDocId, snapshot: P.snapshot }, P.rpcId);
    });
  } catch (o) {
    t.innerHTML += `<div style="padding:20px;text-align:center;color:#dc2626">${d.loadError}: ${o.message || o}</div>`;
  }
}, initVendorAppBlocks = (t) => {
  const d = (document.querySelector(t) || document.body).querySelectorAll("[data-ez-vendorapp]"), r = getWords();
  d.forEach((o) => initOne(o, parseProps(o), r));
};
function initEZTimers(t) {
  for (var e = document.querySelectorAll(`${t} .ez-timer`), d = 0; d < e.length; d++)
    EZTimerInit(e[d]);
}
function EZTimerInit(t) {
  if (!t.timer) {
    t.targetLengthCache = t.getAttribute(
      "lengthSec"
      /* targetLengthSec */
    );
    var e = setInterval(() => {
      if (!t.parentElement) {
        clearInterval(e);
        return;
      }
      EZTimerPlay(t);
    }, 1e3);
    t.timer = e;
  }
}
function EZTimerPlay(t) {
  var e = t.getAttribute(
    "mode"
    /* mode */
  ), d = 0;
  switch (e) {
    case "length":
      var r = t.targetLengthCache != t.getAttribute(
        "lengthSec"
        /* targetLengthSec */
      );
      if (d = t.secondsLeft, !d || r) {
        var o = parseInt(t.getAttribute(
          "lengthSec"
          /* targetLengthSec */
        ) || "0");
        t.targetLengthCache = o.toString(), t.secondsLeft = o, d = t.secondsLeft;
      }
      break;
    case "date":
      try {
        var l = t.getAttribute(
          "dateTime"
          /* targetDateTime */
        ), h = new Date(l);
        d = Math.floor((h.getTime() - Date.now()) / 1e3), d < 0 && (d = 0);
      } catch {
        d = 0;
      }
  }
  var f = Math.floor(d / 86400), y = Math.floor(d % 86400 / 3600), R = Math.floor(d % 3600 / 60), S = d % 60, N = t.querySelector(".dd");
  if (N) {
    var C = N.querySelector(".n");
    C && (C.innerHTML = f < 10 ? "0" + f : "" + f);
  }
  var z = t.querySelector(".hh");
  if (z) {
    var C = z.querySelector(".n");
    C && (C.innerHTML = y < 10 ? "0" + y : "" + y);
  }
  var W = t.querySelector(".mm");
  if (W) {
    var C = W.querySelector(".n");
    C && (C.innerHTML = R < 10 ? "0" + R : "" + R);
  }
  var Y = t.querySelector(".ss");
  if (Y) {
    var C = Y.querySelector(".n");
    C && (C.innerHTML = S < 10 ? "0" + S : "" + S);
  }
  t.secondsLeft && (t.secondsLeft -= 1);
}
const EVENT_PREFIX = "video", START_EVENT = "start", PERCENT_MILESTONES = [25, 50, 75, 100], sentEvents = [], initedCounterIds = [];
let analyticsStarted = !1;
const initVideoAnalytics = () => {
  analyticsStarted || (analyticsStarted = !0, onPlayerMessage((t) => {
    var o, l;
    const e = t.videoId;
    if (!e || !hasAnyTarget(t.analytics))
      return;
    const d = { ...t, videoId: e };
    if (t.event == "onStart") {
      sendEvent(START_EVENT, d);
      return;
    }
    if (t.event != "onProgress" || ((o = t.value) == null ? void 0 : o.playing) != !0)
      return;
    const r = (l = t.value) == null ? void 0 : l.watchedPercent;
    typeof r == "number" && PERCENT_MILESTONES.filter((h) => r >= h).forEach((h) => sendEvent(h.toString(), d));
  }));
}, sendEvent = (t, e) => {
  var h, f, y, R;
  const d = e.videoId, r = `${d}:${t}`;
  if (sentEvents.indexOf(r) > -1)
    return;
  sentEvents.push(r);
  const o = `${((h = e.analytics) == null ? void 0 : h.eventPrefix) || EVENT_PREFIX}_${t}`, l = e.videoTitle || d;
  (f = e.analytics) != null && f.metrika && sendToMetrika(o, d, l, e.metrikaCounterId), (y = e.analytics) != null && y.googleAnalytics && sendToGoogleAnalytics(o, d, l, e.analytics.googleAnalyticsMeasurementId), (R = e.analytics) != null && R.meta && sendToMeta(o, d, l, e.analytics.metaPixelId);
}, hasAnyTarget = (t) => (t == null ? void 0 : t.metrika) == !0 || (t == null ? void 0 : t.googleAnalytics) == !0 || (t == null ? void 0 : t.meta) == !0, sendToMetrika = (t, e, d, r) => {
  const o = getVideoCounterIds(r) ?? getCounterIds(), l = {
    videoId: e,
    video: { [d]: t }
  };
  o.forEach((h) => {
    try {
      ym(h, "reachGoal", t, l);
    } catch {
    }
  });
}, sendToGoogleAnalytics = (t, e, d, r) => {
  if (typeof gtag != "function")
    return;
  const o = {
    video_id: e,
    video_title: d
  };
  r && (o.send_to = r);
  try {
    gtag("event", t, o);
  } catch {
  }
}, sendToMeta = (t, e, d, r) => {
  if (typeof fbq != "function")
    return;
  const o = {
    video_id: e,
    video_title: d
  };
  try {
    r ? fbq("trackSingleCustom", r, t, o) : fbq("trackCustom", t, o);
  } catch {
  }
}, getVideoCounterIds = (t) => {
  if (!t || typeof ym != "function")
    return null;
  const e = parseInt(t, 10);
  if (isNaN(e))
    return null;
  if (initedCounterIds.indexOf(e) == -1 && getCounterIds().indexOf(e) == -1) {
    initedCounterIds.push(e);
    try {
      ym(e, "init", { defer: !0 });
    } catch {
    }
  }
  return [e];
}, getCounterIds = () => {
  if (typeof ym != "function")
    return [];
  try {
    const t = typeof AXLMetrikaCounterIds < "u" ? AXLMetrikaCounterIds : null;
    if (Array.isArray(t) && t.length > 0)
      return t;
    const e = typeof Ya < "u" ? Ya == null ? void 0 : Ya._metrika : null, d = typeof (e == null ? void 0 : e.getCounters) == "function" ? e.getCounters() : e == null ? void 0 : e.counters;
    return Array.isArray(d) ? d.map((r) => r == null ? void 0 : r.id).filter((r) => r != null) : [];
  } catch {
    return [];
  }
}, PSEUDO_CLICK_ATTR = "ezclick", ACTION_ATTR = "ezactions", CONDITION_ATTR = "ez-show-hide", WRAPPER_CLASS = "ez-wrapper";
let axl_base_uri = "", axl_clickActions = {}, axl_fileDownloadUrl = () => `${axl_base_uri}/file/download`, axl_userIsInFilter = async (t, e) => !1, axl_contactId = () => "", axl_contactQueryStringParam, axl_guestId = () => "", axl_guestQueryStringParam;
const ezInitMain = (t) => {
  (t.holderSelector == "" || !t.holderSelector) && (t.holderSelector = "body"), t.baseUrl && (axl_base_uri = t.baseUrl), t.clickActions && (axl_clickActions = t.clickActions), t.userIsInFilter && (axl_userIsInFilter = t.userIsInFilter), typeof t.contactId == "function" && (axl_contactId = t.contactId), axl_contactQueryStringParam = t.contactQueryStringParam, typeof t.questId == "function" && (axl_guestId = t.questId), axl_guestQueryStringParam = t.guestQueryStringParam, makeIframesLazy(), initHtmlEmbeds(t.holderSelector), initPseudoClicks(t.holderSelector), initClicks(t.holderSelector), initConditions(t.holderSelector), initMenuToggle(t.holderSelector), initAudios(t.holderSelector), initPopupTimers(t.holderSelector), initQuiz(t.holderSelector), initSlider(t.holderSelector), initAccordion(t.holderSelector), initEZTimers(t.holderSelector), initVendorAppBlocks(t.holderSelector), initVideoTracking(), initVideoAnalytics(), initVideoMiniPlayer(), initTimecodeLinks(t.holderSelector, t.videoWords), document.querySelectorAll(`.${WRAPPER_CLASS}`).forEach((r) => {
    r.classList.add("live");
  });
  var d = window.AXLWebsite;
  d && (d.showPopup = (r) => showPopup(r), d.hidePopup = () => hidePopup(), d.zoomImage = (r, o) => {
    var l = o || document.getElementsByClassName("ez-wrapper")[0];
    l && r && r.length > 0 && zoomImage(r, l);
  });
};
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
  function r(l) {
    if (l == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(l);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var l = new String("abc");
      if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
        return !1;
      for (var h = {}, f = 0; f < 10; f++)
        h["_" + String.fromCharCode(f)] = f;
      var y = Object.getOwnPropertyNames(h).map(function(S) {
        return h[S];
      });
      if (y.join("") !== "0123456789")
        return !1;
      var R = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(S) {
        R[S] = S;
      }), Object.keys(Object.assign({}, R)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = o() ? Object.assign : function(l, h) {
    for (var f, y = r(l), R, S = 1; S < arguments.length; S++) {
      f = Object(arguments[S]);
      for (var N in f)
        e.call(f, N) && (y[N] = f[N]);
      if (t) {
        R = t(f);
        for (var C = 0; C < R.length; C++)
          d.call(f, R[C]) && (y[R[C]] = f[R[C]]);
      }
    }
    return y;
  }, objectAssign;
}
var react = { exports: {} }, react_production_min = {};
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReact_production_min;
function requireReact_production_min() {
  if (hasRequiredReact_production_min)
    return react_production_min;
  hasRequiredReact_production_min = 1;
  var t = requireObjectAssign(), e = 60103, d = 60106;
  react_production_min.Fragment = 60107, react_production_min.StrictMode = 60108, react_production_min.Profiler = 60114;
  var r = 60109, o = 60110, l = 60112;
  react_production_min.Suspense = 60113;
  var h = 60115, f = 60116;
  if (typeof Symbol == "function" && Symbol.for) {
    var y = Symbol.for;
    e = y("react.element"), d = y("react.portal"), react_production_min.Fragment = y("react.fragment"), react_production_min.StrictMode = y("react.strict_mode"), react_production_min.Profiler = y("react.profiler"), r = y("react.provider"), o = y("react.context"), l = y("react.forward_ref"), react_production_min.Suspense = y("react.suspense"), h = y("react.memo"), f = y("react.lazy");
  }
  var R = typeof Symbol == "function" && Symbol.iterator;
  function S(b) {
    return b === null || typeof b != "object" ? null : (b = R && b[R] || b["@@iterator"], typeof b == "function" ? b : null);
  }
  function N(b) {
    for (var U = "https://reactjs.org/docs/error-decoder.html?invariant=" + b, K = 1; K < arguments.length; K++)
      U += "&args[]=" + encodeURIComponent(arguments[K]);
    return "Minified React error #" + b + "; visit " + U + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var C = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, z = {};
  function W(b, U, K) {
    this.props = b, this.context = U, this.refs = z, this.updater = K || C;
  }
  W.prototype.isReactComponent = {}, W.prototype.setState = function(b, U) {
    if (typeof b != "object" && typeof b != "function" && b != null)
      throw Error(N(85));
    this.updater.enqueueSetState(this, b, U, "setState");
  }, W.prototype.forceUpdate = function(b) {
    this.updater.enqueueForceUpdate(this, b, "forceUpdate");
  };
  function Y() {
  }
  Y.prototype = W.prototype;
  function P(b, U, K) {
    this.props = b, this.context = U, this.refs = z, this.updater = K || C;
  }
  var F = P.prototype = new Y();
  F.constructor = P, t(F, W.prototype), F.isPureReactComponent = !0;
  var Z = { current: null }, g = Object.prototype.hasOwnProperty, v = { key: !0, ref: !0, __self: !0, __source: !0 };
  function $(b, U, K) {
    var re, oe = {}, ie = null, le = null;
    if (U != null)
      for (re in U.ref !== void 0 && (le = U.ref), U.key !== void 0 && (ie = "" + U.key), U)
        g.call(U, re) && !v.hasOwnProperty(re) && (oe[re] = U[re]);
    var de = arguments.length - 2;
    if (de === 1)
      oe.children = K;
    else if (1 < de) {
      for (var ce = Array(de), ye = 0; ye < de; ye++)
        ce[ye] = arguments[ye + 2];
      oe.children = ce;
    }
    if (b && b.defaultProps)
      for (re in de = b.defaultProps, de)
        oe[re] === void 0 && (oe[re] = de[re]);
    return { $$typeof: e, type: b, key: ie, ref: le, props: oe, _owner: Z.current };
  }
  function s(b, U) {
    return { $$typeof: e, type: b.type, key: U, ref: b.ref, props: b.props, _owner: b._owner };
  }
  function u(b) {
    return typeof b == "object" && b !== null && b.$$typeof === e;
  }
  function m(b) {
    var U = { "=": "=0", ":": "=2" };
    return "$" + b.replace(/[=:]/g, function(K) {
      return U[K];
    });
  }
  var E = /\/+/g;
  function w(b, U) {
    return typeof b == "object" && b !== null && b.key != null ? m("" + b.key) : U.toString(36);
  }
  function T(b, U, K, re, oe) {
    var ie = typeof b;
    (ie === "undefined" || ie === "boolean") && (b = null);
    var le = !1;
    if (b === null)
      le = !0;
    else
      switch (ie) {
        case "string":
        case "number":
          le = !0;
          break;
        case "object":
          switch (b.$$typeof) {
            case e:
            case d:
              le = !0;
          }
      }
    if (le)
      return le = b, oe = oe(le), b = re === "" ? "." + w(le, 0) : re, Array.isArray(oe) ? (K = "", b != null && (K = b.replace(E, "$&/") + "/"), T(oe, U, K, "", function(ye) {
        return ye;
      })) : oe != null && (u(oe) && (oe = s(oe, K + (!oe.key || le && le.key === oe.key ? "" : ("" + oe.key).replace(E, "$&/") + "/") + b)), U.push(oe)), 1;
    if (le = 0, re = re === "" ? "." : re + ":", Array.isArray(b))
      for (var de = 0; de < b.length; de++) {
        ie = b[de];
        var ce = re + w(ie, de);
        le += T(ie, U, K, ce, oe);
      }
    else if (ce = S(b), typeof ce == "function")
      for (b = ce.call(b), de = 0; !(ie = b.next()).done; )
        ie = ie.value, ce = re + w(ie, de++), le += T(ie, U, K, ce, oe);
    else if (ie === "object")
      throw U = "" + b, Error(N(31, U === "[object Object]" ? "object with keys {" + Object.keys(b).join(", ") + "}" : U));
    return le;
  }
  function H(b, U, K) {
    if (b == null)
      return b;
    var re = [], oe = 0;
    return T(b, re, "", "", function(ie) {
      return U.call(K, ie, oe++);
    }), re;
  }
  function V(b) {
    if (b._status === -1) {
      var U = b._result;
      U = U(), b._status = 0, b._result = U, U.then(function(K) {
        b._status === 0 && (K = K.default, b._status = 1, b._result = K);
      }, function(K) {
        b._status === 0 && (b._status = 2, b._result = K);
      });
    }
    if (b._status === 1)
      return b._result;
    throw b._result;
  }
  var X = { current: null };
  function G() {
    var b = X.current;
    if (b === null)
      throw Error(N(321));
    return b;
  }
  var ue = { ReactCurrentDispatcher: X, ReactCurrentBatchConfig: { transition: 0 }, ReactCurrentOwner: Z, IsSomeRendererActing: { current: !1 }, assign: t };
  return react_production_min.Children = { map: H, forEach: function(b, U, K) {
    H(b, function() {
      U.apply(this, arguments);
    }, K);
  }, count: function(b) {
    var U = 0;
    return H(b, function() {
      U++;
    }), U;
  }, toArray: function(b) {
    return H(b, function(U) {
      return U;
    }) || [];
  }, only: function(b) {
    if (!u(b))
      throw Error(N(143));
    return b;
  } }, react_production_min.Component = W, react_production_min.PureComponent = P, react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ue, react_production_min.cloneElement = function(b, U, K) {
    if (b == null)
      throw Error(N(267, b));
    var re = t({}, b.props), oe = b.key, ie = b.ref, le = b._owner;
    if (U != null) {
      if (U.ref !== void 0 && (ie = U.ref, le = Z.current), U.key !== void 0 && (oe = "" + U.key), b.type && b.type.defaultProps)
        var de = b.type.defaultProps;
      for (ce in U)
        g.call(U, ce) && !v.hasOwnProperty(ce) && (re[ce] = U[ce] === void 0 && de !== void 0 ? de[ce] : U[ce]);
    }
    var ce = arguments.length - 2;
    if (ce === 1)
      re.children = K;
    else if (1 < ce) {
      de = Array(ce);
      for (var ye = 0; ye < ce; ye++)
        de[ye] = arguments[ye + 2];
      re.children = de;
    }
    return {
      $$typeof: e,
      type: b.type,
      key: oe,
      ref: ie,
      props: re,
      _owner: le
    };
  }, react_production_min.createContext = function(b, U) {
    return U === void 0 && (U = null), b = { $$typeof: o, _calculateChangedBits: U, _currentValue: b, _currentValue2: b, _threadCount: 0, Provider: null, Consumer: null }, b.Provider = { $$typeof: r, _context: b }, b.Consumer = b;
  }, react_production_min.createElement = $, react_production_min.createFactory = function(b) {
    var U = $.bind(null, b);
    return U.type = b, U;
  }, react_production_min.createRef = function() {
    return { current: null };
  }, react_production_min.forwardRef = function(b) {
    return { $$typeof: l, render: b };
  }, react_production_min.isValidElement = u, react_production_min.lazy = function(b) {
    return { $$typeof: f, _payload: { _status: -1, _result: b }, _init: V };
  }, react_production_min.memo = function(b, U) {
    return { $$typeof: h, type: b, compare: U === void 0 ? null : U };
  }, react_production_min.useCallback = function(b, U) {
    return G().useCallback(b, U);
  }, react_production_min.useContext = function(b, U) {
    return G().useContext(b, U);
  }, react_production_min.useDebugValue = function() {
  }, react_production_min.useEffect = function(b, U) {
    return G().useEffect(b, U);
  }, react_production_min.useImperativeHandle = function(b, U, K) {
    return G().useImperativeHandle(b, U, K);
  }, react_production_min.useLayoutEffect = function(b, U) {
    return G().useLayoutEffect(b, U);
  }, react_production_min.useMemo = function(b, U) {
    return G().useMemo(b, U);
  }, react_production_min.useReducer = function(b, U, K) {
    return G().useReducer(b, U, K);
  }, react_production_min.useRef = function(b) {
    return G().useRef(b);
  }, react_production_min.useState = function(b) {
    return G().useState(b);
  }, react_production_min.version = "17.0.2", react_production_min;
}
var react_development = {};
/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReact_development;
function requireReact_development() {
  return hasRequiredReact_development || (hasRequiredReact_development = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      var e = requireObjectAssign(), d = "17.0.2", r = 60103, o = 60106;
      t.Fragment = 60107, t.StrictMode = 60108, t.Profiler = 60114;
      var l = 60109, h = 60110, f = 60112;
      t.Suspense = 60113;
      var y = 60120, R = 60115, S = 60116, N = 60121, C = 60122, z = 60117, W = 60129, Y = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var P = Symbol.for;
        r = P("react.element"), o = P("react.portal"), t.Fragment = P("react.fragment"), t.StrictMode = P("react.strict_mode"), t.Profiler = P("react.profiler"), l = P("react.provider"), h = P("react.context"), f = P("react.forward_ref"), t.Suspense = P("react.suspense"), y = P("react.suspense_list"), R = P("react.memo"), S = P("react.lazy"), N = P("react.block"), C = P("react.server.block"), z = P("react.fundamental"), P("react.scope"), P("react.opaque.id"), W = P("react.debug_trace_mode"), P("react.offscreen"), Y = P("react.legacy_hidden");
      }
      var F = typeof Symbol == "function" && Symbol.iterator, Z = "@@iterator";
      function g(n) {
        if (n === null || typeof n != "object")
          return null;
        var _ = F && n[F] || n[Z];
        return typeof _ == "function" ? _ : null;
      }
      var v = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, $ = {
        transition: 0
      }, s = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, u = {}, m = null;
      function E(n) {
        m = n;
      }
      u.setExtraStackFrame = function(n) {
        m = n;
      }, u.getCurrentStack = null, u.getStackAddendum = function() {
        var n = "";
        m && (n += m);
        var _ = u.getCurrentStack;
        return _ && (n += _() || ""), n;
      };
      var w = {
        current: !1
      }, T = {
        ReactCurrentDispatcher: v,
        ReactCurrentBatchConfig: $,
        ReactCurrentOwner: s,
        IsSomeRendererActing: w,
        // Used by renderers to avoid bundling object-assign twice in UMD bundles:
        assign: e
      };
      T.ReactDebugCurrentFrame = u;
      function H(n) {
        {
          for (var _ = arguments.length, A = new Array(_ > 1 ? _ - 1 : 0), L = 1; L < _; L++)
            A[L - 1] = arguments[L];
          X("warn", n, A);
        }
      }
      function V(n) {
        {
          for (var _ = arguments.length, A = new Array(_ > 1 ? _ - 1 : 0), L = 1; L < _; L++)
            A[L - 1] = arguments[L];
          X("error", n, A);
        }
      }
      function X(n, _, A) {
        {
          var L = T.ReactDebugCurrentFrame, q = L.getStackAddendum();
          q !== "" && (_ += "%s", A = A.concat([q]));
          var te = A.map(function(ee) {
            return "" + ee;
          });
          te.unshift("Warning: " + _), Function.prototype.apply.call(console[n], console, te);
        }
      }
      var G = {};
      function ue(n, _) {
        {
          var A = n.constructor, L = A && (A.displayName || A.name) || "ReactClass", q = L + "." + _;
          if (G[q])
            return;
          V("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", _, L), G[q] = !0;
        }
      }
      var b = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(n) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(n, _, A) {
          ue(n, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(n, _, A, L) {
          ue(n, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(n, _, A, L) {
          ue(n, "setState");
        }
      }, U = {};
      Object.freeze(U);
      function K(n, _, A) {
        this.props = n, this.context = _, this.refs = U, this.updater = A || b;
      }
      K.prototype.isReactComponent = {}, K.prototype.setState = function(n, _) {
        if (!(typeof n == "object" || typeof n == "function" || n == null))
          throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, n, _, "setState");
      }, K.prototype.forceUpdate = function(n) {
        this.updater.enqueueForceUpdate(this, n, "forceUpdate");
      };
      {
        var re = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, oe = function(n, _) {
          Object.defineProperty(K.prototype, n, {
            get: function() {
              H("%s(...) is deprecated in plain JavaScript React classes. %s", _[0], _[1]);
            }
          });
        };
        for (var ie in re)
          re.hasOwnProperty(ie) && oe(ie, re[ie]);
      }
      function le() {
      }
      le.prototype = K.prototype;
      function de(n, _, A) {
        this.props = n, this.context = _, this.refs = U, this.updater = A || b;
      }
      var ce = de.prototype = new le();
      ce.constructor = de, e(ce, K.prototype), ce.isPureReactComponent = !0;
      function ye() {
        var n = {
          current: null
        };
        return Object.seal(n), n;
      }
      function De(n, _, A) {
        var L = _.displayName || _.name || "";
        return n.displayName || (L !== "" ? A + "(" + L + ")" : A);
      }
      function ze(n) {
        return n.displayName || "Context";
      }
      function be(n) {
        if (n == null)
          return null;
        if (typeof n.tag == "number" && V("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof n == "function")
          return n.displayName || n.name || null;
        if (typeof n == "string")
          return n;
        switch (n) {
          case t.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case t.Profiler:
            return "Profiler";
          case t.StrictMode:
            return "StrictMode";
          case t.Suspense:
            return "Suspense";
          case y:
            return "SuspenseList";
        }
        if (typeof n == "object")
          switch (n.$$typeof) {
            case h:
              var _ = n;
              return ze(_) + ".Consumer";
            case l:
              var A = n;
              return ze(A._context) + ".Provider";
            case f:
              return De(n, n.render, "ForwardRef");
            case R:
              return be(n.type);
            case N:
              return be(n._render);
            case S: {
              var L = n, q = L._payload, te = L._init;
              try {
                return be(te(q));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Ne = Object.prototype.hasOwnProperty, rt = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ke, Ze, Xe;
      Xe = {};
      function Ee(n) {
        if (Ne.call(n, "ref")) {
          var _ = Object.getOwnPropertyDescriptor(n, "ref").get;
          if (_ && _.isReactWarning)
            return !1;
        }
        return n.ref !== void 0;
      }
      function qe(n) {
        if (Ne.call(n, "key")) {
          var _ = Object.getOwnPropertyDescriptor(n, "key").get;
          if (_ && _.isReactWarning)
            return !1;
        }
        return n.key !== void 0;
      }
      function Je(n, _) {
        var A = function() {
          Ke || (Ke = !0, V("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        A.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: A,
          configurable: !0
        });
      }
      function Ge(n, _) {
        var A = function() {
          Ze || (Ze = !0, V("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        A.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: A,
          configurable: !0
        });
      }
      function lt(n) {
        if (typeof n.ref == "string" && s.current && n.__self && s.current.stateNode !== n.__self) {
          var _ = be(s.current.type);
          Xe[_] || (V('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _, n.ref), Xe[_] = !0);
        }
      }
      var Te = function(n, _, A, L, q, te, ee) {
        var Q = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: n,
          key: _,
          ref: A,
          props: ee,
          // Record the component responsible for creating this element.
          _owner: te
        };
        return Q._store = {}, Object.defineProperty(Q._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Q, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: L
        }), Object.defineProperty(Q, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: q
        }), Object.freeze && (Object.freeze(Q.props), Object.freeze(Q)), Q;
      };
      function Ye(n, _, A) {
        var L, q = {}, te = null, ee = null, Q = null, pe = null;
        if (_ != null) {
          Ee(_) && (ee = _.ref, lt(_)), qe(_) && (te = "" + _.key), Q = _.__self === void 0 ? null : _.__self, pe = _.__source === void 0 ? null : _.__source;
          for (L in _)
            Ne.call(_, L) && !rt.hasOwnProperty(L) && (q[L] = _[L]);
        }
        var he = arguments.length - 2;
        if (he === 1)
          q.children = A;
        else if (he > 1) {
          for (var ve = Array(he), _e = 0; _e < he; _e++)
            ve[_e] = arguments[_e + 2];
          Object.freeze && Object.freeze(ve), q.children = ve;
        }
        if (n && n.defaultProps) {
          var Re = n.defaultProps;
          for (L in Re)
            q[L] === void 0 && (q[L] = Re[L]);
        }
        if (te || ee) {
          var Ie = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          te && Je(q, Ie), ee && Ge(q, Ie);
        }
        return Te(n, te, ee, Q, pe, s.current, q);
      }
      function nt(n, _) {
        var A = Te(n.type, _, n.ref, n._self, n._source, n._owner, n.props);
        return A;
      }
      function Qe(n, _, A) {
        if (n == null)
          throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + n + ".");
        var L, q = e({}, n.props), te = n.key, ee = n.ref, Q = n._self, pe = n._source, he = n._owner;
        if (_ != null) {
          Ee(_) && (ee = _.ref, he = s.current), qe(_) && (te = "" + _.key);
          var ve;
          n.type && n.type.defaultProps && (ve = n.type.defaultProps);
          for (L in _)
            Ne.call(_, L) && !rt.hasOwnProperty(L) && (_[L] === void 0 && ve !== void 0 ? q[L] = ve[L] : q[L] = _[L]);
        }
        var _e = arguments.length - 2;
        if (_e === 1)
          q.children = A;
        else if (_e > 1) {
          for (var Re = Array(_e), Ie = 0; Ie < _e; Ie++)
            Re[Ie] = arguments[Ie + 2];
          q.children = Re;
        }
        return Te(n.type, te, ee, Q, pe, he, q);
      }
      function Se(n) {
        return typeof n == "object" && n !== null && n.$$typeof === r;
      }
      var Me = ".", it = ":";
      function Be(n) {
        var _ = /[=:]/g, A = {
          "=": "=0",
          ":": "=2"
        }, L = n.replace(_, function(q) {
          return A[q];
        });
        return "$" + L;
      }
      var Ue = !1, ot = /\/+/g;
      function je(n) {
        return n.replace(ot, "$&/");
      }
      function He(n, _) {
        return typeof n == "object" && n !== null && n.key != null ? Be("" + n.key) : _.toString(36);
      }
      function Ae(n, _, A, L, q) {
        var te = typeof n;
        (te === "undefined" || te === "boolean") && (n = null);
        var ee = !1;
        if (n === null)
          ee = !0;
        else
          switch (te) {
            case "string":
            case "number":
              ee = !0;
              break;
            case "object":
              switch (n.$$typeof) {
                case r:
                case o:
                  ee = !0;
              }
          }
        if (ee) {
          var Q = n, pe = q(Q), he = L === "" ? Me + He(Q, 0) : L;
          if (Array.isArray(pe)) {
            var ve = "";
            he != null && (ve = je(he) + "/"), Ae(pe, _, ve, "", function(d1) {
              return d1;
            });
          } else
            pe != null && (Se(pe) && (pe = nt(
              pe,
              // Keep both the (mapped) and old keys if they differ, just as
              // traverseAllChildren used to do for objects as children
              A + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
              (pe.key && (!Q || Q.key !== pe.key) ? (
                // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
                je("" + pe.key) + "/"
              ) : "") + he
            )), _.push(pe));
          return 1;
        }
        var _e, Re, Ie = 0, Oe = L === "" ? Me : L + it;
        if (Array.isArray(n))
          for (var ht = 0; ht < n.length; ht++)
            _e = n[ht], Re = Oe + He(_e, ht), Ie += Ae(_e, _, A, Re, q);
        else {
          var _t = g(n);
          if (typeof _t == "function") {
            var Nt = n;
            _t === Nt.entries && (Ue || H("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Ue = !0);
            for (var e1 = _t.call(Nt), Mt, t1 = 0; !(Mt = e1.next()).done; )
              _e = Mt.value, Re = Oe + He(_e, t1++), Ie += Ae(_e, _, A, Re, q);
          } else if (te === "object") {
            var Ut = "" + n;
            throw Error("Objects are not valid as a React child (found: " + (Ut === "[object Object]" ? "object with keys {" + Object.keys(n).join(", ") + "}" : Ut) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return Ie;
      }
      function ge(n, _, A) {
        if (n == null)
          return n;
        var L = [], q = 0;
        return Ae(n, L, "", "", function(te) {
          return _.call(A, te, q++);
        }), L;
      }
      function et(n) {
        var _ = 0;
        return ge(n, function() {
          _++;
        }), _;
      }
      function xe(n, _, A) {
        ge(n, function() {
          _.apply(this, arguments);
        }, A);
      }
      function Fe(n) {
        return ge(n, function(_) {
          return _;
        }) || [];
      }
      function Ve(n) {
        if (!Se(n))
          throw Error("React.Children.only expected to receive a single React element child.");
        return n;
      }
      function tt(n, _) {
        _ === void 0 ? _ = null : _ !== null && typeof _ != "function" && V("createContext: Expected the optional second argument to be a function. Instead received: %s", _);
        var A = {
          $$typeof: h,
          _calculateChangedBits: _,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: n,
          _currentValue2: n,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null
        };
        A.Provider = {
          $$typeof: l,
          _context: A
        };
        var L = !1, q = !1, te = !1;
        {
          var ee = {
            $$typeof: h,
            _context: A,
            _calculateChangedBits: A._calculateChangedBits
          };
          Object.defineProperties(ee, {
            Provider: {
              get: function() {
                return q || (q = !0, V("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), A.Provider;
              },
              set: function(Q) {
                A.Provider = Q;
              }
            },
            _currentValue: {
              get: function() {
                return A._currentValue;
              },
              set: function(Q) {
                A._currentValue = Q;
              }
            },
            _currentValue2: {
              get: function() {
                return A._currentValue2;
              },
              set: function(Q) {
                A._currentValue2 = Q;
              }
            },
            _threadCount: {
              get: function() {
                return A._threadCount;
              },
              set: function(Q) {
                A._threadCount = Q;
              }
            },
            Consumer: {
              get: function() {
                return L || (L = !0, V("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), A.Consumer;
              }
            },
            displayName: {
              get: function() {
                return A.displayName;
              },
              set: function(Q) {
                te || (H("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", Q), te = !0);
              }
            }
          }), A.Consumer = ee;
        }
        return A._currentRenderer = null, A._currentRenderer2 = null, A;
      }
      var at = -1, Pe = 0, dt = 1, we = 2;
      function a(n) {
        if (n._status === at) {
          var _ = n._result, A = _(), L = n;
          L._status = Pe, L._result = A, A.then(function(q) {
            if (n._status === Pe) {
              var te = q.default;
              te === void 0 && V(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, q);
              var ee = n;
              ee._status = dt, ee._result = te;
            }
          }, function(q) {
            if (n._status === Pe) {
              var te = n;
              te._status = we, te._result = q;
            }
          });
        }
        if (n._status === dt)
          return n._result;
        throw n._result;
      }
      function c(n) {
        var _ = {
          // We use these fields to store the result.
          _status: -1,
          _result: n
        }, A = {
          $$typeof: S,
          _payload: _,
          _init: a
        };
        {
          var L, q;
          Object.defineProperties(A, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return L;
              },
              set: function(te) {
                V("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), L = te, Object.defineProperty(A, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return q;
              },
              set: function(te) {
                V("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), q = te, Object.defineProperty(A, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return A;
      }
      function I(n) {
        n != null && n.$$typeof === R ? V("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof n != "function" ? V("forwardRef requires a render function but was given %s.", n === null ? "null" : typeof n) : n.length !== 0 && n.length !== 2 && V("forwardRef render functions accept exactly two parameters: props and ref. %s", n.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), n != null && (n.defaultProps != null || n.propTypes != null) && V("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var _ = {
          $$typeof: f,
          render: n
        };
        {
          var A;
          Object.defineProperty(_, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return A;
            },
            set: function(L) {
              A = L, n.displayName == null && (n.displayName = L);
            }
          });
        }
        return _;
      }
      var x = !1;
      function D(n) {
        return !!(typeof n == "string" || typeof n == "function" || n === t.Fragment || n === t.Profiler || n === W || n === t.StrictMode || n === t.Suspense || n === y || n === Y || x || typeof n == "object" && n !== null && (n.$$typeof === S || n.$$typeof === R || n.$$typeof === l || n.$$typeof === h || n.$$typeof === f || n.$$typeof === z || n.$$typeof === N || n[0] === C));
      }
      function O(n, _) {
        D(n) || V("memo: The first argument must be a component. Instead received: %s", n === null ? "null" : typeof n);
        var A = {
          $$typeof: R,
          type: n,
          compare: _ === void 0 ? null : _
        };
        {
          var L;
          Object.defineProperty(A, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return L;
            },
            set: function(q) {
              L = q, n.displayName == null && (n.displayName = q);
            }
          });
        }
        return A;
      }
      function k() {
        var n = v.current;
        if (n === null)
          throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
        return n;
      }
      function B(n, _) {
        var A = k();
        if (_ !== void 0 && V("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", _, typeof _ == "number" && Array.isArray(arguments[2]) ? `

Did you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://reactjs.org/link/rules-of-hooks` : ""), n._context !== void 0) {
          var L = n._context;
          L.Consumer === n ? V("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : L.Provider === n && V("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return A.useContext(n, _);
      }
      function p(n) {
        var _ = k();
        return _.useState(n);
      }
      function M(n, _, A) {
        var L = k();
        return L.useReducer(n, _, A);
      }
      function j(n) {
        var _ = k();
        return _.useRef(n);
      }
      function J(n, _) {
        var A = k();
        return A.useEffect(n, _);
      }
      function se(n, _) {
        var A = k();
        return A.useLayoutEffect(n, _);
      }
      function fe(n, _) {
        var A = k();
        return A.useCallback(n, _);
      }
      function ae(n, _) {
        var A = k();
        return A.useMemo(n, _);
      }
      function ne(n, _, A) {
        var L = k();
        return L.useImperativeHandle(n, _, A);
      }
      function Ce(n, _) {
        {
          var A = k();
          return A.useDebugValue(n, _);
        }
      }
      var $e = 0, me, ke, We, ut, Le, Ct, bt;
      function Et() {
      }
      Et.__reactDisabledLog = !0;
      function Ft() {
        {
          if ($e === 0) {
            me = console.log, ke = console.info, We = console.warn, ut = console.error, Le = console.group, Ct = console.groupCollapsed, bt = console.groupEnd;
            var n = {
              configurable: !0,
              enumerable: !0,
              value: Et,
              writable: !0
            };
            Object.defineProperties(console, {
              info: n,
              log: n,
              warn: n,
              error: n,
              group: n,
              groupCollapsed: n,
              groupEnd: n
            });
          }
          $e++;
        }
      }
      function zt() {
        {
          if ($e--, $e === 0) {
            var n = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: e({}, n, {
                value: me
              }),
              info: e({}, n, {
                value: ke
              }),
              warn: e({}, n, {
                value: We
              }),
              error: e({}, n, {
                value: ut
              }),
              group: e({}, n, {
                value: Le
              }),
              groupCollapsed: e({}, n, {
                value: Ct
              }),
              groupEnd: e({}, n, {
                value: bt
              })
            });
          }
          $e < 0 && V("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var mt = T.ReactCurrentDispatcher, vt;
      function ct(n, _, A) {
        {
          if (vt === void 0)
            try {
              throw Error();
            } catch (q) {
              var L = q.stack.trim().match(/\n( *(at )?)/);
              vt = L && L[1] || "";
            }
          return `
` + vt + n;
        }
      }
      var gt = !1, ft;
      {
        var Bt = typeof WeakMap == "function" ? WeakMap : Map;
        ft = new Bt();
      }
      function wt(n, _) {
        if (!n || gt)
          return "";
        {
          var A = ft.get(n);
          if (A !== void 0)
            return A;
        }
        var L;
        gt = !0;
        var q = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var te;
        te = mt.current, mt.current = null, Ft();
        try {
          if (_) {
            var ee = function() {
              throw Error();
            };
            if (Object.defineProperty(ee.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(ee, []);
              } catch (Oe) {
                L = Oe;
              }
              Reflect.construct(n, [], ee);
            } else {
              try {
                ee.call();
              } catch (Oe) {
                L = Oe;
              }
              n.call(ee.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Oe) {
              L = Oe;
            }
            n();
          }
        } catch (Oe) {
          if (Oe && L && typeof Oe.stack == "string") {
            for (var Q = Oe.stack.split(`
`), pe = L.stack.split(`
`), he = Q.length - 1, ve = pe.length - 1; he >= 1 && ve >= 0 && Q[he] !== pe[ve]; )
              ve--;
            for (; he >= 1 && ve >= 0; he--, ve--)
              if (Q[he] !== pe[ve]) {
                if (he !== 1 || ve !== 1)
                  do
                    if (he--, ve--, ve < 0 || Q[he] !== pe[ve]) {
                      var _e = `
` + Q[he].replace(" at new ", " at ");
                      return typeof n == "function" && ft.set(n, _e), _e;
                    }
                  while (he >= 1 && ve >= 0);
                break;
              }
          }
        } finally {
          gt = !1, mt.current = te, zt(), Error.prepareStackTrace = q;
        }
        var Re = n ? n.displayName || n.name : "", Ie = Re ? ct(Re) : "";
        return typeof n == "function" && ft.set(n, Ie), Ie;
      }
      function It(n, _, A) {
        return wt(n, !1);
      }
      function jt(n) {
        var _ = n.prototype;
        return !!(_ && _.isReactComponent);
      }
      function $t(n, _, A) {
        if (n == null)
          return "";
        if (typeof n == "function")
          return wt(n, jt(n));
        if (typeof n == "string")
          return ct(n);
        switch (n) {
          case t.Suspense:
            return ct("Suspense");
          case y:
            return ct("SuspenseList");
        }
        if (typeof n == "object")
          switch (n.$$typeof) {
            case f:
              return It(n.render);
            case R:
              return $t(n.type, _, A);
            case N:
              return It(n._render);
            case S: {
              var L = n, q = L._payload, te = L._init;
              try {
                return $t(te(q), _, A);
              } catch {
              }
            }
          }
        return "";
      }
      var St = {}, At = T.ReactDebugCurrentFrame;
      function pt(n) {
        if (n) {
          var _ = n._owner, A = $t(n.type, n._source, _ ? _.type : null);
          At.setExtraStackFrame(A);
        } else
          At.setExtraStackFrame(null);
      }
      function Ht(n, _, A, L, q) {
        {
          var te = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var ee in n)
            if (te(n, ee)) {
              var Q = void 0;
              try {
                if (typeof n[ee] != "function") {
                  var pe = Error((L || "React class") + ": " + A + " type `" + ee + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[ee] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw pe.name = "Invariant Violation", pe;
                }
                Q = n[ee](_, ee, L, A, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (he) {
                Q = he;
              }
              Q && !(Q instanceof Error) && (pt(q), V("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", L || "React class", A, ee, typeof Q), pt(null)), Q instanceof Error && !(Q.message in St) && (St[Q.message] = !0, pt(q), V("Failed %s type: %s", A, Q.message), pt(null));
            }
        }
      }
      function st(n) {
        if (n) {
          var _ = n._owner, A = $t(n.type, n._source, _ ? _.type : null);
          E(A);
        } else
          E(null);
      }
      var yt;
      yt = !1;
      function Pt() {
        if (s.current) {
          var n = be(s.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
      function Vt(n) {
        if (n !== void 0) {
          var _ = n.fileName.replace(/^.*[\\\/]/, ""), A = n.lineNumber;
          return `

Check your code at ` + _ + ":" + A + ".";
        }
        return "";
      }
      function Wt(n) {
        return n != null ? Vt(n.__source) : "";
      }
      var Rt = {};
      function qt(n) {
        var _ = Pt();
        if (!_) {
          var A = typeof n == "string" ? n : n.displayName || n.name;
          A && (_ = `

Check the top-level render call using <` + A + ">.");
        }
        return _;
      }
      function Tt(n, _) {
        if (!(!n._store || n._store.validated || n.key != null)) {
          n._store.validated = !0;
          var A = qt(_);
          if (!Rt[A]) {
            Rt[A] = !0;
            var L = "";
            n && n._owner && n._owner !== s.current && (L = " It was passed a child from " + be(n._owner.type) + "."), st(n), V('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', A, L), st(null);
          }
        }
      }
      function xt(n, _) {
        if (typeof n == "object") {
          if (Array.isArray(n))
            for (var A = 0; A < n.length; A++) {
              var L = n[A];
              Se(L) && Tt(L, _);
            }
          else if (Se(n))
            n._store && (n._store.validated = !0);
          else if (n) {
            var q = g(n);
            if (typeof q == "function" && q !== n.entries)
              for (var te = q.call(n), ee; !(ee = te.next()).done; )
                Se(ee.value) && Tt(ee.value, _);
          }
        }
      }
      function kt(n) {
        {
          var _ = n.type;
          if (_ == null || typeof _ == "string")
            return;
          var A;
          if (typeof _ == "function")
            A = _.propTypes;
          else if (typeof _ == "object" && (_.$$typeof === f || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          _.$$typeof === R))
            A = _.propTypes;
          else
            return;
          if (A) {
            var L = be(_);
            Ht(A, n.props, "prop", L, n);
          } else if (_.PropTypes !== void 0 && !yt) {
            yt = !0;
            var q = be(_);
            V("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", q || "Unknown");
          }
          typeof _.getDefaultProps == "function" && !_.getDefaultProps.isReactClassApproved && V("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Gt(n) {
        {
          for (var _ = Object.keys(n.props), A = 0; A < _.length; A++) {
            var L = _[A];
            if (L !== "children" && L !== "key") {
              st(n), V("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", L), st(null);
              break;
            }
          }
          n.ref !== null && (st(n), V("Invalid attribute `ref` supplied to `React.Fragment`."), st(null));
        }
      }
      function Lt(n, _, A) {
        var L = D(n);
        if (!L) {
          var q = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Wt(_);
          te ? q += te : q += Pt();
          var ee;
          n === null ? ee = "null" : Array.isArray(n) ? ee = "array" : n !== void 0 && n.$$typeof === r ? (ee = "<" + (be(n.type) || "Unknown") + " />", q = " Did you accidentally export a JSX literal instead of a component?") : ee = typeof n, V("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ee, q);
        }
        var Q = Ye.apply(this, arguments);
        if (Q == null)
          return Q;
        if (L)
          for (var pe = 2; pe < arguments.length; pe++)
            xt(arguments[pe], n);
        return n === t.Fragment ? Gt(Q) : kt(Q), Q;
      }
      var Ot = !1;
      function Yt(n) {
        var _ = Lt.bind(null, n);
        return _.type = n, Ot || (Ot = !0, H("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(_, "type", {
          enumerable: !1,
          get: function() {
            return H("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: n
            }), n;
          }
        }), _;
      }
      function Kt(n, _, A) {
        for (var L = Qe.apply(this, arguments), q = 2; q < arguments.length; q++)
          xt(arguments[q], L.type);
        return kt(L), L;
      }
      try {
        var Dt = Object.freeze({});
      } catch {
      }
      var Zt = Lt, Xt = Kt, Jt = Yt, Qt = {
        map: ge,
        forEach: xe,
        count: et,
        toArray: Fe,
        only: Ve
      };
      t.Children = Qt, t.Component = K, t.PureComponent = de, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = T, t.cloneElement = Xt, t.createContext = tt, t.createElement = Zt, t.createFactory = Jt, t.createRef = ye, t.forwardRef = I, t.isValidElement = Se, t.lazy = c, t.memo = O, t.useCallback = fe, t.useContext = B, t.useDebugValue = Ce, t.useEffect = J, t.useImperativeHandle = ne, t.useLayoutEffect = se, t.useMemo = ae, t.useReducer = M, t.useRef = j, t.useState = p, t.version = d;
    }();
  }(react_development)), react_development;
}
process.env.NODE_ENV === "production" ? react.exports = requireReact_production_min() : react.exports = requireReact_development();
var reactExports = react.exports;
const React = /* @__PURE__ */ getDefaultExportFromCjs(reactExports);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1, requireObjectAssign();
  var t = reactExports, e = 60103;
  if (reactJsxRuntime_production_min.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var d = Symbol.for;
    e = d("react.element"), reactJsxRuntime_production_min.Fragment = d("react.fragment");
  }
  var r = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function h(f, y, R) {
    var S, N = {}, C = null, z = null;
    R !== void 0 && (C = "" + R), y.key !== void 0 && (C = "" + y.key), y.ref !== void 0 && (z = y.ref);
    for (S in y)
      o.call(y, S) && !l.hasOwnProperty(S) && (N[S] = y[S]);
    if (f && f.defaultProps)
      for (S in y = f.defaultProps, y)
        N[S] === void 0 && (N[S] = y[S]);
    return { $$typeof: e, type: f, key: C, ref: z, props: N, _owner: r.current };
  }
  return reactJsxRuntime_production_min.jsx = h, reactJsxRuntime_production_min.jsxs = h, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      var e = reactExports, d = requireObjectAssign(), r = 60103, o = 60106;
      t.Fragment = 60107;
      var l = 60108, h = 60114, f = 60109, y = 60110, R = 60112, S = 60113, N = 60120, C = 60115, z = 60116, W = 60121, Y = 60122, P = 60117, F = 60129, Z = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var g = Symbol.for;
        r = g("react.element"), o = g("react.portal"), t.Fragment = g("react.fragment"), l = g("react.strict_mode"), h = g("react.profiler"), f = g("react.provider"), y = g("react.context"), R = g("react.forward_ref"), S = g("react.suspense"), N = g("react.suspense_list"), C = g("react.memo"), z = g("react.lazy"), W = g("react.block"), Y = g("react.server.block"), P = g("react.fundamental"), g("react.scope"), g("react.opaque.id"), F = g("react.debug_trace_mode"), g("react.offscreen"), Z = g("react.legacy_hidden");
      }
      var v = typeof Symbol == "function" && Symbol.iterator, $ = "@@iterator";
      function s(p) {
        if (p === null || typeof p != "object")
          return null;
        var M = v && p[v] || p[$];
        return typeof M == "function" ? M : null;
      }
      var u = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function m(p) {
        {
          for (var M = arguments.length, j = new Array(M > 1 ? M - 1 : 0), J = 1; J < M; J++)
            j[J - 1] = arguments[J];
          E("error", p, j);
        }
      }
      function E(p, M, j) {
        {
          var J = u.ReactDebugCurrentFrame, se = J.getStackAddendum();
          se !== "" && (M += "%s", j = j.concat([se]));
          var fe = j.map(function(ae) {
            return "" + ae;
          });
          fe.unshift("Warning: " + M), Function.prototype.apply.call(console[p], console, fe);
        }
      }
      var w = !1;
      function T(p) {
        return !!(typeof p == "string" || typeof p == "function" || p === t.Fragment || p === h || p === F || p === l || p === S || p === N || p === Z || w || typeof p == "object" && p !== null && (p.$$typeof === z || p.$$typeof === C || p.$$typeof === f || p.$$typeof === y || p.$$typeof === R || p.$$typeof === P || p.$$typeof === W || p[0] === Y));
      }
      function H(p, M, j) {
        var J = M.displayName || M.name || "";
        return p.displayName || (J !== "" ? j + "(" + J + ")" : j);
      }
      function V(p) {
        return p.displayName || "Context";
      }
      function X(p) {
        if (p == null)
          return null;
        if (typeof p.tag == "number" && m("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof p == "function")
          return p.displayName || p.name || null;
        if (typeof p == "string")
          return p;
        switch (p) {
          case t.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case h:
            return "Profiler";
          case l:
            return "StrictMode";
          case S:
            return "Suspense";
          case N:
            return "SuspenseList";
        }
        if (typeof p == "object")
          switch (p.$$typeof) {
            case y:
              var M = p;
              return V(M) + ".Consumer";
            case f:
              var j = p;
              return V(j._context) + ".Provider";
            case R:
              return H(p, p.render, "ForwardRef");
            case C:
              return X(p.type);
            case W:
              return X(p._render);
            case z: {
              var J = p, se = J._payload, fe = J._init;
              try {
                return X(fe(se));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var G = 0, ue, b, U, K, re, oe, ie;
      function le() {
      }
      le.__reactDisabledLog = !0;
      function de() {
        {
          if (G === 0) {
            ue = console.log, b = console.info, U = console.warn, K = console.error, re = console.group, oe = console.groupCollapsed, ie = console.groupEnd;
            var p = {
              configurable: !0,
              enumerable: !0,
              value: le,
              writable: !0
            };
            Object.defineProperties(console, {
              info: p,
              log: p,
              warn: p,
              error: p,
              group: p,
              groupCollapsed: p,
              groupEnd: p
            });
          }
          G++;
        }
      }
      function ce() {
        {
          if (G--, G === 0) {
            var p = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: d({}, p, {
                value: ue
              }),
              info: d({}, p, {
                value: b
              }),
              warn: d({}, p, {
                value: U
              }),
              error: d({}, p, {
                value: K
              }),
              group: d({}, p, {
                value: re
              }),
              groupCollapsed: d({}, p, {
                value: oe
              }),
              groupEnd: d({}, p, {
                value: ie
              })
            });
          }
          G < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var ye = u.ReactCurrentDispatcher, De;
      function ze(p, M, j) {
        {
          if (De === void 0)
            try {
              throw Error();
            } catch (se) {
              var J = se.stack.trim().match(/\n( *(at )?)/);
              De = J && J[1] || "";
            }
          return `
` + De + p;
        }
      }
      var be = !1, Ne;
      {
        var rt = typeof WeakMap == "function" ? WeakMap : Map;
        Ne = new rt();
      }
      function Ke(p, M) {
        if (!p || be)
          return "";
        {
          var j = Ne.get(p);
          if (j !== void 0)
            return j;
        }
        var J;
        be = !0;
        var se = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var fe;
        fe = ye.current, ye.current = null, de();
        try {
          if (M) {
            var ae = function() {
              throw Error();
            };
            if (Object.defineProperty(ae.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(ae, []);
              } catch (Le) {
                J = Le;
              }
              Reflect.construct(p, [], ae);
            } else {
              try {
                ae.call();
              } catch (Le) {
                J = Le;
              }
              p.call(ae.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Le) {
              J = Le;
            }
            p();
          }
        } catch (Le) {
          if (Le && J && typeof Le.stack == "string") {
            for (var ne = Le.stack.split(`
`), Ce = J.stack.split(`
`), $e = ne.length - 1, me = Ce.length - 1; $e >= 1 && me >= 0 && ne[$e] !== Ce[me]; )
              me--;
            for (; $e >= 1 && me >= 0; $e--, me--)
              if (ne[$e] !== Ce[me]) {
                if ($e !== 1 || me !== 1)
                  do
                    if ($e--, me--, me < 0 || ne[$e] !== Ce[me]) {
                      var ke = `
` + ne[$e].replace(" at new ", " at ");
                      return typeof p == "function" && Ne.set(p, ke), ke;
                    }
                  while ($e >= 1 && me >= 0);
                break;
              }
          }
        } finally {
          be = !1, ye.current = fe, ce(), Error.prepareStackTrace = se;
        }
        var We = p ? p.displayName || p.name : "", ut = We ? ze(We) : "";
        return typeof p == "function" && Ne.set(p, ut), ut;
      }
      function Ze(p, M, j) {
        return Ke(p, !1);
      }
      function Xe(p) {
        var M = p.prototype;
        return !!(M && M.isReactComponent);
      }
      function Ee(p, M, j) {
        if (p == null)
          return "";
        if (typeof p == "function")
          return Ke(p, Xe(p));
        if (typeof p == "string")
          return ze(p);
        switch (p) {
          case S:
            return ze("Suspense");
          case N:
            return ze("SuspenseList");
        }
        if (typeof p == "object")
          switch (p.$$typeof) {
            case R:
              return Ze(p.render);
            case C:
              return Ee(p.type, M, j);
            case W:
              return Ze(p._render);
            case z: {
              var J = p, se = J._payload, fe = J._init;
              try {
                return Ee(fe(se), M, j);
              } catch {
              }
            }
          }
        return "";
      }
      var qe = {}, Je = u.ReactDebugCurrentFrame;
      function Ge(p) {
        if (p) {
          var M = p._owner, j = Ee(p.type, p._source, M ? M.type : null);
          Je.setExtraStackFrame(j);
        } else
          Je.setExtraStackFrame(null);
      }
      function lt(p, M, j, J, se) {
        {
          var fe = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var ae in p)
            if (fe(p, ae)) {
              var ne = void 0;
              try {
                if (typeof p[ae] != "function") {
                  var Ce = Error((J || "React class") + ": " + j + " type `" + ae + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof p[ae] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Ce.name = "Invariant Violation", Ce;
                }
                ne = p[ae](M, ae, J, j, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch ($e) {
                ne = $e;
              }
              ne && !(ne instanceof Error) && (Ge(se), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", J || "React class", j, ae, typeof ne), Ge(null)), ne instanceof Error && !(ne.message in qe) && (qe[ne.message] = !0, Ge(se), m("Failed %s type: %s", j, ne.message), Ge(null));
            }
        }
      }
      var Te = u.ReactCurrentOwner, Ye = Object.prototype.hasOwnProperty, nt = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Qe, Se, Me;
      Me = {};
      function it(p) {
        if (Ye.call(p, "ref")) {
          var M = Object.getOwnPropertyDescriptor(p, "ref").get;
          if (M && M.isReactWarning)
            return !1;
        }
        return p.ref !== void 0;
      }
      function Be(p) {
        if (Ye.call(p, "key")) {
          var M = Object.getOwnPropertyDescriptor(p, "key").get;
          if (M && M.isReactWarning)
            return !1;
        }
        return p.key !== void 0;
      }
      function Ue(p, M) {
        if (typeof p.ref == "string" && Te.current && M && Te.current.stateNode !== M) {
          var j = X(Te.current.type);
          Me[j] || (m('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', X(Te.current.type), p.ref), Me[j] = !0);
        }
      }
      function ot(p, M) {
        {
          var j = function() {
            Qe || (Qe = !0, m("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", M));
          };
          j.isReactWarning = !0, Object.defineProperty(p, "key", {
            get: j,
            configurable: !0
          });
        }
      }
      function je(p, M) {
        {
          var j = function() {
            Se || (Se = !0, m("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", M));
          };
          j.isReactWarning = !0, Object.defineProperty(p, "ref", {
            get: j,
            configurable: !0
          });
        }
      }
      var He = function(p, M, j, J, se, fe, ae) {
        var ne = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: p,
          key: M,
          ref: j,
          props: ae,
          // Record the component responsible for creating this element.
          _owner: fe
        };
        return ne._store = {}, Object.defineProperty(ne._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(ne, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: J
        }), Object.defineProperty(ne, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: se
        }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
      };
      function Ae(p, M, j, J, se) {
        {
          var fe, ae = {}, ne = null, Ce = null;
          j !== void 0 && (ne = "" + j), Be(M) && (ne = "" + M.key), it(M) && (Ce = M.ref, Ue(M, se));
          for (fe in M)
            Ye.call(M, fe) && !nt.hasOwnProperty(fe) && (ae[fe] = M[fe]);
          if (p && p.defaultProps) {
            var $e = p.defaultProps;
            for (fe in $e)
              ae[fe] === void 0 && (ae[fe] = $e[fe]);
          }
          if (ne || Ce) {
            var me = typeof p == "function" ? p.displayName || p.name || "Unknown" : p;
            ne && ot(ae, me), Ce && je(ae, me);
          }
          return He(p, ne, Ce, se, J, Te.current, ae);
        }
      }
      var ge = u.ReactCurrentOwner, et = u.ReactDebugCurrentFrame;
      function xe(p) {
        if (p) {
          var M = p._owner, j = Ee(p.type, p._source, M ? M.type : null);
          et.setExtraStackFrame(j);
        } else
          et.setExtraStackFrame(null);
      }
      var Fe;
      Fe = !1;
      function Ve(p) {
        return typeof p == "object" && p !== null && p.$$typeof === r;
      }
      function tt() {
        {
          if (ge.current) {
            var p = X(ge.current.type);
            if (p)
              return `

Check the render method of \`` + p + "`.";
          }
          return "";
        }
      }
      function at(p) {
        {
          if (p !== void 0) {
            var M = p.fileName.replace(/^.*[\\\/]/, ""), j = p.lineNumber;
            return `

Check your code at ` + M + ":" + j + ".";
          }
          return "";
        }
      }
      var Pe = {};
      function dt(p) {
        {
          var M = tt();
          if (!M) {
            var j = typeof p == "string" ? p : p.displayName || p.name;
            j && (M = `

Check the top-level render call using <` + j + ">.");
          }
          return M;
        }
      }
      function we(p, M) {
        {
          if (!p._store || p._store.validated || p.key != null)
            return;
          p._store.validated = !0;
          var j = dt(M);
          if (Pe[j])
            return;
          Pe[j] = !0;
          var J = "";
          p && p._owner && p._owner !== ge.current && (J = " It was passed a child from " + X(p._owner.type) + "."), xe(p), m('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', j, J), xe(null);
        }
      }
      function a(p, M) {
        {
          if (typeof p != "object")
            return;
          if (Array.isArray(p))
            for (var j = 0; j < p.length; j++) {
              var J = p[j];
              Ve(J) && we(J, M);
            }
          else if (Ve(p))
            p._store && (p._store.validated = !0);
          else if (p) {
            var se = s(p);
            if (typeof se == "function" && se !== p.entries)
              for (var fe = se.call(p), ae; !(ae = fe.next()).done; )
                Ve(ae.value) && we(ae.value, M);
          }
        }
      }
      function c(p) {
        {
          var M = p.type;
          if (M == null || typeof M == "string")
            return;
          var j;
          if (typeof M == "function")
            j = M.propTypes;
          else if (typeof M == "object" && (M.$$typeof === R || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          M.$$typeof === C))
            j = M.propTypes;
          else
            return;
          if (j) {
            var J = X(M);
            lt(j, p.props, "prop", J, p);
          } else if (M.PropTypes !== void 0 && !Fe) {
            Fe = !0;
            var se = X(M);
            m("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", se || "Unknown");
          }
          typeof M.getDefaultProps == "function" && !M.getDefaultProps.isReactClassApproved && m("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function I(p) {
        {
          for (var M = Object.keys(p.props), j = 0; j < M.length; j++) {
            var J = M[j];
            if (J !== "children" && J !== "key") {
              xe(p), m("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", J), xe(null);
              break;
            }
          }
          p.ref !== null && (xe(p), m("Invalid attribute `ref` supplied to `React.Fragment`."), xe(null));
        }
      }
      function x(p, M, j, J, se, fe) {
        {
          var ae = T(p);
          if (!ae) {
            var ne = "";
            (p === void 0 || typeof p == "object" && p !== null && Object.keys(p).length === 0) && (ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Ce = at(se);
            Ce ? ne += Ce : ne += tt();
            var $e;
            p === null ? $e = "null" : Array.isArray(p) ? $e = "array" : p !== void 0 && p.$$typeof === r ? ($e = "<" + (X(p.type) || "Unknown") + " />", ne = " Did you accidentally export a JSX literal instead of a component?") : $e = typeof p, m("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", $e, ne);
          }
          var me = Ae(p, M, j, se, fe);
          if (me == null)
            return me;
          if (ae) {
            var ke = M.children;
            if (ke !== void 0)
              if (J)
                if (Array.isArray(ke)) {
                  for (var We = 0; We < ke.length; We++)
                    a(ke[We], p);
                  Object.freeze && Object.freeze(ke);
                } else
                  m("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                a(ke, p);
          }
          return p === t.Fragment ? I(me) : c(me), me;
        }
      }
      function D(p, M, j) {
        return x(p, M, j, !0);
      }
      function O(p, M, j) {
        return x(p, M, j, !1);
      }
      var k = O, B = D;
      t.jsx = k, t.jsxs = B;
    }();
  }(reactJsxRuntime_development)), reactJsxRuntime_development;
}
process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports;
const ezEditorIndex = "";
let ezViewerInstanceCounter = 0;
class EZEditorView extends React.Component {
  constructor() {
    super(...arguments), this.wrapperID = `ez-wrapper-content-${++ezViewerInstanceCounter}`, this.gotoStepAttribute = "goToCourseStep", this.wrapperDom = React.createRef();
  }
  componentDidMount() {
    if (this.wrapperDom.current != null) {
      const d = this.finalHtml();
      this.wrapperDom.current.innerHTML = d;
      var e = this.wrapperDom.current.querySelectorAll("script");
      this.buildScript(e, 0);
    }
    ezInitMain({
      holderSelector: "#" + this.wrapperID,
      baseUrl: this.props.baseUrl,
      clickActions: this.props.clickActions,
      contactId: this.props.currentUserId,
      userIsInFilter: this.props.userIsInFilter
    }), ezInitForms(this.props.formProps, () => {
      var d, r;
      return ((r = (d = this.props).currentUserId) == null ? void 0 : r.call(d)) != null;
    }), this.props.onCourseItemClick != null && document.querySelectorAll(`[${this.gotoStepAttribute}]`).forEach((d) => {
      d.addEventListener("click", () => {
        var o, l;
        const r = d.getAttribute(this.gotoStepAttribute);
        r && ((l = (o = this.props).onCourseItemClick) == null || l.call(o, r));
      });
    }), window[this.gotoStepAttribute] = this.props.onCourseItemClick;
  }
  finalHtml() {
    let e = this.props.html ?? "";
    const d = new RegExp('href="download:([^"]+)"', "g");
    if (e = e.replace(d, (r, o) => `href="${this.props.baseUrl}/file/download/${o}"`), this.props.onCourseItemClick != null) {
      const r = new RegExp('href="step:([^"]+)"', "g");
      e = e.replace(r, (o, l) => `${this.gotoStepAttribute}="${l}"`);
    }
    return e;
  }
  //this thing below is needed for script execution
  //need to do them in order load one after another.
  //e.g. load jquery and then using $(document).ready() in this case will work
  buildScript(e, d) {
    const r = e[d];
    if (!r)
      return !0;
    const o = document.createElement("script");
    Array.from(r.attributes).forEach((h) => o.setAttribute(h.name, h.value));
    const l = !o.hasAttribute("src");
    l || (o.onload = () => this.buildScript(e, d + 1)), o.appendChild(document.createTextNode(r.innerHTML)), r.parentNode && r.parentNode.replaceChild(o, r), l && this.buildScript(e, d + 1);
  }
  render() {
    const e = ["ez-wrapper", "live"];
    return this.props.noCopy && e.push("no-copy"), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("style", { children: this.props.style }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: this.wrapperDom, id: this.wrapperID, className: e.join(" "), style: this.props.wrapperStyle, children: " " })
    ] });
  }
}
export {
  CountryCookieName,
  EZCaptcha,
  EZEditorView,
  applyUrlParamToHiddenField,
  applyUrlParamToHiddenFields,
  buildPlayerEmbedCode,
  emulateClick,
  ezInitForms,
  ezInitMain,
  formatTimecode,
  getPlayerParam,
  getPlayerVideoIds,
  isInsideWidget,
  isOurPlayerEmbed,
  makeIframesLazy,
  onPlayerMessage,
  parseTimecode,
  parseVideoMomentSettings,
  resolveUrlParamValue,
  setPlayerParam,
  toVideoMomentSettings
};
//# sourceMappingURL=index.js.map
